/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import API_BASE_URL from "../../config/api";
import CompanyCell from "../Form/MwNowyHandling/CompanyCell";
import RecipientsCell, {
  parseRecipients,
} from "../Form/MwNowyHandling/RecipientsCell";
import {
  buildCompanyDict,
  normalizeCompany,
  ILOSC_PACZKI_FIELDS,
  ILOSC_PALETY_FIELDS,
  iloscGroupActive,
} from "../Form/MwNowyHandling/schema";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment-timezone";
import { jwtDecode } from "jwt-decode";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  CircularProgress,
  TextField,
  Button,
  MenuItem,
  Select,
  ListSubheader,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import Autocomplete from "@mui/material/Autocomplete";
import { createFilterOptions } from "@mui/material/Autocomplete";
//import EmailConversationTable from "./EmailConversationTable";
import {
  ExitToApp as ExitToAppIcon,
  ArrowBack as ArrowBackIcon,
  Info as InfoIcon,
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@mui/material/Tooltip";
import EmailSender from "./EmailSender";
import SplitTicketModal from "./SplitTicketModal";
import InvoiceEditorDialog from "./InvoiceEditorDialog";
import { checkSadExists } from "./functions";
import { usePageStyles } from "../common/pageStyles";

const drawerWidth = "10%";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    width: "100%",
    minWidth: 0,
    overflowX: "auto",
  },
  tableContainer: {
    minWidth: 700,
    maxHeight: "calc(100vh - 180px)",
    overflowY: "auto",
  },
  tableHeaderRow: {
    backgroundColor: "#e1f5fe",
    position: "sticky",
    top: 0,
    zIndex: 1,
    fontSize: "18px",
    fontWeight: 800,
  },
  tableHeaderLabel: {
    fontSize: "10px",
    fontWeight: "bold",
  },
  tableTitle: {
    textAlign: "center",
  },
  tableHeaderCell: {
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(10, 2),
    color: "#666",
  },
  editForm: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  inputField: {
    minWidth: "300px",
    maxWidth: "600px", // Dodaj ograniczenie szerokości
    width: "60%",
  },
  fieldList: {
    width: "100%", // Ustawienie szerokości na 100% ekranu
    maxWidth: "100%", // Zapobieganie rozciąganiu się poza ekran
    boxSizing: "border-box", // Uwzględnienie paddingu i bordera w szerokości
    // ... inne style, które mógłbyś mieć ...
  },
  fieldListItem: {
    marginRight: theme.spacing(2),
  },
  buttonsContainerTopLeft: {
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: theme.spacing(2),
  },
  komentarzeHeading: {
    marginTop: theme.spacing(2),
    fontSize: "30px",
    fontWeight: 450,
  },
  komentarzeBody: {
    fontSize: "18px",
    fontWeight: 300,
  },
  mailNotificationButton: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  // ---- Powiadomienia mailowe w komentarzach (kolory: przychodzący pomarańcz, wychodzący błękit) ----
  mailCard: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(1),
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
  },
  mailCardIncoming: {
    backgroundColor: "#fff8e1",
    border: "1px solid #ffe0b2",
    borderLeft: "6px solid #ff9800",
    "& $mailBadge": { backgroundColor: "#ff9800" },
  },
  mailCardOutgoing: {
    backgroundColor: "#e3f2fd",
    border: "1px solid #b3e5fc",
    borderLeft: "6px solid #03a9f4",
    "& $mailBadge": { backgroundColor: "#03a9f4" },
  },
  mailCardHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderBottom: "1px solid rgba(0,0,0,0.08)",
  },
  mailBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    padding: "4px 12px",
    borderRadius: 16,
    color: "#fff",
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: "0.2px",
  },
  mailCardFooter: {
    marginTop: theme.spacing(1),
    fontSize: 13,
    color: "#555",
  },
  link: {
    fontSize: "1.2rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  fieldBlocksContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    justifyContent: "center",
    width: "80%",
  },
  fieldBlock: {
    background: theme.palette.primary.main,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    cursor: "pointer",

    transition: "background 0.3s ease",
    "&:hover": {
      background: theme.palette.primary.dark,
    },
  },
  fieldLabel: {
    color: "#000",
    fontWeight: 500,
    textAlign: "center",
  },
  closeButton: {
    marginTop: theme.spacing(2),
  },
  formControlWidth: {
    width: "60%",
  },
  categoryRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start", // Wyrównanie do lewej strony
    flexWrap: "wrap", // Zapobieganie przewijaniu poprzez zawijanie elementów
    marginBottom: theme.spacing(2),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
      paddingBottom: theme.spacing(2),
    },
  },
  categoryHeading: {
    fontWeight: "bold",
    marginRight: theme.spacing(2),
  },
  fieldBlocksRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap", // Pozwala elementom przechodzić do nowej linii, jeśli nie mieszczą się
    gap: theme.spacing(1),
  },
  // eslint-disable-next-line no-dupe-keys
  fieldBlock: {
    padding: theme.spacing(1),
    // Pole bez wartości: jasnoszary chip z czarnym napisem.
    backgroundColor: "#e0e0e0",
    border: "1px solid #bdbdbd",
    borderRadius: theme.shape.borderRadius,
    cursor: "pointer",
    transition: "background-color 0.3s",
    "&:hover": {
      backgroundColor: "#cfcfcf",
    },
  },
  // Pole z poprawnie uzupelniona wartoscia (przeszlo walidacje) - zielony chip.
  fieldBlockValid: {
    backgroundColor: theme.palette.success.main,
    borderColor: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.dark,
    },
    // Zielony chip zachowuje biały napis.
    "& $fieldLabel": {
      color: theme.palette.common.white,
    },
  },
  // Pole zablokowane, dopoki nie uzupelniono "Towar celny".
  fieldBlockLocked: {
    backgroundColor: "#bdbdbd",
    cursor: "not-allowed",
    opacity: 0.75,
    "&:hover": {
      backgroundColor: "#bdbdbd",
    },
  },

  // ---- Podglad "Magazyn Warszawa - Nowy Handling" (uklad 2-kolumnowy) ----
  nhStatusBar: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "baseline",
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
    background: "#e3f2fd",
    borderLeft: "5px solid #1976d2",
    borderRadius: 6,
  },
  nhStatusLabel: {
    fontSize: 14,
    fontWeight: 600,
    color: "#555",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  nhStatusValue: {
    fontSize: 20,
    fontWeight: 700,
    color: "#0d47a1",
  },
  nhSummaryWrap: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    gap: theme.spacing(3),
  },
  nhSummaryCol: {
    flex: "1 1 340px",
    minWidth: 280,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  nhCard: {
    background: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: 8,
    padding: theme.spacing(2),
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  },
  nhCardTitle: {
    fontSize: 20,
    fontWeight: 800,
    color: "#1976d2",
    borderBottom: "2px solid #1976d2",
    paddingBottom: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
  nhRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    gap: theme.spacing(2),
    padding: theme.spacing(0.75, 0),
    borderBottom: "1px solid #f0f0f0",
    fontSize: 15,
    "&:last-child": { borderBottom: "none" },
  },
  nhRowLabel: {
    color: "#666",
    fontWeight: 600,
    flexShrink: 0,
  },
  nhRowValue: {
    color: "#212121",
    textAlign: "right",
    wordBreak: "break-word",
  },
  nhRowValueEmpty: {
    color: "#bbb",
  },
  nhMeta: {
    marginTop: theme.spacing(2),
    fontSize: 13,
    color: "#777",
  },
  nhReleaseWrap: {
    marginTop: theme.spacing(1.5),
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.spacing(0.5),
  },
  nhReleaseHint: {
    fontSize: 12,
    color: "#777",
  },

  // ---- Sekcja znaczników (chipy) ----
  // Wyraźnie oddzielona sekcja "Znaczniki" od danych wyświetlanych powyżej.
  ckSection: {
    marginTop: theme.spacing(5),
    paddingTop: theme.spacing(3),
    borderTop: "4px solid #e3f2fd",
  },
  ckSectionHeader: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1, 2),
    fontSize: 24,
    fontWeight: 800,
    color: "#0d47a1",
    background: "#e3f2fd",
    borderLeft: "5px solid #1976d2",
    borderRadius: 6,
  },
  // Dwie kolumny kart obok siebie (układ "murarski"); na wąskim ekranie jedna.
  ckGrid: {
    columnCount: 2,
    columnGap: theme.spacing(2),
    "@media (max-width: 900px)": {
      columnCount: 1,
    },
  },
  ckCard: {
    breakInside: "avoid",
    background: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: 8,
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
    marginBottom: theme.spacing(2),
  },
  ckCardHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    width: "100%",
    padding: theme.spacing(1.25, 2),
    background: "transparent",
    border: "none",
    borderBottom: "2px solid #1976d2",
    cursor: "pointer",
    textAlign: "left",
  },
  ckCardTitle: {
    flex: 1,
    fontSize: 18,
    fontWeight: 800,
    color: "#1976d2",
  },
  ckCount: {
    minWidth: 24,
    padding: "2px 8px",
    borderRadius: 12,
    background: "#2e7d32",
    color: "#fff",
    fontSize: 13,
    fontWeight: 700,
    textAlign: "center",
  },
  ckArrow: {
    color: "#1976d2",
    fontSize: 16,
  },
  ckCardBody: {
    padding: theme.spacing(1.5, 2, 2),
  },
  ckSubTitle: {
    margin: theme.spacing(1, 0, 0.5),
    fontSize: 13,
    fontWeight: 600,
    color: "#666",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  ckChips: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  ckChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.75, 1.5),
    border: "1px solid #bdbdbd",
    borderRadius: 18,
    background: "#f5f5f5",
    color: "#424242",
    fontSize: 14,
    cursor: "pointer",
    userSelect: "none",
    transition: "background-color 0.2s, border-color 0.2s",
    "&:hover": {
      background: "#eeeeee",
      borderColor: "#9e9e9e",
    },
    "&:focus-within": {
      outline: "2px solid #1976d2",
      outlineOffset: 2,
    },
  },
  ckChipChecked: {
    background: theme.palette.success.main,
    borderColor: theme.palette.success.main,
    color: "#fff",
    fontWeight: 600,
    "&:hover": {
      background: theme.palette.success.dark,
      borderColor: theme.palette.success.dark,
    },
  },
  ckChipUrgent: {
    background: "#d32f2f",
    borderColor: "#d32f2f",
    color: "#fff",
    fontWeight: 700,
    "&:hover": {
      background: "#b71c1c",
      borderColor: "#b71c1c",
    },
  },
  ckChipDisabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    "&:hover": {
      background: "#f5f5f5",
      borderColor: "#bdbdbd",
    },
  },
  // Ukryty wizualnie, ale nadal fokusowalny natywny checkbox.
  ckInput: {
    position: "absolute",
    opacity: 0,
    width: 0,
    height: 0,
    margin: 0,
  },
  ckActionBar: {
    position: "sticky",
    bottom: 0,
    zIndex: 2,
    padding: theme.spacing(1.5, 2),
    background: "#fff",
    borderTop: "1px solid #e0e0e0",
    boxShadow: "0 -2px 6px rgba(0,0,0,0.08)",
  },
  // Przycisk zapisu w pasku akcji: zaokrąglony, bez wersalików, na całą szerokość.
  ckSaveButton: {
    "&&": {
      width: "100%",
      padding: theme.spacing(1.25, 3),
      borderRadius: 24,
      fontSize: 16,
      fontWeight: 700,
      textTransform: "none",
      letterSpacing: 0.3,
      background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
      color: "#fff",
      boxShadow: "0 3px 8px rgba(25,118,210,0.35)",
      transition: "box-shadow 0.2s, transform 0.1s",
    },
    "&&:hover": {
      boxShadow: "0 5px 12px rgba(25,118,210,0.45)",
      background: "linear-gradient(135deg, #1e88e5 0%, #1565c0 100%)",
    },
    "&&:active": {
      transform: "translateY(1px)",
    },
  },
  // ---- Formularz dodawania komentarza ----
  cmCard: {
    background: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: 8,
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  },
  cmTitle: {
    fontSize: 20,
    fontWeight: 800,
    color: "#1976d2",
    borderBottom: "2px solid #1976d2",
    paddingBottom: theme.spacing(0.5),
    marginBottom: theme.spacing(1.5),
  },
  cmInfo: {
    padding: theme.spacing(1, 1.5),
    marginBottom: theme.spacing(2),
    background: "#e3f2fd",
    borderLeft: "4px solid #1976d2",
    borderRadius: 4,
    fontSize: 14,
    color: "#0d47a1",
  },
  cmLabel: {
    display: "block",
    marginBottom: theme.spacing(0.5),
    fontSize: 13,
    fontWeight: 600,
    color: "#666",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  cmLabelRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    "& > span": { marginBottom: 0 },
  },
  cmTextarea: {
    width: "100%",
    boxSizing: "border-box",
    padding: theme.spacing(1.25, 1.5),
    border: "1px solid #bdbdbd",
    borderRadius: 6,
    fontFamily: "inherit",
    fontSize: 15,
    // Tylko w pionie i w ograniczonym zakresie - nie da się rozciągnąć na całą stronę.
    resize: "vertical",
    minHeight: 100,
    maxHeight: 240,
    outline: "none",
    transition: "border-color 0.2s, box-shadow 0.2s",
    "&:focus": {
      borderColor: "#1976d2",
      boxShadow: "0 0 0 3px rgba(25,118,210,0.18)",
    },
  },
  cmFooter: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(1),
  },

  // ---- Lista komentarzy (zwykłe komentarze) ----
  ccItem: {
    background: "#fff",
    border: "1px solid #e0e0e0",
    borderLeft: "4px solid #9e9e9e",
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(1),
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  },
  ccHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderBottom: "1px solid #f0f0f0",
  },
  ccAvatar: {
    flexShrink: 0,
    width: 34,
    height: 34,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: 16,
    fontWeight: 700,
  },
  ccAuthor: {
    fontSize: 16,
    fontWeight: 700,
    color: "#212121",
  },
  ccDate: {
    marginLeft: "auto",
    fontSize: 13,
    color: "#777",
    whiteSpace: "nowrap",
  },
  ccText: {
    fontSize: 16,
    lineHeight: 1.5,
    color: "#212121",
    whiteSpace: "pre-line",
    overflowWrap: "anywhere",
  },
}));

const BASE_URL = API_BASE_URL;

const headers = {
  "Content-Type": "application/json",
  // Getter: token czytany przy każdym żądaniu, a nie raz przy ładowaniu skryptu
  // (inaczej po zalogowaniu bez odświeżenia strony wysyłany byłby stary/pusty token).
  get Authorization() {
    return `Bearer ${localStorage.getItem("token")}`;
  },
};
const fieldLabels = {
  nrRef: "nr Referencyjny",
  importer: "Importer",
  eksporter: "Eksporter",
  nrFaktury: "nr Faktury",
  nr_ref_gwaranta: "nr Ref Gwaranta",
  dokPrzedPrzybyciem: "Dokumenty przed przybyciem",
  osobaWeryfikujacaOdprawe: "Osoba weryfikująca odprawe",
  osobaWysylajacaOdprawe: "Osoba wysyłająca odprawe",
  osobaPrzygotowujacaOdprawe: "Osoba przygotowujaca odprawe",
  osobaMonitorujacaOdprawe: "Osoba monitorująca odprawe",
  nrRejestracyjnyPojazdyKurier: "nr Rejestracyjny pojazdu/kuriera",
  lokalizacjaTowaru: "Lokalizacja towaru",
  SAD: "SAD",
  MRN: "MRN",
  Rewizja: "Rewizja",
  statusRealizacji: "Status realizacji",
  rodzaj: "Rodzaj odprawy",
  pliki: "Ścieżka do plików",
  rodzajTransportu: "Rodzaj Transportu",
  data: "Data wygaśnięcia T1",
  adresatDokumentow: "Adresat dokumentów",
  waga_netto: "Waga Netto",
  waga_brutto: "Waga Brutto",
  waluta: "Waluta",
  gwarant: "Gwarant",
  urzad_tranzytowy: "Przewidywany urząd tranzytowy",
  urzad_przeznaczenia: "Urząd celny przeznaczenia",
  nrPojazdu: "nr Pojazdu",
  emailKorespondencyjny: "Email korespondencyjny",
  nota_ksiegowa: "Nota księgowa",
  nr_LRN: "nr LRN",
  kwota_gwarancji: "Kwota gwarancji w PLN",
  data_ie: "Data zakończenia tranzytu",
  nrTranzytu: "Nr tranzytu",
  numerListu: "Numer listu przewozowego",
  nadawca: "Nazwa firmy (nadawca)",
  liczbaPaczek: "Liczba paczek",
  liczbaPalet: "Liczba palet",
  iloscPozycjiSAD: "Ilość pozycji SAD",
  bladDokumentacji: "Błąd dokumentacji",
  rodzajBledu: "Rodzaj błędu",
  zwrot: "Zwrot",
  powod: "Powód zwrotu",
  wniosek: "Wniosek",
  kierunek: "Kierunek",
  serwisLotniczy: "Serwis lotniczy",
  przyjazdAuta: "Przyjazd auta",
  startSkanowania: "Start skanowania",
  zakonczenieSkanowania: "Zakończenie skanowania",
  iloscDeklPaczek: "Ilość dekl. paczek",
  iloscDeklPalet: "Ilość dekl. palet",
  iloscFaktPaczek: "Ilość fakt. paczek",
  iloscFaktPalet: "Ilość fakt. palet",
  problemZPrzesylka: "Problem z przesyłką",
  towarCelny: "Towar celny",
  podjazdAuta: "Podjazd auta",
  wyjazdAuta: "Godzina wyjazdu auta",
};

const categories = {
  "Informacje Podstawowe": [
    "statusRealizacji",
    "nrRef",
    "importer",
    "eksporter",
    "nrFaktury",
    "rodzajTransportu",
    "dokPrzedPrzybyciem",
    "lokalizacjaTowaru",
    "adresatDokumentow",
    "emailKorespondencyjny",
    "rodzaj",
    "nota_ksiegowa",
  ],
  "Szczegóły Odprawy": [
    "osobaWeryfikujacaOdprawe",
    "osobaWysylajacaOdprawe",
    "osobaPrzygotowujacaOdprawe",
    "osobaMonitorujacaOdprawe",
    "nrTranzytu",
    "Rewizja",
  ],
  "Transport i Lokalizacja": [
    "nrRejestracyjnyPojazdyKurier",
    "lokalizacjaTowaru",
    "nrPojazdu",
  ],
  "Dokumentacja i Pliki": ["SAD", "MRN", "pliki"],
  "Szczegóły Finansowe i Tranzytu": [
    "waga_netto",
    "waga_brutto",
    "waluta",
    "gwarant",
    "urzad_tranzytowy",
    "urzad_przeznaczenia",
    "nr_LRN",
    "kwota_gwarancji",
    "data_ie",
    "nr_ref_gwaranta",
  ],
  "Daty i Terminy": ["data"],
  "Magazyn Warszawa": [
    "statusRealizacji",
    "numerListu",
    "nadawca",
    "liczbaPaczek",
    "liczbaPalet",
    "MRN",
    "iloscPozycjiSAD",
    "Rewizja",
    "pliki",
    "kierunek",
    "serwisLotniczy",
  ],
  "Magazyn Warszawa Zwroty i Błędy": [
    "createdBy",
    "numerListu",
    "liczbaPaczek",
    "bladDokumentacji",
    "rodzajBledu",
    "zwrot",
    "powod",
    "wniosek",
    "nadawca",
  ],
  "Magazyn Warszawa Handling": [
    "createdBy",
    "numerListu",
    "nadawca",
    "liczbaPaczek",
    "liczbaPalet",
    "kierunek",
  ],
  Przyjęcie: ["przyjazdAuta", "numerListu", "nadawca", "startSkanowania"],
  // "Towar celny" jako pierwsze - pozostale pola sekcji sa zablokowane, dopoki
  // nie zostanie uzupelnione.
  Obsługa: [
    "towarCelny",
    "kierunek",
    "iloscDeklPaczek",
    "iloscDeklPalet",
    "iloscFaktPaczek",
    "iloscFaktPalet",
    "problemZPrzesylka",
    "zakonczenieSkanowania",
  ],
  "Odprawa celna": [
    "osobaPrzygotowujacaOdprawe",
    "MRN",
    "iloscPozycjiSAD",
    "Rewizja",
    "serwisLotniczy",
  ],
  "Wydanie towaru": ["podjazdAuta", "wyjazdAuta"],
};

// Komunikat tooltipa dla pol zablokowanych brakiem "Towar celny".
const TOWAR_CELNY_LOCK_HINT =
  'Pole zablokowane. Uzupełnij najpierw pole „Towar celny" (pierwsze w sekcji Obsługa), aby odblokować pozostałe pola tej sekcji.';

const NH_OBSLUGA_FIELDS = [
  "towarCelny",
  "kierunek",
  "iloscDeklPaczek",
  "iloscDeklPalet",
  "iloscFaktPaczek",
  "iloscFaktPalet",
  "problemZPrzesylka",
  "zakonczenieSkanowania",
];
const NH_ODPRAWA_CELNA_FIELDS = [
  "osobaPrzygotowujacaOdprawe",
  "MRN",
  "iloscPozycjiSAD",
  "Rewizja",
  "serwisLotniczy",
];

const nhFilled = (row, f) => String(row?.[f] ?? "").trim() !== "";

// Paczki vs palety: przesylka jest ALBO w paczkach ALBO na paletach. Gdy jedna
// grupa ma wartosc > 0, pola drugiej sa zablokowane (i przy zapisie zerowane).
const iloscPaczkiActive = (row) =>
  iloscGroupActive(ILOSC_PACZKI_FIELDS.map((f) => row?.[f]));
const iloscPaletyActive = (row) =>
  iloscGroupActive(ILOSC_PALETY_FIELDS.map((f) => row?.[f]));
const ILOSC_PACZKI_LOCK_HINT =
  'Pole zablokowane. Przesyłka jest liczona w paczkach — pola palet są zerowane. Wyzeruj „Ilość dekl./fakt. paczek", aby edytować palety.';
const ILOSC_PALETY_LOCK_HINT =
  'Pole zablokowane. Przesyłka jest liczona w paletach — pola paczek są zerowane. Wyzeruj „Ilość dekl./fakt. palet", aby edytować paczki.';
const KIERUNEK_SERWIS_LOTNICZY_LOCK_HINT =
  'Pole zablokowane. „Serwis lotniczy" = Tak — kierunek nie jest wymagany. Ustaw „Serwis lotniczy" na Nie, aby edytować kierunek.';

const nhObslugaComplete = (row) =>
  !!row &&
  NH_OBSLUGA_FIELDS.every((f) => {
    // "Serwis lotniczy" = Tak -> "Kierunek" nie jest wymagany.
    if (
      f === "kierunek" &&
      String(row?.serwisLotniczy ?? "").trim() === "Tak"
    ) {
      return true;
    }
    return nhFilled(row, f);
  });
const nhOdprawaCelnaComplete = (row) =>
  !!row && NH_ODPRAWA_CELNA_FIELDS.every((f) => nhFilled(row, f));

// "Podjazd auta": wystarczy uzupelniona sekcja "Obsługa". Gdy "Towar celny" = Tak
// i "Odprawa celna" jeszcze niekompletna - podjazd i tak mozna wpisac.
const isPodjazdAutaUnlocked = (row) => nhObslugaComplete(row);

// "Godzina wyjazdu auta": edytowalne dopiero gdy rekord dojdzie do etapu wydania -
// status "Towar do wydania" (po wpisaniu "Podjazd auta" albo po kliknieciu
// "Przekaż towar do wydania") oraz nadal po zapisaniu godziny (status
// "Zrealizowano"), zeby dalo sie poprawic pomylke. Wczesniej zablokowane - dzieki
// temu "Towar do wydania" nie da sie pominac.
const isWyjazdAutaUnlocked = (row) =>
  ["Towar do wydania", "Zrealizowano"].includes(row?.statusRealizacji) &&
  nhFilled(row, "podjazdAuta");

// Przycisk "Przekaż towar do wydania": widoczny w sekcji "Wydanie towaru", gdy
// odprawa celna jest zamknieta (status "Oclono"), a auto juz stoi pod magazynem.
const canReleaseNhGoods = (row) =>
  row?.towarCelny === "Tak" &&
  row?.statusRealizacji === "Oclono" &&
  nhFilled(row, "podjazdAuta");

const PODJAZD_AUTA_LOCK_HINT =
  'Pole zablokowane. Uzupełnij wszystkie pola sekcji „Obsługa", aby móc wpisać „Podjazd auta".';

const WYDANIE_TOWARU_LOCK_HINT =
  'Pole zablokowane. Uzupełnij wszystkie pola sekcji „Obsługa", a gdy „Towar celny" = Tak — także wszystkie pola sekcji „Odprawa celna".';

const WYJAZD_AUTA_LOCK_HINT =
  'Pole zablokowane. Najpierw uzupełnij „Podjazd auta", aby odblokować „Godzina wyjazdu auta".';

const WYJAZD_AUTA_RELEASE_HINT =
  'Pole zablokowane. Odprawa celna jest zamknięta (status „Oclono") — kliknij „Przekaż towar do wydania" w sekcji „Wydanie towaru", aby przejść do statusu „Towar do wydania".';

// Godziny "Nowy Handling" trzymamy jako tekst "HH:MM" (24h, zero-padded) - taki
// format zwraca <input type="time"> i porzadek leksykalny jest chronologiczny.
// Zwraca true, gdy a >= b, albo gdy którakolwiek wartość jest pusta (brak ograniczenia).
const timeGte = (a, b) => {
  const x = String(a ?? "").trim();
  const y = String(b ?? "").trim();
  if (!x || !y) return true;
  return x >= y;
};

const HHMM_RE = /^([01]\d|2[0-3]):[0-5]\d$/;
const NH_DATETIME_RE = /^\d{4}-\d{2}-\d{2} ([01]\d|2[0-3]):[0-5]\d$/;
const NH_KIERUNEK_OPTIONS = ["GB", "CH", "NO", "BA", "RS", "Lotniczy"];

// "Wydanie towaru": w bazie trzymamy "YYYY-MM-DD HH:mm". W polu edycji uzytkownik
// wpisuje sama godzine - wyciagamy koncowe "HH:mm" z dowolnego formatu.
const nhTimePart = (value) => {
  const m = String(value ?? "").match(/(\d{2}:\d{2})(?::\d{2})?$/);
  return m ? m[1] : "";
};

// "HH:mm" -> "YYYY-MM-DD HH:mm" (data = dzis). Wartosc juz z data zostaje bez zmian.
const nhDateStamp = (value) => {
  const v = String(value ?? "").trim();
  if (!v) return v;
  if (HHMM_RE.test(v)) {
    return `${moment().tz("Europe/Warsaw").format("YYYY-MM-DD")} ${v}`;
  }
  return v;
};

// Podglad inline w polu "Godzina wyjazdu auta": czy wpisana godzina jest wczesniejsza
// niz "Podjazd auta". Porownanie po samej godzinie (obie wartosci sa z tego samego dnia).
const wyjazdBeforePodjazd = (editedData, rowData) => {
  const wyjazd = nhTimePart(
    editedData?.wyjazdAuta ?? rowData?.wyjazdAuta ?? "",
  );
  const podjazd = nhTimePart(rowData?.podjazdAuta ?? "");
  return !!wyjazd && !!podjazd && wyjazd < podjazd;
};

// Czy pole "Nowy Handling" ma juz poprawnie uzupelniona wartosc (przeszlo walidacje) -
// wtedy chip w liscie "Wybierz pole do edycji" jest zielony zamiast niebieskiego.
const isNowyHandlingFieldValid = (field, row, companyDict) => {
  const v = String(row?.[field] ?? "").trim();
  if (!v) return false;
  switch (field) {
    case "przyjazdAuta":
      return HHMM_RE.test(v) && timeGte(row?.startSkanowania, v);
    case "startSkanowania":
      return HHMM_RE.test(v) && timeGte(v, row?.przyjazdAuta);
    case "zakonczenieSkanowania":
      return HHMM_RE.test(v) && timeGte(v, row?.startSkanowania);
    case "numerListu":
      return v.length === 14;
    case "nadawca":
      return (
        !!companyDict &&
        companyDict.size > 0 &&
        companyDict.has(normalizeCompany(v))
      );
    case "problemZPrzesylka":
    case "towarCelny":
    case "Rewizja":
    case "serwisLotniczy":
      return v === "Tak" || v === "Nie";
    case "kierunek":
      return NH_KIERUNEK_OPTIONS.includes(v);
    case "iloscDeklPaczek":
    case "iloscDeklPalet":
    case "iloscFaktPaczek":
    case "iloscFaktPalet":
    case "iloscPozycjiSAD":
      return /^\d+$/.test(v) && Number(v) >= 0;
    case "MRN":
      return /^(2[5-9]|[3-9][0-9])PL[A-Z0-9]{14,16}$/.test(v);
    case "podjazdAuta":
    case "wyjazdAuta":
      return NH_DATETIME_RE.test(v) || HHMM_RE.test(v);
    default:
      return true;
  }
};

// Czy pole "Zwroty i Błędy" jest uzupelnione - prosty check "niepuste = zielony"
// (bez walidacji formatu jak przy Nowym Handlingu - tu wystarcza sam fakt wypelnienia).
const isZwrotyIBledyFieldValid = (field, row) =>
  String(row?.[field] ?? "").trim() !== "";

// Godzina "Nowy Handling" -> zawsze "HH:mm" (paduje "8:5" -> "08:05", ucina ":ss").
// Wartosci spoza wzorca zostawiamy bez zmian.
const formatHHmm = (value) => {
  const s = String(value ?? "").trim();
  const m = s.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
  return m ? `${m[1].padStart(2, "0")}:${m[2]}` : s;
};

// "Nowy Handling": godzina (tylko HH:mm w bazie) + data z rekordu -> "HH:mm, DD-MM-YYYY".
const nhDateTime = (dateSource, timeValue) => {
  const time = formatHHmm(timeValue);
  if (!time) return "";
  const date = dateSource
    ? moment(dateSource).tz("Europe/Warsaw").format("DD-MM-YYYY")
    : "";
  return date ? `${time}, ${date}` : time;
};

// Podglad "Nowy Handling" - wiersz "etykieta: wartosc" w karcie sekcji.
const nhIsEmpty = (value) =>
  value === null || value === undefined || value === "";

const renderNhRow = (classes, label, value) => (
  <div key={label} className={classes.nhRow}>
    <span className={classes.nhRowLabel}>{label}</span>
    <span
      className={
        nhIsEmpty(value)
          ? `${classes.nhRowValue} ${classes.nhRowValueEmpty}`
          : classes.nhRowValue
      }
    >
      {nhIsEmpty(value) ? "—" : value}
    </span>
  </div>
);

const FolderPathAction = ({ nrRef, path }) => {
  const [isOpening, setIsOpening] = useState(false);

  if (!path) {
    return <>{path}</>;
  }

  const handleOpenFolder = async () => {
    if (!nrRef || isOpening) return;
    setIsOpening(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${BASE_URL}/folders/${encodeURIComponent(nrRef)}/open`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      window.location.href = response.data.uri;
    } catch (error) {
      console.error("Error opening folder:", error);
      const status = error.response?.status;
      if (status === 401) {
        toast.error("Sesja wygasła. Zaloguj się ponownie.");
      } else if (status === 403) {
        toast.error("Brak uprawnień do otwarcia tego folderu.");
      } else if (status === 404) {
        toast.error("Nie znaleziono folderu dla tego zgłoszenia.");
      } else if (status === 400) {
        toast.error("Nieprawidłowy numer referencyjny zgłoszenia.");
      } else {
        toast.error("Nie udało się otworzyć folderu. Spróbuj ponownie.");
      }
    } finally {
      setIsOpening(false);
    }
  };

  const handleCopyPath = async () => {
    try {
      await navigator.clipboard.writeText(path);
      toast.success("Skopiowano ścieżkę do schowka.", { autoClose: 1500 });
    } catch (error) {
      console.error("Error copying path:", error);
      toast.error("Nie udało się skopiować ścieżki.");
    }
  };

  return (
    <>
      <Tooltip title="Otwórz folder (wymaga lokalnego helpera na komputerze)">
        <span
          onClick={handleOpenFolder}
          style={{
            cursor: isOpening ? "wait" : "pointer",
            color: "#1976d2",
            textDecoration: "underline",
            opacity: isOpening ? 0.6 : 1,
          }}
        >
          {path}
        </span>
      </Tooltip>
      <Button
        size="small"
        onClick={handleCopyPath}
        style={{ marginLeft: 8, textTransform: "none" }}
      >
        Kopiuj ścieżkę
      </Button>
    </>
  );
};

const importTypes = [
  "Import",
  "Import - wpis do rejestru",
  "Symulacja sad",
  "Wprowadzenie na skład",
  "Uszlachetnianie czynne",
  "Powrotny przywóz",
  "Odprawa czasowa import",
];

const exportTypes = [
  "Eksport",
  "Wyprowadzenie ze składu",
  "Uszlachetnianie bierne",
  "Powrotny wywóz",
  "Eksport - wpis do rejestru",
  "Eksport PL i import inny kraj",
  "Odprawa czasowa eksport",
];

const CommentSection = ({
  id,
  rowData,
  onDataRefresh,
  emailRefreshToken = 0,
}) => {
  const classes = useStyles();
  const [ckCollapsed, setCkCollapsed] = useState({});
  const [comment, setComment] = useState("");
  const [showCommentPrompt, setShowCommentPrompt] = useState(false);
  const [fakturaBox, setFakturaBox] = useState(false);
  const [brakCertyfikatyBox, setBrakCertyfikatyBox] = useState(false);
  const [DSKBox, setDSKBox] = useState(false);
  const [brakEksportZKrajuWywozuBox, setBrakEksportZKrajuWywozuBox] =
    useState(false);
  const [brakExcelBox, setBrakExcelBox] = useState(false);
  const [listPrzewozowyBox, setListPrzewozowyBox] = useState(false);
  const [kosztyTransportuBox, setKosztyTransportuBox] = useState(false);
  const [informacjeOTowarzeBox, setInformacjeOTowarzeBox] = useState(false);
  const [T1Box, setT1Box] = useState(false);
  const [swiadectwoBox, setSwiadectwoBox] = useState(false);
  const [plikiBox, setPlikiBox] = useState(false);
  const [sankcjeBox, setSankcjeBox] = useState(false);
  const [CBAMBox, setCBAMBox] = useState(false);
  const [CEBox, setCEBox] = useState(false);

  const [wagaMailBox, setwagaMailBox] = useState(false);
  const [wagaTabelaBox, setwagaTabelaBox] = useState(false);
  const [wagaPropBox, setwagaPropBox] = useState(false);
  const [wagaDokBox, setwagaDokpBox] = useState(false);

  const [kilkaRazyBox, setKilkaRazyBox] = useState(false);
  const [wiecejNiz3Box, setWiecejNiz3Box] = useState(false);
  const [odprawaPo16Box, setOdprawaPo16Box] = useState(false);
  const [zglosBladBox, setZglosBladBox] = useState(false);

  const [brakUpowaznieniaBox, setBrakUpowaznieniaBox] = useState(false);
  const [eoriBox, setEoriBox] = useState(false);
  const [oczekiwanieNaPlatnoscBox, setOczekiwanieNaPlatnoscBox] =
    useState(false);
  const [ponownyMailOBrakiBox, setPonownyMailOBrakiBox] = useState(false);
  const previousPonownyMailRef = useRef(ponownyMailOBrakiBox);
  const [brakFakturyEdytowalnejBox, setBrakFakturyEdytowalnejBox] =
    useState(false);
  const [brakPackingListEdytowalnegoBox, setBrakPackingListEdytowalnegoBox] =
    useState(false);
  const [brakIncotermsBox, setBrakIncotermsBox] = useState(false);
  const [onwozBox, setOnwozBox] = useState(false);
  const [oczekiwanieRozladunekBox, setOczekiwanieRozladunekBox] =
    useState(false);
  const [brakInneBox, setBrakInneBox] = useState(false);
  const [brakInne, setBrakInne] = useState("");
  const [pilneBox, setPilneBox] = useState(false);
  const [ATRBox, setATRBox] = useState(false);
  const [EURBox, setEURBox] = useState(false);
  const [T2LBox, setT2LBox] = useState(false);
  const [RPSBox, setRPSBox] = useState(false);
  const [probZabBox, setProbZabBox] = useState(false);
  const [dataOdebraniaDokumentowBox, setDataOdebraniaDokumentowBox] =
    useState(false);
  const [dataOdebraniaDokumentow, setDataOdebraniaDokumentow] = useState("");
  const [WIJHARSBox, setWIJHARSBox] = useState(false);
  const [SingleWindowBox, setSingleWindowBox] = useState(false);
  const [ObecnoscPracownikaBox, setObecnoscPracownikaBox] = useState(false);
  const [COOBox, setCOOBox] = useState(false);
  const [WysylkaDokumentowBox, setWysylkaDokumentowBox] = useState(false);
  const [SanepidBox, setSanepidBox] = useState(false);

  const [userCheckedOznaczUwagi, setUserCheckedOznaczUwagi] = useState(false);

  // Stan do przechowywania oryginalnych wartości z bazy
  const [originalCheckboxValues, setOriginalCheckboxValues] = useState({});

  // Stan dla checkboxa "Zgłoś błąd" - ma osobną logikę
  const [showErrorReportPrompt, setShowErrorReportPrompt] = useState(false);
  const [errorReportMessage, setErrorReportMessage] = useState("");

  const [emailData, setEmailData] = useState([]);
  const [additionalRecipients, setAdditionalRecipients] = useState([]);
  const [recipientsError, setRecipientsError] = useState("");
  const [validLoginsList, setValidLoginsList] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const autocompleteRef = useRef(null);
  const { nrRef } = useParams();
  const [currentUsername, setCurrentUsername] = useState("");

  // Lista użytkowników uprawnionych do zgłaszania błędów
  const allowedErrorReportUsers = [
    "adobrowolska",
    "bbrus",
    "dczernikowska",
    "aszkutnik",
    "pmunik",
    "pnowak",
    "plomza",
    "Maciej",
    "igor-tester",
    "pmichalska",
  ];

  // Filtrowanie opcji - wyszukiwanie od początku tekstu
  const filterOptions = createFilterOptions({
    matchFrom: "start",
    stringify: (option) => option,
  });

  const getCurrentDateTimeLocal = () =>
    moment.tz("Europe/Warsaw").format("YYYY-MM-DDTHH:mm");

  const toDateTimeLocalValue = (dateTimeValue) => {
    if (!dateTimeValue) {
      return "";
    }

    const parsed = moment.tz(
      dateTimeValue,
      ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DDTHH:mm"],
      "Europe/Warsaw",
    );

    return parsed.isValid() ? parsed.format("YYYY-MM-DDTHH:mm") : "";
  };

  const formatDateTimeDisplay = (dateTimeValue) => {
    if (!dateTimeValue) {
      return "";
    }

    const parsed = moment.tz(
      dateTimeValue,
      ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DDTHH:mm"],
      "Europe/Warsaw",
    );

    return parsed.isValid()
      ? parsed.format("DD-MM-YYYY, HH:mm")
      : String(dateTimeValue);
  };

  const handleCheckboxChange = async (event) => {
    const { name, checked } = event.target;
    if (name === "wagaMail") {
      setwagaMailBox(checked);
      setwagaTabelaBox(false);
      setwagaPropBox(false);
    } else if (name === "wagaTabela") {
      setwagaTabelaBox(checked);
      setwagaMailBox(false);
      setwagaPropBox(false);
    } else if (name === "wagaProp") {
      setwagaPropBox(checked);
      setwagaMailBox(false);
      setwagaTabelaBox(false);
    }

    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const role = decoded.role;
    const username = decoded.username;
    const canModify = ["admin"].includes(role);

    // Funkcja pomocnicza do sprawdzenia czy którykolwiek checkbox wymagający komentarza został zmieniony względem wartości z bazy
    const checkIfAnyCommentRequired = (
      changedCheckboxName,
      newCheckedValue,
    ) => {
      const currentCheckboxes = {
        kilkaRazy: kilkaRazyBox,
        wiecejNiz3: wiecejNiz3Box,
        odprawaPo16: odprawaPo16Box,
        // zglosBlad ma osobną logikę - nie jest tutaj
        ATR: ATRBox,
        COO: COOBox,
        EUR: EURBox,
        ObecnoscPracownika: ObecnoscPracownikaBox,
        RPS: RPSBox,
        Sanepid: SanepidBox,
        SingleWindow: SingleWindowBox,
        T2L: T2LBox,
        WIJHARS: WIJHARSBox,
        WysylkaDokumentow: WysylkaDokumentowBox,
      };

      // Aktualizuj wartość dla zmienianego checkboxa
      currentCheckboxes[changedCheckboxName] = newCheckedValue;

      // Sprawdź czy którykolwiek checkbox został zmieniony względem oryginalnej wartości z bazy
      return Object.keys(currentCheckboxes).some((key) => {
        const currentValue = currentCheckboxes[key];
        const originalValue = originalCheckboxValues[key] || false;
        return currentValue !== originalValue;
      });
    };

    switch (name) {
      case "faktura":
        setFakturaBox(checked);
        break;
      case "certyfikaty":
        setBrakCertyfikatyBox(checked);
        break;
      case "dsk":
        setDSKBox(checked);
        break;
      case "eksportZKrajuWywozu":
        setBrakEksportZKrajuWywozuBox(checked);
        break;
      case "excel":
        setBrakExcelBox(checked);
        break;
      case "listPrzewozowy":
        setListPrzewozowyBox(checked);
        break;
      case "kosztyTransportu":
        setKosztyTransportuBox(checked);
        break;
      case "informacjeOTowarze":
        setInformacjeOTowarzeBox(checked);
        break;
      case "T1":
        setT1Box(checked);
        break;
      case "swiadectwo":
        setSwiadectwoBox(checked);
        break;
      case "upowaznienie":
        setBrakUpowaznieniaBox(checked);
        break;
      case "eori":
        setEoriBox(checked);
        break;
      case "oczekiwanieNaPlatnosc":
        setOczekiwanieNaPlatnoscBox(checked);
        break;
      case "ponownyMailOBraki":
        const previous = previousPonownyMailRef.current;
        setPonownyMailOBrakiBox(checked);

        if (checked !== previous) {
          try {
            await axios.post(
              `${BASE_URL}/update-mailobraki-timestamp/${id}`,
              {},
              {
                headers: headers,
              },
            );
          } catch (err) {
            console.error("Błąd przy aktualizacji daty ponownego maila:", err);
            toast.error("Nie udało się zaktualizować daty wysłania maila.");
          }
        }

        previousPonownyMailRef.current = checked;
        break;

      case "brakFakturyEdytowalnej":
        setBrakFakturyEdytowalnejBox(checked);
        break;
      case "brakPackingList":
        setBrakPackingListEdytowalnegoBox(checked);
        break;
      case "brakIncoterms":
        setBrakIncotermsBox(checked);
        break;
      case "onwoz":
        setOnwozBox(checked);
        break;
      case "oczekiwanieRozladunek":
        setOczekiwanieRozladunekBox(checked);
        break;
      case "brakInne":
        setBrakInneBox(checked);
        if (!checked) {
          setBrakInne("");
        }
        break;
      case "pliki":
        setPlikiBox(checked);
        break;
      case "sankcje":
        setSankcjeBox(checked);
        break;
      case "CBAM":
        setCBAMBox(checked);
        break;
      case "CE":
        setCEBox(checked);
        break;
      case "pilne":
        setPilneBox(checked);
        break;
      case "wagaMail":
        setwagaMailBox(checked);
        break;
      case "wagaTabela":
        setwagaTabelaBox(checked);
        break;
      case "wagaProp":
        setwagaPropBox(checked);
        break;
      case "wagaDok":
        setwagaDokpBox(checked);
        break;
      case "kilkaRazy":
        setKilkaRazyBox(checked);
        const anyCheckedAfterKilkaRazy = checkIfAnyCommentRequired(
          "kilkaRazy",
          checked,
        );
        setShowCommentPrompt(anyCheckedAfterKilkaRazy);
        break;
      case "wiecejNiz3":
        setWiecejNiz3Box(checked);
        const anyCheckedAfterWiecejNiz3 = checkIfAnyCommentRequired(
          "wiecejNiz3",
          checked,
        );
        setShowCommentPrompt(anyCheckedAfterWiecejNiz3);
        break;
      case "odprawaPo16":
        setOdprawaPo16Box(checked);
        const anyCheckedAfterOdprawaPo16 = checkIfAnyCommentRequired(
          "odprawaPo16",
          checked,
        );
        setShowCommentPrompt(anyCheckedAfterOdprawaPo16);
        break;
      case "zglosBlad":
        setZglosBladBox(checked);
        // Zgłoś błąd ma osobną logikę - sprawdź czy został zmieniony względem wartości z bazy
        const originalZglosBlad = originalCheckboxValues.zglosBlad || false;
        const zglosBladChanged = checked !== originalZglosBlad;
        setShowErrorReportPrompt(zglosBladChanged);
        // zglosBlad nie wpływa na showCommentPrompt - ma osobną logikę z polem do opisu błędu
        break;
      case "ATR":
        setATRBox(checked);
        const anyCheckedAfterATR = checkIfAnyCommentRequired("ATR", checked);
        setShowCommentPrompt(anyCheckedAfterATR);
        break;
      case "COO":
        setCOOBox(checked);
        const anyCheckedAfterCOO = checkIfAnyCommentRequired("COO", checked);
        setShowCommentPrompt(anyCheckedAfterCOO);
        break;
      case "EUR":
        setEURBox(checked);
        const anyCheckedAfterEUR = checkIfAnyCommentRequired("EUR", checked);
        setShowCommentPrompt(anyCheckedAfterEUR);
        break;
      case "ObecnoscPracownika":
        setObecnoscPracownikaBox(checked);
        const anyCheckedAfterObecnoscPracownika = checkIfAnyCommentRequired(
          "ObecnoscPracownika",
          checked,
        );
        setShowCommentPrompt(anyCheckedAfterObecnoscPracownika);
        break;
      case "RPS":
        setRPSBox(checked);
        const anyCheckedAfterRPS = checkIfAnyCommentRequired("RPS", checked);
        setShowCommentPrompt(anyCheckedAfterRPS);
        break;
      case "probZab":
        setProbZabBox(checked);
        break;
      case "dataOdebraniaDokumentow":
        setDataOdebraniaDokumentowBox(checked);
        if (checked) {
          setDataOdebraniaDokumentow(
            (prev) => prev || getCurrentDateTimeLocal(),
          );
        } else {
          setDataOdebraniaDokumentow("");
        }
        break;
      case "Sanepid":
        setSanepidBox(checked);
        const anyCheckedAfterSanepid = checkIfAnyCommentRequired(
          "Sanepid",
          checked,
        );
        setShowCommentPrompt(anyCheckedAfterSanepid);
        break;
      case "SingleWindow":
        setSingleWindowBox(checked);
        const anyCheckedAfterSingleWindow = checkIfAnyCommentRequired(
          "SingleWindow",
          checked,
        );
        setShowCommentPrompt(anyCheckedAfterSingleWindow);
        break;
      case "T2L":
        setT2LBox(checked);
        const anyCheckedAfterT2L = checkIfAnyCommentRequired("T2L", checked);
        setShowCommentPrompt(anyCheckedAfterT2L);
        break;
      case "WIJHARS":
        setWIJHARSBox(checked);
        const anyCheckedAfterWIJHARS = checkIfAnyCommentRequired(
          "WIJHARS",
          checked,
        );
        setShowCommentPrompt(anyCheckedAfterWIJHARS);
        break;
      case "WysylkaDokumentow":
        setWysylkaDokumentowBox(checked);
        const anyCheckedAfterWysylkaDokumentow = checkIfAnyCommentRequired(
          "WysylkaDokumentow",
          checked,
        );
        setShowCommentPrompt(anyCheckedAfterWysylkaDokumentow);
        break;

      default:
        break;
    }
  };

  // Function to handle comment input change
  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  // Function to fetch valid logins from database
  const fetchValidLogins = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/users`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      // Ekstrahuj same loginy (username) z tabeli users do tablicy i posortuj alfabetycznie
      const logins = response.data
        .map((user) => user.username)
        .sort((a, b) => a.localeCompare(b));
      setValidLoginsList(logins);
    } catch (error) {
      console.error("Error fetching valid logins:", error);
    }
  };

  // Function to validate additional recipients format
  const validateRecipientsFormat = (logins) => {
    if (!logins || logins.length === 0) {
      setRecipientsError("");
      return true;
    }

    // Sprawdzenie czy są puste loginy
    for (let login of logins) {
      if (!login || login.trim() === "") {
        setRecipientsError(
          "Wykryto pusty login. Usuń puste wartości (sprawdź czy nie ma spacji po przecinku).",
        );
        return false;
      }
    }

    // Sprawdzenie czy loginy zawierają spacje (poza trim)
    for (let login of logins) {
      const trimmedLogin = login.trim();
      if (trimmedLogin.includes(" ")) {
        setRecipientsError(
          `Login "${trimmedLogin}" zawiera spacje. Loginy nie mogą zawierać spacji.`,
        );
        return false;
      }
    }

    // Sprawdzenie czy loginy istnieją w bazie danych
    if (validLoginsList.length > 0) {
      const invalidLogins = [];
      for (let login of logins) {
        const normalizedLogin = login.trim();
        if (!validLoginsList.includes(normalizedLogin)) {
          invalidLogins.push(login.trim());
        }
      }

      if (invalidLogins.length > 0) {
        if (invalidLogins.length === 1) {
          setRecipientsError(
            `Login "${invalidLogins[0]}" nie istnieje w bazie danych.`,
          );
        } else {
          setRecipientsError(
            `Loginy nie istnieją w bazie danych: ${invalidLogins.join(", ")}`,
          );
        }
        return false;
      }
    }

    setRecipientsError("");
    return true;
  };

  // Handle input change - automatyczne tworzenie chipów po przecinku
  const handleInputChange = (event, newInputValue, reason) => {
    if (newInputValue.includes(",")) {
      // Jeśli użytkownik wpisał przecinek
      const parts = newInputValue.split(",");
      const loginsToAdd = parts
        .map((p) => p.trim())
        .filter((p) => p.length > 0);

      if (loginsToAdd.length > 0) {
        const newRecipients = [...additionalRecipients, ...loginsToAdd];
        setAdditionalRecipients(newRecipients);
        validateRecipientsFormat(newRecipients);
      }

      // Po przecinku wyczyść pole input i przywróć focus
      setInputValue("");

      // Przywróć focus do pola input po małym opóźnieniu
      setTimeout(() => {
        if (autocompleteRef.current) {
          const input = autocompleteRef.current.querySelector("input");
          if (input) {
            input.focus();
          }
        }
      }, 0);

      return;
    }

    if (reason === "reset") {
      // Gdy autocomplete resetuje wartość (np. po wybraniu z listy lub Enter)
      setInputValue("");
      return;
    }

    // Normalne wpisywanie
    setInputValue(newInputValue);
  };

  // Handle additional recipients change with validation
  const handleAdditionalRecipientsChange = (event, newValue, reason) => {
    // Zawsze przetwarzaj wartości - szukaj przecinków i rozdziel je
    const processedValues = [];

    newValue.forEach((value) => {
      if (typeof value === "string" && value.includes(",")) {
        // Rozdziel po przecinkach
        const splitValues = value.split(",").map((v) => v.trim());
        // Dodaj wszystkie wartości, nawet puste - walidacja je wykryje
        processedValues.push(...splitValues);
      } else if (typeof value === "string") {
        processedValues.push(value.trim());
      } else {
        processedValues.push(value);
      }
    });

    setAdditionalRecipients(processedValues);
    validateRecipientsFormat(processedValues);

    // Po dodaniu chipów wyczyść input
    if (reason === "createOption" || reason === "selectOption") {
      setInputValue("");
    }
  };

  const handleSaveComment = async () => {
    try {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const username = decoded.username;

      const timestamp = moment.tz("Europe/Warsaw").format();

      let potentialRecipients = [];

      // Sprawdzenie rodzajTransportu i przypisanie odpowiednich odbiorców
      if (rowData.rodzajTransportu === "Magazyn Warszawa Nowy Handling") {
        // Nowy Handling - brak automatycznych odbiorców. Mail wychodzi tylko,
        // gdy uzytkownik wpisze "Dodatkowi odbiorcy powiadomienia".
        potentialRecipients = [];
      } else if (
        [
          "Magazyn Warszawa",
          "Magazyn Warszawa Zwroty i Błędy",
          "Magazyn Warszawa Handling",
        ].includes(rowData.rodzajTransportu)
      ) {
        // Dla Magazyn Warszawa - odbiorcą jest createdBy
        potentialRecipients = [rowData.createdBy];
      } else {
        // Dla pozostałych rodzajów transportu - standardowi odbiorcy
        potentialRecipients = [
          rowData.osobaPrzygotowujacaOdprawe,
          rowData.osobaWysylajacaOdprawe,
        ];
      }

      // Filtruj standardowych odbiorców - usuń osobę która dodaje komentarz i puste wartości
      const filteredPotentialRecipients = potentialRecipients
        .filter(Boolean)
        .filter((recipient) => recipient !== username);

      // Przetwarzanie dodatkowych odbiorców
      const extraRecipients = additionalRecipients.filter(
        (login) => login.length > 0,
      );

      // Łączenie odfiltrowanych standardowych i dodatkowych odbiorców
      const recipients = [
        ...filteredPotentialRecipients,
        ...extraRecipients,
      ].filter(Boolean);

      if (!comment.trim()) {
        toast.error("Komentarz nie może być pusty.");
        return;
      }

      // Walidacja formatu dodatkowych odbiorców
      if (
        additionalRecipients.length > 0 &&
        !validateRecipientsFormat(additionalRecipients)
      ) {
        toast.error("Popraw format loginów dodatkowych odbiorców.");
        return;
      }

      const hasRecipients = recipients.length > 0;
      const hasAdditionalRecipients = extraRecipients.length > 0;

      // Tworzenie treści komentarza z informacją o odbiorcach powiadomienia
      let finalComment = comment;

      // Połącz wszystkich odbiorców (automatycznych i dodatkowych) i usuń duplikaty
      const allRecipients = [
        ...new Set([...filteredPotentialRecipients, ...extraRecipients]),
      ];

      // Dodaj informację o wszystkich odbiorcach powiadomienia
      if (allRecipients.length > 0) {
        finalComment += `\n\n---\nOdbiorcy powiadomienia: ${allRecipients.join(", ")}`;
      }

      const payload = hasRecipients
        ? {
            id,
            comment: finalComment,
            username,
            recipients,
            timestamp,
            nrRef: rowData.nrRef,
            rodzajTransportu: rowData.rodzajTransportu,
            statusRealizacji: rowData.statusRealizacji,
            rodzaj: rowData.rodzaj,
          }
        : {
            id,
            comment: finalComment,
            username,
          };

      const endpoint = hasRecipients
        ? `${BASE_URL}/comments/addWithNotification`
        : `${BASE_URL}/comments/${id}`;

      await axios.post(endpoint, payload, { headers });

      setComment("");
      setAdditionalRecipients([]);
      toast.success(
        hasRecipients
          ? "Dodano komentarz i wysłano powiadomienie!"
          : "Dodano komentarz.",
      );
      if (onDataRefresh) {
        await onDataRefresh();
      }
    } catch (error) {
      console.error("Error saving comment:", error);

      // Pokaż szczegółowy komunikat błędu z backendu
      const backendMessage = error.response?.data?.message;

      if (error.response?.status === 400) {
        toast.error(backendMessage || "Nieprawidłowe dane wejściowe.");
      } else if (error.response?.status === 500) {
        // Błąd 500: brak połączenia z bazą, błąd transakcji, błąd wysyłania emaila
        toast.error(
          backendMessage ||
            "Błąd serwera – komentarz nie został zapisany. Spróbuj ponownie.",
        );
      } else if (error.request) {
        // Brak odpowiedzi z serwera
        toast.error(
          "Brak odpowiedzi z serwera – sprawdź połączenie z internetem i spróbuj ponownie.",
        );
      } else {
        toast.error(
          backendMessage || "Nie udało się dodać komentarza. Spróbuj ponownie.",
        );
      }

      // Log szczegółowy dla debugowania
      if (backendMessage) {
        console.error("📧 Szczegóły błędu z backendu:", backendMessage);
      }
    }
  };

  const notify = () => {
    toast.success("Dane zapisano poprawnie!", {
      autoClose: 1000, // Set autoClose to the number of milliseconds you want the notification to be visible, in this case, 1 second
    });
  };

  const handleSaveCheckboxData = async () => {
    try {
      const checkboxDataPayload = {
        fakturaChecked: fakturaBox ? 1 : 0,
        listPrzewozowyChecked: listPrzewozowyBox ? 1 : 0,
        kosztyTransportuChecked: kosztyTransportuBox ? 1 : 0,
        informacjeOTowarzeChecked: informacjeOTowarzeBox ? 1 : 0,
        T1Checked: T1Box ? 1 : 0,
        swiadectwoChecked: swiadectwoBox ? 1 : 0,
        plikiChecked: plikiBox ? 1 : 0,
        sankcjeChecked: sankcjeBox ? 1 : 0,
        CBAMChecked: CBAMBox ? 1 : 0,
        CEChecked: CEBox ? 1 : 0,
        wagaMailChecked: wagaMailBox ? 1 : 0,
        wagaTabelaChecked: wagaTabelaBox ? 1 : 0,
        wagaPropChecked: wagaPropBox ? 1 : 0,
        wagaDokChecked: wagaDokBox ? 1 : 0,
        kilkaRazyChecked: kilkaRazyBox ? 1 : 0,
        wiecejNiz3Checked: wiecejNiz3Box ? 1 : 0,
        odprawaPo16Checked: odprawaPo16Box ? 1 : 0,
        zglosBladChecked: zglosBladBox ? 1 : 0,
        upowaznienieChecked: brakUpowaznieniaBox ? 1 : 0,
        eoriChecked: eoriBox ? 1 : 0,
        oczekiwanieNaPlatnosc: oczekiwanieNaPlatnoscBox ? 1 : 0,
        ponownyMailOBraki: ponownyMailOBrakiBox ? 1 : 0,
        brakFakturyEdytowalnej: brakFakturyEdytowalnejBox ? 1 : 0,
        brakPackingListEdytowalnego: brakPackingListEdytowalnegoBox ? 1 : 0,
        brakIncoterms: brakIncotermsBox ? 1 : 0,
        onwozChecked: onwozBox ? 1 : 0,
        oczekiwanieRozladunekChecked: oczekiwanieRozladunekBox ? 1 : 0,
        pilneChecked: pilneBox ? 1 : 0,
        ATRChecked: ATRBox ? 1 : 0,
        EURChecked: EURBox ? 1 : 0,
        T2LChecked: T2LBox ? 1 : 0,
        RPSChecked: RPSBox ? 1 : 0,
        probZabChecked: probZabBox ? 1 : 0,
        SanepidChecked: SanepidBox ? 1 : 0,
        WIJHARSChecked: WIJHARSBox ? 1 : 0,
        SingleWindowChecked: SingleWindowBox ? 1 : 0,
        ObecnoscPracownikaChecked: ObecnoscPracownikaBox ? 1 : 0,
        COOChecked: COOBox ? 1 : 0,
        WysylkaDokumentowChecked: WysylkaDokumentowBox ? 1 : 0,
        brakCertyfikatyChecked: brakCertyfikatyBox ? 1 : 0,
        brakEksportZKrajuWywozuChecked: brakEksportZKrajuWywozuBox ? 1 : 0,
        brakExcelChecked: brakExcelBox ? 1 : 0,
        brakInne,
        dskChecked: DSKBox ? 1 : 0,
        dataOdebraniaDokumentow: dataOdebraniaDokumentowBox
          ? dataOdebraniaDokumentow
          : null,
      };

      // Zrób główny update checkboxów
      await axios.put(
        `${BASE_URL}/update-checkbox-data/${id}`,
        checkboxDataPayload,
        {
          headers: headers,
        },
      );

      // Sprawdź, czy zmienił się stan ponownyMailOBrakiBox
      if (ponownyMailOBrakiBox !== previousPonownyMailRef.current) {
        await axios.post(
          `${BASE_URL}/update-mailobraki-timestamp/${id}`,
          {},
          {
            headers: headers,
          },
        );

        // Zaktualizuj ref
        previousPonownyMailRef.current = ponownyMailOBrakiBox;
      }

      // Odśwież rowData w DetailPage - m.in. handleEditSave sprawdza tam
      // oczekiwanieNaRozladunekLubOdprawaLaczonaBox przy zmianie rodzajTransportu.
      if (onDataRefresh) {
        await onDataRefresh();
      }

      notify();
    } catch (error) {
      console.error("Error saving checkbox data:", error);
      toast.error("Wystąpił błąd przy zapisywaniu danych.");
    }
  };

  const handleSaveErrorReport = async () => {
    try {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const username = decoded.username;

      // Sprawdź czy wiadomość nie jest pusta
      if (!errorReportMessage.trim()) {
        toast.warning("Treść powiadomienia nie może być pusta!");
        return;
      }

      // Określ czy błąd został zaznaczony czy odznaczony
      const originalZglosBlad = originalCheckboxValues.zglosBlad || false;
      const action = zglosBladBox ? "zaznaczono" : "odznaczono";

      // Wyślij powiadomienie email
      await axios.post(
        `${BASE_URL}/send-error-report-notification`,
        {
          nrRef: rowData.nrRef,
          message: errorReportMessage,
          action: action,
          username: username,
          id: rowData.id,
        },
        {
          headers: headers,
        },
      );

      // Zapisz stan checkboxa w bazie
      const checkboxDataPayload = {
        zglosBladChecked: zglosBladBox ? 1 : 0,
      };

      await axios.put(
        `${BASE_URL}/update-checkbox-data/${id}`,
        checkboxDataPayload,
        {
          headers: headers,
        },
      );

      toast.success("Powiadomienie zostało wysłane!");
      setErrorReportMessage("");
      await fetchCheckboxData();
      if (onDataRefresh) {
        await onDataRefresh();
      }
    } catch (error) {
      console.error("Error sending error report:", error);
      toast.error("Wystąpił błąd przy wysyłaniu powiadomienia.");
    }
  };

  const handleSaveCommentAndCheckBox = async () => {
    try {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const username = decoded.username;

      // Check if the comment is empty
      if (!comment.trim()) {
        // Show a toast notification if the comment is empty
        toast.warning("Komentarz nie może być pusty!");
        return; // Exit the function without making the API call
      }

      // Wykryj które checkboxy z sekcji "Uwagi do działu finansowego" zostały zmienione
      const financialCheckboxes = {
        ATR: {
          current: ATRBox,
          original: originalCheckboxValues.ATR || false,
          label: "A. TR",
        },
        COO: {
          current: COOBox,
          original: originalCheckboxValues.COO || false,
          label: "COO",
        },
        EUR: {
          current: EURBox,
          original: originalCheckboxValues.EUR || false,
          label: "EUR. 1",
        },
        ObecnoscPracownika: {
          current: ObecnoscPracownikaBox,
          original: originalCheckboxValues.ObecnoscPracownika || false,
          label: "Obecność pracownika przy kontroli",
        },
        kilkaRazy: {
          current: kilkaRazyBox,
          original: originalCheckboxValues.kilkaRazy || false,
          label: "Odprawa wysłana kilka razy ze względu na błąd klienta",
        },
        odprawaPo16: {
          current: odprawaPo16Box,
          original: originalCheckboxValues.odprawaPo16 || false,
          label: "Odprawa zlecona po godzinach",
        },
        RPS: {
          current: RPSBox,
          original: originalCheckboxValues.RPS || false,
          label: "RPS",
        },
        Sanepid: {
          current: SanepidBox,
          original: originalCheckboxValues.Sanepid || false,
          label: "Sanepid",
        },
        SingleWindow: {
          current: SingleWindowBox,
          original: originalCheckboxValues.SingleWindow || false,
          label: "SINGLE-WINDOW",
        },
        T2L: {
          current: T2LBox,
          original: originalCheckboxValues.T2L || false,
          label: "T2L",
        },
        wiecejNiz3: {
          current: wiecejNiz3Box,
          original: originalCheckboxValues.wiecejNiz3 || false,
          label: "Więcej niż 3 pozycje na fakturze zostały wprowadzone ręcznie",
        },
        WIJHARS: {
          current: WIJHARSBox,
          original: originalCheckboxValues.WIJHARS || false,
          label: "WIJHARS",
        },
        WysylkaDokumentow: {
          current: WysylkaDokumentowBox,
          original: originalCheckboxValues.WysylkaDokumentow || false,
          label: "Wysyłka dokumentów",
        },
      };

      const changedCheckboxes = [];
      Object.keys(financialCheckboxes).forEach((key) => {
        const checkbox = financialCheckboxes[key];
        if (checkbox.current !== checkbox.original) {
          changedCheckboxes.push({
            name: key,
            label: checkbox.label,
            wasChecked: checkbox.original,
            isChecked: checkbox.current,
          });
        }
      });

      const finalComment =
        changedCheckboxes.length > 0
          ? `Informacja dla działu finansowego:\n${comment}`
          : comment;

      // Make an API call to save the comment
      // eslint-disable-next-line no-unused-vars
      const response = await axios.post(
        `${BASE_URL}/comments/${id}`,
        { comment: finalComment, username },
        { headers },
      );

      // Convert the boolean values to 0 or 1
      const checkboxDataPayload = {
        fakturaChecked: fakturaBox ? 1 : 0,
        listPrzewozowyChecked: listPrzewozowyBox ? 1 : 0,
        kosztyTransportuChecked: kosztyTransportuBox ? 1 : 0,
        informacjeOTowarzeChecked: informacjeOTowarzeBox ? 1 : 0,
        T1Checked: T1Box ? 1 : 0,
        swiadectwoChecked: swiadectwoBox ? 1 : 0,
        plikiChecked: plikiBox ? 1 : 0,
        sankcjeChecked: sankcjeBox ? 1 : 0,
        CBAMChecked: CBAMBox ? 1 : 0,
        CEChecked: CEBox ? 1 : 0,
        wagaMailChecked: wagaMailBox ? 1 : 0,
        wagaTabelaChecked: wagaTabelaBox ? 1 : 0,
        wagaPropChecked: wagaPropBox ? 1 : 0,
        wagaDokChecked: wagaDokBox ? 1 : 0,
        kilkaRazyChecked: kilkaRazyBox ? 1 : 0,
        wiecejNiz3Checked: wiecejNiz3Box ? 1 : 0,
        odprawaPo16Checked: odprawaPo16Box ? 1 : 0,
        zglosBladChecked: zglosBladBox ? 1 : 0,
        upowaznienieChecked: brakUpowaznieniaBox ? 1 : 0,
        eoriChecked: eoriBox ? 1 : 0,
        oczekiwanieNaPlatnosc: oczekiwanieNaPlatnoscBox ? 1 : 0,
        ponownyMailOBraki: ponownyMailOBrakiBox ? 1 : 0,
        brakFakturyEdytowalnej: brakFakturyEdytowalnejBox ? 1 : 0,
        brakPackingListEdytowalnego: brakPackingListEdytowalnegoBox ? 1 : 0,
        brakIncoterms: brakIncotermsBox ? 1 : 0,
        onwozChecked: onwozBox ? 1 : 0,
        oczekiwanieRozladunekChecked: oczekiwanieRozladunekBox ? 1 : 0,
        pilneChecked: pilneBox ? 1 : 0,
        ATRChecked: ATRBox ? 1 : 0,
        EURChecked: EURBox ? 1 : 0,
        T2LChecked: T2LBox ? 1 : 0,
        RPSChecked: RPSBox ? 1 : 0,
        probZabChecked: probZabBox ? 1 : 0,
        SanepidChecked: SanepidBox ? 1 : 0,
        WIJHARSChecked: WIJHARSBox ? 1 : 0,
        SingleWindowChecked: SingleWindowBox ? 1 : 0,
        ObecnoscPracownikaChecked: ObecnoscPracownikaBox ? 1 : 0,
        COOChecked: COOBox ? 1 : 0,
        WysylkaDokumentowChecked: WysylkaDokumentowBox ? 1 : 0,
        brakCertyfikatyChecked: brakCertyfikatyBox ? 1 : 0,
        brakEksportZKrajuWywozuChecked: brakEksportZKrajuWywozuBox ? 1 : 0,
        brakExcelChecked: brakExcelBox ? 1 : 0,
        brakInne,
        dskChecked: DSKBox ? 1 : 0,
        dataOdebraniaDokumentow: dataOdebraniaDokumentowBox
          ? dataOdebraniaDokumentow
          : null,
      };

      // Make the PUT request to update the checkbox data
      await axios.put(
        `${BASE_URL}/update-checkbox-data/${id}`,
        checkboxDataPayload,
        {
          headers: headers,
        },
      );

      // Sprawdź, czy zmienił się stan ponownyMailOBrakiBox
      if (ponownyMailOBrakiBox !== previousPonownyMailRef.current) {
        await axios.post(
          `${BASE_URL}/update-mailobraki-timestamp/${id}`,
          {},
          {
            headers: headers,
          },
        );

        // Zaktualizuj ref
        previousPonownyMailRef.current = ponownyMailOBrakiBox;
      }

      // Wyślij email do działu finansowego jeśli jakieś checkboxy zostały zmienione
      if (changedCheckboxes.length > 0) {
        try {
          await axios.post(
            `${BASE_URL}/send-financial-notification`,
            {
              nrRef: rowData.nrRef,
              changedCheckboxes: changedCheckboxes,
              username: username,
              comment: finalComment,
              id: rowData.id,
            },
            {
              headers: headers,
            },
          );
        } catch (emailError) {
          console.error(
            "Błąd podczas wysyłania emaila do działu finansowego:",
            emailError,
          );
          // Nie przerywamy procesu jeśli email się nie wyśle
        }
      }

      // Show a success toast notification when comment is saved
      toast.success("Zapisano znacznik oraz komentarz!");

      // Clear the comment input field after successful save
      setComment("");
      await fetchCheckboxData();
      if (onDataRefresh) {
        await onDataRefresh();
      }
    } catch (error) {
      console.error("Error saving comment:", error);
      // Handle the error here (e.g., show an error message)
      toast.error("Wystąpił błąd przy zapisie znaczniki oraz komentarz.");
    }
  };

  // Function to fetch checkbox data from the backend
  const fetchCheckboxData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/fetch-checkbox-data/${id}`,
        {
          headers: headers,
        },
      );

      // Assuming the response contains the checkbox data as an object
      const checkboxData = response.data;
      setFakturaBox(checkboxData.fakturaBox);
      setListPrzewozowyBox(checkboxData.listPrzewozowyBox);
      setKosztyTransportuBox(checkboxData.kosztyTransportuBox);
      setInformacjeOTowarzeBox(checkboxData.informacjeOTowarzeBox);
      setT1Box(checkboxData.T1Box);
      setSwiadectwoBox(checkboxData.swiadectwoBox);
      setPlikiBox(checkboxData.plikiBox);
      setSankcjeBox(checkboxData.sankcjeBox);
      setCBAMBox(checkboxData.CBAMBox);
      setCEBox(checkboxData.CEBox);
      setwagaMailBox(checkboxData.wagaMailBox);
      setwagaTabelaBox(checkboxData.wagaTabelaBox);
      setwagaPropBox(checkboxData.wagaPropBox);
      setwagaDokpBox(checkboxData.wagaDokBox);
      setKilkaRazyBox(checkboxData.kilkaRazyBox);
      setWiecejNiz3Box(checkboxData.wiecejNiz3Box);
      setOdprawaPo16Box(checkboxData.odprawaPo16Box);
      setZglosBladBox(checkboxData.zglosBladBox);
      setBrakUpowaznieniaBox(checkboxData.brakUpowaznieniaBox);
      setEoriBox(checkboxData.eoriBox);
      setPilneBox(checkboxData.pilneBox);
      setOczekiwanieNaPlatnoscBox(checkboxData.oczekiwanieNaPlatnoscBox);
      setPonownyMailOBrakiBox(checkboxData.ponownyMailOBrakiBox);
      setBrakFakturyEdytowalnejBox(checkboxData.brakFakturyEdytowalnejBox);
      setBrakPackingListEdytowalnegoBox(
        checkboxData.brakPackingListEdytowalnegoBox,
      );
      setBrakIncotermsBox(checkboxData.brakIncotermsBox);
      setOnwozBox(checkboxData.onwozBox);
      setOczekiwanieRozladunekBox(
        checkboxData.oczekiwanieNaRozladunekLubOdprawaLaczonaBox,
      );
      setBrakInneBox(checkboxData.brakInneBox);
      setBrakInne(checkboxData.brakInne);
      setATRBox(checkboxData.ATRBox);
      setEURBox(checkboxData.EURBox);
      setT2LBox(checkboxData.T2LBox);
      setRPSBox(checkboxData.RPSBox);
      setProbZabBox(checkboxData.probZabBox);
      setSanepidBox(checkboxData.SanepidBox);
      setWIJHARSBox(checkboxData.WIJHARSBox);
      setSingleWindowBox(checkboxData.SingleWindowBox);
      setObecnoscPracownikaBox(checkboxData.ObecnoscPracownikaBox);
      setCOOBox(checkboxData.COOBox);
      setWysylkaDokumentowBox(checkboxData.WysylkaDokumentowBox);
      setBrakCertyfikatyBox(checkboxData.brakCertyfikatyBox);
      setBrakEksportZKrajuWywozuBox(checkboxData.brakEksportZKrajuWywozuBox);
      setBrakExcelBox(checkboxData.brakExcelBox);
      setDSKBox(checkboxData.DSKBox);
      setDataOdebraniaDokumentowBox(
        Boolean(checkboxData.dataOdebraniaDokumentow),
      );
      setDataOdebraniaDokumentow(
        toDateTimeLocalValue(checkboxData.dataOdebraniaDokumentow),
      );

      // Zapisz oryginalne wartości checkboxów wymagających komentarza
      setOriginalCheckboxValues({
        kilkaRazy: checkboxData.kilkaRazyBox,
        wiecejNiz3: checkboxData.wiecejNiz3Box,
        odprawaPo16: checkboxData.odprawaPo16Box,
        zglosBlad: checkboxData.zglosBladBox,
        ATR: checkboxData.ATRBox,
        COO: checkboxData.COOBox,
        EUR: checkboxData.EURBox,
        ObecnoscPracownika: checkboxData.ObecnoscPracownikaBox,
        RPS: checkboxData.RPSBox,
        probZab: checkboxData.probZabBox,
        Sanepid: checkboxData.SanepidBox,
        SingleWindow: checkboxData.SingleWindowBox,
        T2L: checkboxData.T2LBox,
        WIJHARS: checkboxData.WIJHARSBox,
        WysylkaDokumentow: checkboxData.WysylkaDokumentowBox,
      });
    } catch (error) {
      console.error("Error fetching checkbox data:", error);
    }
  };

  const fetchDataByNrRef = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/getEmailDataByNrRef/${nrRef}`,
        {
          headers: headers,
        },
      );

      if (response.status === 200) {
        return response.data; // Zwraca dane z odpowiedzi
      } else {
        // Obsługa odpowiedzi innej niż 200 OK
        console.error("Nie udało się pobrać danych dla nrRef:", nrRef);
      }
    } catch (error) {
      console.error("Błąd podczas pobierania danych:", error);
      throw error; // Rzucenie wyjątku do dalszej obsługi błędów
    }
  };

  // Odśwież sekcję "Wysłane maile z DutyStation" bez przeładowania strony.
  const refreshEmailData = async () => {
    try {
      const data = await fetchDataByNrRef(nrRef);
      setEmailData(data || []);
    } catch (error) {
      console.error("Nie udało się odświeżyć listy wysłanych maili:", error);
    }
  };

  // Rodzic (DetailPage) zwiększa emailRefreshToken po wysłaniu maila -> ponowne pobranie listy.
  useEffect(() => {
    if (emailRefreshToken > 0) refreshEmailData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailRefreshToken]);

  function EmailTable({ emails }) {
    // Funkcja do wyciągania zawartości body z pełnego dokumentu HTML wraz ze stylami
    const extractEmailContent = (html) => {
      if (!html) return "";

      let styles = "";
      let content = html;

      // Sprawdź czy to pełny dokument HTML (zawiera <!DOCTYPE lub <html>)
      if (html.includes("<!DOCTYPE") || html.includes("<html>")) {
        // Wyciągnij style z <head>
        const styleMatches = html.matchAll(/<style[^>]*>([\s\S]*?)<\/style>/gi);
        for (const match of styleMatches) {
          if (match[1]) {
            // Dodaj prefix .email-content-wrapper do każdego selektora CSS
            let scopedStyles = match[1];
            // Podstawowe scopowanie - dodaj prefix do większości selektorów
            scopedStyles = scopedStyles.replace(
              /([^\r\n,{}]+)(,(?=[^}]*{)|\s*{)/g,
              (match, selector, ending) => {
                // Pomiń @media, @keyframes itp.
                if (selector.trim().startsWith("@")) {
                  return match;
                }
                return `.email-content-wrapper ${selector.trim()}${ending}`;
              },
            );
            styles += scopedStyles;
          }
        }

        // Wyciągnij zawartość body
        const bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
        if (bodyMatch && bodyMatch[1]) {
          content = bodyMatch[1];
        }
      }

      // Usuń wszystko przed słowem "Potwierdzenie"
      const potwierdzeniMatch = content.match(/(Potwierdzenie[\s\S]*)/i);
      if (potwierdzeniMatch && potwierdzeniMatch[1]) {
        content = potwierdzeniMatch[1];
      }

      // Zwróć style i zawartość razem
      if (styles) {
        return `<style>${styles}</style><div class="email-content-wrapper">${content}</div>`;
      }

      return content;
    };

    const tableContainerStyle = {
      display: "grid",
      // Adjusting column sizes: make "Treść wiadomości" wider and "Adres email" smaller
      gridTemplateColumns: "minmax(50px, auto) 3fr 1fr auto",
      gap: "1px",
      marginTop: "20px",
      backgroundColor: "#ddd",
    };
    const rowStyle = {
      display: "contents",
    };
    const cellStyle = {
      padding: "8px",
      textAlign: "left",
      backgroundColor: "#fff",
    };

    const emailContentStyle = {
      padding: "8px",
      textAlign: "left",
      backgroundColor: "#fff",
      maxWidth: "100%",
      overflow: "auto",
    };

    if (emails.length === 0) {
      return null;
    }

    return (
      <>
        <h2>Wysłane maile z DutyStation</h2>
        <div style={tableContainerStyle}>
          <div style={rowStyle}>
            <div style={cellStyle}>
              <strong>Lp.</strong>
            </div>
            <div style={cellStyle}>
              <strong>Treść wiadomości</strong>
            </div>
            <div style={cellStyle}>
              <strong>Adres email</strong>
            </div>
            <div style={cellStyle}>
              <strong>Data wysłania</strong>
            </div>
          </div>
          {emails.map((email, index) => {
            const emailContent = extractEmailContent(email.text);
            return (
              <div key={index} style={rowStyle}>
                <div style={cellStyle}>{index + 1}</div>
                <div
                  style={emailContentStyle}
                  dangerouslySetInnerHTML={{ __html: emailContent }}
                />
                <div style={cellStyle}>{email.email}</div>
                <div style={cellStyle}>
                  {new Date(email.dataWyslania).toLocaleString("pl-PL", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  }

  useEffect(() => {
    // Pobierz username z tokena
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setCurrentUsername(decoded.username);
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }

    fetchCheckboxData();
    fetchValidLogins(); // Pobierz listę prawidłowych loginów
    const fetchData = async () => {
      try {
        const data = await fetchDataByNrRef(nrRef);
        setEmailData(data);
      } catch (error) {
        console.error("Error fetching email data:", error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isMagazynWarszawaTransport =
    rowData &&
    [
      "Magazyn Warszawa",
      "Magazyn Warszawa Zwroty i Błędy",
      "Magazyn Warszawa Handling",
    ].includes(rowData.rodzajTransportu);

  // Nowy Handling: brak automatycznych odbiorców - mail wychodzi tylko, gdy
  // uzytkownik wypelni "Dodatkowi odbiorcy powiadomienia".
  const isNowyHandlingComment =
    rowData && rowData.rodzajTransportu === "Magazyn Warszawa Nowy Handling";

  const automaticRecipients = isNowyHandlingComment
    ? []
    : isMagazynWarszawaTransport
      ? [rowData?.createdBy]
      : [rowData?.osobaPrzygotowujacaOdprawe, rowData?.osobaWysylajacaOdprawe];

  const automaticRecipientsWithoutCurrentUser = automaticRecipients
    .filter(Boolean)
    .filter((recipient) => recipient !== currentUsername);

  // ---- Sekcja znaczników: chipy zamiast listy checkboxów ----
  // Natywny checkbox (ukryty wizualnie) zostaje w <label>, więc handleCheckboxChange
  // dostaje to samo zdarzenie (name/checked) co wcześniej.
  const ckChip = (name, checked, label, opts = {}) => (
    <label
      key={name}
      className={[
        classes.ckChip,
        checked && (opts.urgent ? classes.ckChipUrgent : classes.ckChipChecked),
        opts.disabled && classes.ckChipDisabled,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <input
        type="checkbox"
        className={classes.ckInput}
        name={name}
        checked={checked}
        disabled={opts.disabled}
        onChange={handleCheckboxChange}
      />
      {checked && <span aria-hidden="true">✓</span>}
      {label}
    </label>
  );

  const ckCount = (chips) => chips.filter(([, checked]) => checked).length;

  const ckCard = (key, title, count, children) => {
    const collapsed = Boolean(ckCollapsed[key]);
    return (
      <div className={classes.ckCard} key={key}>
        <button
          type="button"
          className={classes.ckCardHeader}
          onClick={() =>
            setCkCollapsed((prev) => ({ ...prev, [key]: !prev[key] }))
          }
          aria-expanded={!collapsed}
        >
          <span className={classes.ckCardTitle}>{title}</span>
          {count > 0 && <span className={classes.ckCount}>{count}</span>}
          <span className={classes.ckArrow}>{collapsed ? "▸" : "▾"}</span>
        </button>
        {!collapsed && <div className={classes.ckCardBody}>{children}</div>}
      </div>
    );
  };

  const brakiChips = [
    ["certyfikaty", brakCertyfikatyBox, "Certyfikaty"],
    ["dsk", DSKBox, "DSK"],
    [
      "eksportZKrajuWywozu",
      brakEksportZKrajuWywozuBox,
      "Eksport z kraju wywozu",
    ],
    ["excel", brakExcelBox, "Plik Excel z danymi do odprawy"],
    ["faktura", fakturaBox, "Faktura"],
    ["listPrzewozowy", listPrzewozowyBox, "List przewozowy"],
    ["kosztyTransportu", kosztyTransportuBox, "Koszty transportu"],
    ["informacjeOTowarze", informacjeOTowarzeBox, "Informacje o towarze"],
    ["T1", T1Box, "T1"],
    ["swiadectwo", swiadectwoBox, "Świadectwo"],
    ["upowaznienie", brakUpowaznieniaBox, "Upoważnienie"],
    ["eori", eoriBox, "EORI"],
    [
      "oczekiwanieNaPlatnosc",
      oczekiwanieNaPlatnoscBox,
      "Oczekiwanie na płatność",
    ],
    ["ponownyMailOBraki", ponownyMailOBrakiBox, "Ponowny mail o braki"],
    ["brakFakturyEdytowalnej", brakFakturyEdytowalnejBox, "Edytowalna faktura"],
    [
      "brakPackingList",
      brakPackingListEdytowalnegoBox,
      "Packing list edytowalny",
    ],
    ["brakIncoterms", brakIncotermsBox, "INCOTERMS + miejscowość"],
    ["onwoz", onwozBox, "Oczekiwanie na wykonanie obciążenia zabezpieczenia"],
    [
      "oczekiwanieRozladunek",
      oczekiwanieRozladunekBox,
      "Oczekiwanie na rozładunek i/lub odprawa łączona z innymi agencjami",
    ],
    ["brakInne", brakInneBox, "Inny"],
  ];
  const ograniczeniaChips = [
    ["sankcje", sankcjeBox, "Sankcje"],
    ["CBAM", CBAMBox, "CBAM"],
    ["CE", CEBox, "CE"],
  ];
  const plikiChips = [["pliki", plikiBox], ...ograniczeniaChips];
  const wagaChips = [
    [
      "wagaMail",
      wagaMailBox,
      "Waga wg informacji z maila",
      wagaTabelaBox || wagaPropBox || wagaDokBox,
    ],
    [
      "wagaTabela",
      wagaTabelaBox,
      "Waga wg danych z tabeli",
      wagaMailBox || wagaPropBox || wagaDokBox,
    ],
    [
      "wagaProp",
      wagaPropBox,
      "Waga proporcjonalnie",
      wagaMailBox || wagaTabelaBox || wagaDokBox,
    ],
    [
      "wagaDok",
      wagaDokBox,
      "Waga z dokumentów",
      wagaMailBox || wagaTabelaBox || wagaPropBox,
    ],
  ];
  const uwagiChips = [
    ["zglosBlad", zglosBladBox, "Zgłoś błąd w przygotowanej odprawie"],
    ["probZab", probZabBox, "Problem z zabezpieczeniem"],
    [
      "dataOdebraniaDokumentow",
      dataOdebraniaDokumentowBox,
      "Data i godzina odebrania dokumentów",
    ],
  ];
  const finanseChips = [
    ["ATR", ATRBox, "A. TR"],
    ["COO", COOBox, "COO"],
    ["EUR", EURBox, "EUR. 1"],
    [
      "ObecnoscPracownika",
      ObecnoscPracownikaBox,
      "Obecność pracownika przy kontroli",
    ],
    [
      "kilkaRazy",
      kilkaRazyBox,
      "Odprawa wysłana kilka razy ze względu na błąd klienta",
    ],
    ["odprawaPo16", odprawaPo16Box, "Odprawa zlecona po godzinach"],
    ["RPS", RPSBox, "RPS"],
    ["Sanepid", SanepidBox, "Sanepid"],
    ["SingleWindow", SingleWindowBox, "SINGLE-WINDOW"],
    ["T2L", T2LBox, "T2L"],
    [
      "wiecejNiz3",
      wiecejNiz3Box,
      "Więcej niż 3 pozycje na fakturze zostały wprowadzone ręcznie",
    ],
    ["WIJHARS", WIJHARSBox, "WIJHARS"],
    ["WysylkaDokumentow", WysylkaDokumentowBox, "Wysyłka dokumentów"],
  ];

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {rowData &&
          rowData.rodzajTransportu !== "Magazyn Warszawa" &&
          rowData.rodzajTransportu !== "Magazyn Warszawa Zwroty i Błędy" &&
          rowData.rodzajTransportu !== "Magazyn Warszawa Handling" &&
          rowData.rodzajTransportu !== "Magazyn Warszawa Nowy Handling" && (
            <div className={classes.ckSection}>
              <div className={classes.ckSectionHeader}>Znaczniki</div>
              <div className={classes.ckGrid}>
                {ckCard(
                  "priorytet",
                  "Priorytet",
                  pilneBox ? 1 : 0,
                  <div className={classes.ckChips}>
                    {ckChip("pilne", pilneBox, "Pilne", { urgent: true })}
                  </div>,
                )}

                {ckCard(
                  "braki",
                  "Braki do odprawy celnej",
                  ckCount(brakiChips),
                  <>
                    <div className={classes.ckChips}>
                      {brakiChips.map(([name, checked, label]) =>
                        ckChip(name, checked, label),
                      )}
                    </div>
                    {brakInneBox && (
                      <TextField
                        label="Opisz inny brak"
                        value={brakInne}
                        onChange={(event) => setBrakInne(event.target.value)}
                        fullWidth
                        margin="normal"
                        inputProps={{ maxLength: 255 }}
                      />
                    )}
                  </>,
                )}

                {ckCard(
                  "pliki",
                  "Pliki i dodatkowe ograniczenia",
                  ckCount(plikiChips),
                  <>
                    <div className={classes.ckSubTitle}>
                      Przygotowano plik .xls do odprawy
                    </div>
                    <div className={classes.ckChips}>
                      {ckChip("pliki", plikiBox, "Pliki do zaczytania")}
                    </div>
                    <div className={classes.ckSubTitle}>
                      Towar podlega dodatkowym ograniczeniom
                    </div>
                    <div className={classes.ckChips}>
                      {ograniczeniaChips.map(([name, checked, label]) =>
                        ckChip(name, checked, label),
                      )}
                    </div>
                    {CBAMBox && (
                      <>
                        <div className={classes.ckSubTitle}>Waga CBAM</div>
                        <div className={classes.ckChips}>
                          {wagaChips.map(([name, checked, label, disabled]) =>
                            ckChip(name, checked, label, { disabled }),
                          )}
                        </div>
                      </>
                    )}
                  </>,
                )}

                {allowedErrorReportUsers.includes(currentUsername) &&
                  ckCard(
                    "uwagi",
                    "Uwagi",
                    ckCount(uwagiChips),
                    <>
                      <div className={classes.ckChips}>
                        {uwagiChips.map(([name, checked, label]) =>
                          ckChip(name, checked, label),
                        )}
                      </div>

                      {dataOdebraniaDokumentow && (
                        <Typography
                          variant="subtitle1"
                          style={{ fontSize: "16px", fontWeight: 600 }}
                        >
                          Odebranie dokumentów:{" "}
                          {formatDateTimeDisplay(dataOdebraniaDokumentow)}
                        </Typography>
                      )}

                      {dataOdebraniaDokumentowBox && (
                        <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                          <TextField
                            label="Wybierz datę i godzinę"
                            type="datetime-local"
                            value={dataOdebraniaDokumentow}
                            onChange={(event) =>
                              setDataOdebraniaDokumentow(event.target.value)
                            }
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ step: 60 }}
                          />
                        </div>
                      )}

                      {showErrorReportPrompt && (
                        <>
                          <Typography
                            variant="h6"
                            style={{ marginTop: "15px" }}
                          >
                            <strong>
                              *Wpisz treść powiadomienia o błędzie (wymagane):
                            </strong>
                          </Typography>
                          <textarea
                            value={errorReportMessage}
                            onChange={(e) =>
                              setErrorReportMessage(e.target.value)
                            }
                            rows={4}
                            cols={50}
                            placeholder="Opisz błąd..."
                            style={{
                              resize: "none",
                              marginTop: "10px",
                              marginBottom: "10px",
                            }}
                          />
                          <div>
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={handleSaveErrorReport}
                            >
                              Wyślij powiadomienie o błędzie
                            </Button>
                          </div>
                        </>
                      )}
                    </>,
                  )}

                {ckCard(
                  "finanse",
                  "Uwagi do działu finansowego",
                  ckCount(finanseChips),
                  <div className={classes.ckChips}>
                    {finanseChips.map(([name, checked, label]) =>
                      ckChip(name, checked, label),
                    )}
                  </div>,
                )}
              </div>

              <div className={classes.ckActionBar}>
                {showCommentPrompt ? (
                  <>
                    <Typography variant="subtitle1">
                      <strong>
                        *Napisz opis do znacznika (Komentarz jest wymagany).
                        Zapisując zmiany, dział finansowy zostanie poinformowany
                        mailowo.
                      </strong>
                    </Typography>
                    <textarea
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      rows={4}
                      placeholder="Wpisz komentarz"
                      style={{
                        resize: "none",
                        width: "100%",
                        boxSizing: "border-box",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    />
                    <Button
                      className={classes.ckSaveButton}
                      variant="contained"
                      color="primary"
                      onClick={handleSaveCommentAndCheckBox}
                    >
                      Zapisz komentarz oraz znacznik
                    </Button>
                  </>
                ) : (
                  <Button
                    className={classes.ckSaveButton}
                    variant="contained"
                    color="primary"
                    onClick={handleSaveCheckboxData}
                  >
                    Zapisz dane z checkboxów
                  </Button>
                )}
              </div>
            </div>
          )}
        {rowData &&
          rowData.rodzajTransportu !== "Magazyn Warszawa" &&
          rowData.rodzajTransportu !== "Magazyn Warszawa Zwroty i Błędy" &&
          rowData.rodzajTransportu !== "Magazyn Warszawa Handling" && (
            <>
              <EmailTable emails={emailData} />
              {/* <EmailConversationTable nrRef={nrRef} /> */}
            </>
          )}
        <div className={classes.cmCard}>
          <div className={classes.cmTitle}>Dodaj komentarz</div>

          <div className={classes.cmInfo}>
            {isNowyHandlingComment ? (
              <>
                Powiadomienie mailowe zostanie wysłane tylko wtedy, gdy
                uzupełnisz pole „Dodatkowi odbiorcy powiadomienia”. Puste pole =
                zapisze się sam komentarz.
              </>
            ) : (
              <>
                Powiadomienie mailowe zostanie automatycznie wysłane do{" "}
                {isMagazynWarszawaTransport
                  ? "osoby tworzącej"
                  : "os. przygotowującej oraz os. wysyłającej"}
                .
              </>
            )}
            {!isNowyHandlingComment && (
              <div style={{ marginTop: 4 }}>
                Otrzymają:{" "}
                <strong>
                  {!rowData
                    ? "..."
                    : automaticRecipientsWithoutCurrentUser.length > 0
                      ? automaticRecipientsWithoutCurrentUser.join(", ")
                      : "(brak automatycznych odbiorców)"}
                </strong>
              </div>
            )}
          </div>

          <label className={classes.cmLabel} htmlFor="detail-comment-text">
            Treść komentarza
          </label>
          <textarea
            id="detail-comment-text"
            className={classes.cmTextarea}
            value={comment}
            onChange={handleCommentChange}
            rows={5}
            placeholder="Wpisz swój komentarz..."
          />

          <div className={classes.cmLabelRow}>
            <span className={classes.cmLabel}>
              Dodatkowi odbiorcy powiadomienia (opcjonalnie)
            </span>
            <Tooltip
              title={
                rowData &&
                rowData.rodzajTransportu &&
                rowData.rodzajTransportu.startsWith("Magazyn Warszawa")
                  ? "Bez podania dodatkowych odbiorców, powiadomienie zostanie wysłane tylko do osoby tworzącej"
                  : "Bez podania dodatkowych odbiorców, powiadomienie zostanie wysłane tylko do: os.przygotowująca, os.wysyłająca"
              }
              arrow
              placement="right"
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: "14px",
                    maxWidth: "400px",
                  },
                },
              }}
            >
              <InfoIcon
                style={{
                  fontSize: "20px",
                  color: "#1976d2",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          </div>
          <div ref={autocompleteRef} style={{ width: "100%" }}>
            <Autocomplete
              key={additionalRecipients.length}
              multiple
              freeSolo
              clearOnBlur={false}
              autoHighlight
              selectOnFocus
              options={validLoginsList}
              value={additionalRecipients}
              onChange={handleAdditionalRecipientsChange}
              inputValue={inputValue}
              onInputChange={handleInputChange}
              filterOptions={filterOptions}
              ListboxProps={{
                sx: {
                  "& .MuiAutocomplete-option[aria-selected='true']": {
                    backgroundColor: "#bbdefb !important",
                  },
                  "& .MuiAutocomplete-option.Mui-focused": {
                    backgroundColor: "#bbdefb !important",
                  },
                  "& .MuiAutocomplete-option:hover": {
                    backgroundColor: "#e3f2fd !important",
                  },
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Wpisz lub wybierz loginy (oddziel przecinkami lub Enter)"
                  error={!!recipientsError}
                  size="small"
                  style={{
                    marginTop: "5px",
                    marginBottom: recipientsError ? "5px" : "10px",
                  }}
                  helperText="Możesz wpisać ręcznie (np: plomza,adobrowolska) lub wybrać z listy."
                />
              )}
            />
          </div>
          {recipientsError && (
            <Typography
              variant="caption"
              style={{
                color: "#f44336",
                marginBottom: "10px",
                display: "block",
                fontSize: "12px",
              }}
            >
              {recipientsError}
            </Typography>
          )}
          <div className={classes.cmFooter}>
            <Button
              className={classes.ckSaveButton}
              style={{ width: "auto", minWidth: 180 }}
              variant="contained"
              color="primary"
              onClick={handleSaveComment}
            >
              Zapisz
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

const osobyWeryfikujaceEksporty = [
  "adobrowolska",
  "bbrus",
  "dczernikowska",
  "pmunik",
  "pnowak",
  "pmichalska",
];

const DetailPage = () => {
  const location = useLocation();
  const classes = useStyles();
  const pageClasses = usePageStyles();
  const { nrRef, id } = useParams();
  const [rowData, setRowData] = useState(null);
  // Błąd pobierania danych zgłoszenia (zamiast wiecznego "Loading...").
  const [loadError, setLoadError] = useState(null);
  const [editField, setEditField] = useState(null);
  const [availableFields, setAvailableFields] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editedData, setEditedData] = useState({});
  // Zwiekszany po wyslaniu maila - wymusza odswiezenie listy "Wysłane maile z DutyStation" w CommentSection.
  const [emailRefreshToken, setEmailRefreshToken] = useState(0);
  // Blokada podwojnego kliniecia przycisku "Przekaż towar do wydania" (Nowy Handling).
  const [isReleasingNhGoods, setIsReleasingNhGoods] = useState(false);
  const [comments, setComments] = useState([]);
  const [uzytkownicyList, setUzytkownicyList] = useState([]);
  const [lokalizacjaList, setLokalizacjaList] = useState([]);
  const [urzadZgloszeniaList, setUrzadZgloszeniaList] = useState([]);
  const [urzadTranzytowyList, setUrzadTranzytowyList] = useState([]);
  const [urzadPrzeznaczeniaList, setUrzadPrzeznaczeniaList] = useState([]);
  const [importerList, setImporterList] = useState([]);
  const [eksporterList, setEksporterList] = useState([]);
  const [mwCompaniesList, setMwCompaniesList] = useState([]);
  const mwCompanyDict = useMemo(
    () => buildCompanyDict(mwCompaniesList),
    [mwCompaniesList],
  );
  const [adresaciList, setAdresaciList] = useState([]);
  const adresaciDict = useMemo(
    () => buildCompanyDict(adresaciList),
    [adresaciList],
  );
  const [importerSearchTerm, setImporterSearchTerm] = useState("");
  const [eksporterSearchTerm, setEksporterSearchTerm] = useState("");
  const [isSplitModalOpen, setIsSplitModalOpen] = useState(false);
  const token = localStorage.getItem("token");
  const mailNotificationPrefix = "[POWIADOMIENIE_MAILOWE]";
  let username; // Deklaracja zmiennej na wyższym poziomie zakresu
  let role; // Jeśli 'role' jest również używana później
  const [openInvoiceDialog, setOpenInvoiceDialog] = useState(false);
  const [openUrzadZgloszeniaDialog, setOpenUrzadZgloszeniaDialog] =
    useState(false);
  const [selectedUrzadZgloszenia, setSelectedUrzadZgloszenia] = useState("");
  const [selectedLokalizacjaTowaruDialog, setSelectedLokalizacjaTowaruDialog] =
    useState("");
  const [urzadSearchTerm, setUrzadSearchTerm] = useState("");
  const [lokalizacjaSearchTerm, setLokalizacjaSearchTerm] = useState("");
  const [isMailNotificationDialogOpen, setIsMailNotificationDialogOpen] =
    useState(false);
  const [mailNotificationText, setMailNotificationText] = useState("");
  const [
    mailNotificationArchiveConfirmed,
    setMailNotificationArchiveConfirmed,
  ] = useState(false);
  const [mailNotificationDirection, setMailNotificationDirection] =
    useState("przychodzacy");

  const handleOpenInvoiceDialog = () => setOpenInvoiceDialog(true);
  const handleCloseInvoiceDialog = () => setOpenInvoiceDialog(false);
  const handleSaveInvoices = (value) => {
    setEditedData((prev) => ({
      ...prev,
      nrFaktury: value,
    }));
    setOpenInvoiceDialog(false);
  };

  const handleCloseUrzadZgloszeniaDialog = () => {
    setOpenUrzadZgloszeniaDialog(false);
    setSelectedUrzadZgloszenia("");
    setSelectedLokalizacjaTowaruDialog("");
    setUrzadSearchTerm("");
    setLokalizacjaSearchTerm("");
  };

  const handleConfirmUrzadZgloszeniaDialog = async () => {
    if (isUrzadZgloszeniaMissing && !selectedUrzadZgloszenia.trim()) {
      toast.error("Wybierz Urząd zgłoszenia.");
      return;
    }

    if (isLokalizacjaTowaruMissing && !selectedLokalizacjaTowaruDialog.trim()) {
      toast.error("Wybierz Lokalizację towaru.");
      return;
    }

    setOpenUrzadZgloszeniaDialog(false);
    await handleEditSave(null, true);
  };

  const filteredUrzadZgloszeniaOptions = urzadZgloszeniaList.filter((item) =>
    String(item.name || "")
      .toLowerCase()
      .includes(urzadSearchTerm.toLowerCase()),
  );

  const filteredLokalizacjaOptions = lokalizacjaList.filter((item) =>
    String(item.name || "")
      .toLowerCase()
      .includes(lokalizacjaSearchTerm.toLowerCase()),
  );

  const selectedRodzajForEdit = editedData.rodzaj || rowData?.rodzaj || "";
  const isImporterListMode = importTypes.includes(selectedRodzajForEdit);
  const isEksporterListMode = exportTypes.includes(selectedRodzajForEdit);

  const filteredImporterOptions = importerList.filter((item) =>
    String(item || "")
      .toLowerCase()
      .includes(importerSearchTerm.toLowerCase()),
  );

  const filteredEksporterOptions = eksporterList.filter((item) =>
    String(item || "")
      .toLowerCase()
      .includes(eksporterSearchTerm.toLowerCase()),
  );

  const isUrzadZgloszeniaMissing = !(
    editedData.urzadZgloszenia ||
    rowData?.urzadZgloszenia ||
    ""
  ).trim();
  const isLokalizacjaTowaruMissing = !(
    editedData.lokalizacjaTowaru ||
    rowData?.lokalizacjaTowaru ||
    ""
  ).trim();

  if (token) {
    const decoded = jwtDecode(token);
    username = decoded.username; // Przypisanie do wcześniej zadeklarowanej zmiennej
    role = decoded.role; // Przypisanie do wcześniej zadeklarowanej zmiennej
  }

  const importRodzajURL =
    "https://acwegacom.sharepoint.com/sites/AgencjaCelnaWega-ASp.zo.o/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FAgencjaCelnaWega%2DASp%2Ezo%2Eo%2FShared%20Documents%2FPRZYW%C3%93Z&viewid=c9ebcf23%2Dd938%2D4dfc%2D8ef2%2D74695f94ddee";
  const eksportRodzajURL =
    "https://acwegacom.sharepoint.com/sites/AgencjaCelnaWega-ASp.zo.o/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FAgencjaCelnaWega%2DASp%2Ezo%2Eo%2FShared%20Documents%2FWYW%C3%93Z&viewid=c9ebcf23%2Dd938%2D4dfc%2D8ef2%2D74695f94ddee";

  const navigate = useNavigate();

  async function fetchComments() {
    try {
      const response = await axios.get(`${BASE_URL}/comments/${id}`, {
        headers: headers,
      });
      setComments(response.data);
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  }

  const handleCommentSectionDataRefresh = async () => {
    await Promise.all([fetchComments(), fetchRowData()]);
  };

  const isMailNotificationComment = (commentText = "") =>
    String(commentText).startsWith(mailNotificationPrefix);

  // Kierunek nie może być kodowany w osobnym prefiksie, bo backend
  // (sendCommentEmail.js) rozpoznaje mail powiadomienia wyłącznie po
  // dokładnym prefiksie mailNotificationPrefix i na tej podstawie dobiera
  // szablon/temat maila "Otrzymano wiadomość mailową". Dlatego kierunek
  // jest odczytywany z linii "Kierunek: ..." w treści komentarza.
  const getMailNotificationDirection = (commentText = "") => {
    if (!isMailNotificationComment(commentText)) {
      return null;
    }
    return /Kierunek:\s*Mail wychodzący/i.test(String(commentText))
      ? "wychodzacy"
      : "przychodzacy";
  };

  const getDisplayedCommentText = (commentText = "") => {
    if (!isMailNotificationComment(commentText)) {
      return commentText;
    }
    return String(commentText).replace(mailNotificationPrefix, "").trim();
  };

  // Kolor awatara zależny od loginu autora (ten sam autor = ten sam kolor).
  const COMMENT_AVATAR_COLORS = [
    "#1976d2",
    "#388e3c",
    "#7b1fa2",
    "#f57c00",
    "#0097a7",
    "#c2185b",
    "#5d4037",
  ];
  const getCommentAvatarColor = (username = "") => {
    const hash = [...String(username)].reduce(
      (acc, ch) => acc + ch.charCodeAt(0),
      0,
    );
    return COMMENT_AVATAR_COLORS[hash % COMMENT_AVATAR_COLORS.length];
  };

  // Jeden komentarz na liście. Powiadomienia mailowe (przychodzące/wychodzące)
  // zachowują dotychczasowy wygląd, zwykłe komentarze są kartą z awatarem autora.
  const renderCommentItem = (comment) => {
    const isMailNotification = isMailNotificationComment(comment.comment);
    const mailDirection = getMailNotificationDirection(comment.comment);
    const isOutgoingMail = mailDirection === "wychodzacy";

    if (!isMailNotification) {
      const author = String(comment.username ?? "");
      return (
        <div key={comment.id} className={classes.ccItem}>
          <div className={classes.ccHeader}>
            <span
              className={classes.ccAvatar}
              style={{ backgroundColor: getCommentAvatarColor(author) }}
              aria-hidden="true"
            >
              {(author.charAt(0) || "?").toUpperCase()}
            </span>
            <span className={classes.ccAuthor}>{author || "—"}</span>
            <span className={classes.ccDate}>
              {moment(comment.created_at).format("HH:mm, DD-MM-YYYY")}
            </span>
          </div>
          <div className={classes.ccText}>
            {getDisplayedCommentText(comment.comment)}
          </div>
        </div>
      );
    }

    return (
      <div
        key={comment.id}
        className={`${classes.mailCard} ${
          isOutgoingMail ? classes.mailCardOutgoing : classes.mailCardIncoming
        }`}
      >
        <div className={classes.mailCardHeader}>
          <span className={classes.mailBadge}>
            <span aria-hidden="true">{isOutgoingMail ? "↗" : "↙"}</span>
            {isOutgoingMail ? "Mail wychodzący" : "Mail przychodzący"}
          </span>
          <span className={classes.ccDate}>
            {moment(comment.created_at).format("HH:mm, DD-MM-YYYY")}
          </span>
        </div>
        <div className={classes.ccText}>
          {getDisplayedCommentText(comment.comment)}
        </div>
        <div className={classes.mailCardFooter}>
          Odnotował(a): <strong>{comment.username || "—"}</strong>
        </div>
      </div>
    );
  };

  const handleRecordMailNotification = () => {
    setMailNotificationText("");
    setMailNotificationArchiveConfirmed(false);
    setMailNotificationDirection("przychodzacy");
    setIsMailNotificationDialogOpen(true);
  };

  const handleCloseMailNotificationDialog = () => {
    setIsMailNotificationDialogOpen(false);
    setMailNotificationText("");
    setMailNotificationArchiveConfirmed(false);
    setMailNotificationDirection("przychodzacy");
  };

  const handleSaveMailNotification = async () => {
    if (!mailNotificationText.trim()) {
      toast.error("Wpisz treść maila.");
      return;
    }

    if (
      mailNotificationDirection === "przychodzacy" &&
      !mailNotificationArchiveConfirmed
    ) {
      toast.error(
        "Zaznacz, że pamiętasz o archiwizacji maila w katalogu do plików.",
      );
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const username = decoded.username;
      const nowInWarsaw = moment.tz("Europe/Warsaw");
      const timestamp = nowInWarsaw.format();
      const displayTimestamp = nowInWarsaw.format("HH:mm, DD-MM-YYYY");

      const recipients = [
        rowData.osobaPrzygotowujacaOdprawe,
        rowData.osobaMonitorujacaOdprawe,
      ]
        .map((recipient) => String(recipient || "").trim())
        .filter(Boolean)
        .filter((recipient) => recipient !== username);

      const uniqueRecipients = [...new Set(recipients)];
      const recipientsSummary =
        uniqueRecipients.length > 0
          ? uniqueRecipients.join(", ")
          : "brak (brak odbiorców lub próba wysyłki do siebie)";

      const isOutgoing = mailNotificationDirection === "wychodzacy";
      const notificationDirectionLabel = isOutgoing
        ? "Mail wychodzący"
        : "Mail przychodzący";

      // Prefiks musi zostać taki sam dla obu kierunków - backend
      // (sendCommentEmail.js) po nim rozpoznaje powiadomienie mailowe
      // i wysyła e-mail z szablonem "Otrzymano wiadomość mailową".
      const notificationComment = `${mailNotificationPrefix}\nOdnotowano wiadomość mailową w sprawie.\nKierunek: ${notificationDirectionLabel}\nData i godzina: ${displayTimestamp}\nKliknięte przez: ${username}\nOdbiorcy wiadomości: ${recipientsSummary}\nTreść maila:\n${mailNotificationText.trim()}`;

      if (uniqueRecipients.length > 0) {
        await axios.post(
          `${BASE_URL}/comments/addWithNotification`,
          {
            id,
            comment: notificationComment,
            username,
            recipients: uniqueRecipients,
            timestamp,
            nrRef: rowData.nrRef,
            rodzajTransportu: rowData.rodzajTransportu,
            statusRealizacji: rowData.statusRealizacji,
            rodzaj: rowData.rodzaj,
            importer: rowData.importer,
            eksporter: rowData.eksporter,
          },
          { headers },
        );

        toast.success(
          "Odnotowano powiadomienie mailowe i wysłano e-maile do przypisanych osób.",
        );
      } else {
        await axios.post(
          `${BASE_URL}/comments/${id}`,
          {
            comment: notificationComment,
            username,
          },
          { headers },
        );

        toast.info(
          "Odnotowano powiadomienie mailowe. E-mail nie został wysłany (brak odbiorców lub próba wysyłki do siebie).",
        );
      }

      handleCloseMailNotificationDialog();
      await handleCommentSectionDataRefresh();
    } catch (error) {
      console.error("Error recording mail notification:", error);
      const backendMessage = error.response?.data?.message;
      toast.error(
        backendMessage ||
          "Wystąpił błąd podczas odnotowywania powiadomienia mailowego.",
      );
    }
  };

  const processRowData = async (rowData) => {
    if (rowData.rodzajTransportu !== "Kurier MU MAN zakład") {
      if (
        rowData.rodzajTransportu === "Kurier" &&
        rowData.lokalizacjaTowaru === "MU MAN zakład"
      ) {
        try {
          // Tutaj tworzymy ciało żądania zawierające tylko id i rodzaj
          const requestBody = {
            rodzaj: "Kurier MU MAN zakład",
          };

          const response = await axios.put(
            `${BASE_URL}/updateRodzajKurierMan/${id}`,
            requestBody,
            {
              headers: headers, // Zakładam, że `headers` są zdefiniowane gdzieś wcześniej
            },
          );
        } catch (error) {
          console.error("Błąd podczas aktualizacji danych:", error);
        }
      }
    }
  };

  // Funkcja do pobierania danych o tym czy w liscie kontrolenej jest wybrany przelew jako metoda platnosci
  const fetchPrzelew = (id, rodzaj, headers) => {
    return new Promise(async (resolve, reject) => {
      try {
        const przywozRodzaje = [
          "Import",
          "Import - wpis do rejestru",
          "Wprowadzenie na skład",
          "Uszlachetnianie czynne",
          "Powrotny przywóz",
          "Odprawa czasowa import",
        ];

        if (przywozRodzaje.includes(rodzaj)) {
          const endpoint = `${BASE_URL}/przywoz_zwykly/przelew/${id}`;
          const response = await axios.get(endpoint, {
            headers: headers,
          });

          const data = response.data; // Zwracamy pełny obiekt, nie data[0]
          resolve(data);
        } else {
          console.warn("Nieprawidłowy rodzaj dla przywozu.");
          resolve(null); // Nie przerywa działania komponentu
        }
      } catch (error) {
        console.error("Error in fetchPrzelew:", error);
        reject(error);
      }
    });
  };

  // Funkcja do pobierania danych
  function fetchRowData() {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.get(`${BASE_URL}/detail/${nrRef}/${id}`, {
          headers: headers,
        });

        const rowData = response.data?.[0];
        if (!rowData) {
          console.error("Brak danych w odpowiedzi serwera");
          reject(new Error("Brak danych w odpowiedzi serwera"));
          return;
        }

        setRowData(rowData);

        const rodzaj = rowData.rodzaj;
        if (!rodzaj) {
          console.warn("Nieprawidłowy rodzaj dla przywozu.");
          rowData.przelew = false; // Ustawienie domyślnej wartości
          resolve(rowData);
          return;
        }

        // Pobieranie danych przelewu
        const przelewData = await fetchPrzelew(id, rodzaj, headers);
        if (!przelewData || typeof przelewData.przelew === "undefined") {
          console.warn("Brak danych przelewu lub niepoprawne dane.");
          rowData.przelew = false; // Domyślna wartość
        } else {
          rowData.przelew = przelewData.przelew ? 1 : false;
        }

        await processRowData(rowData);
        resolve(rowData);
      } catch (error) {
        console.error("Error in fetchRowData:", error);
        reject(error);
      }
    });
  }

  const handleUsersChange = async () => {
    setTimeout(async () => {
      try {
        const response = await axios.get(`${BASE_URL}/list/uzytkownicy`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        // Sortujemy listę alfabetycznie według pola 'username'
        const sortedUsers = response.data.sort((a, b) =>
          a.name.localeCompare(b.name),
        );

        setUzytkownicyList(sortedUsers);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }, 100);
  };

  const handleUrzadTranzytowyChange = async () => {
    setTimeout(async () => {
      try {
        const response = await axios.get(`${BASE_URL}/list/urzad_tranzytowy`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        // Sort the data alphabetically by name using localeCompare
        const sortedData = response.data.sort((a, b) => {
          return a.name.localeCompare(b.name, "pl", { sensitivity: "base" });
        });

        setUrzadTranzytowyList(sortedData); // Set the filtered list
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }, 100);
  };

  const handleUrzadPrzeznaczeniaChange = async () => {
    setTimeout(async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/list/urzad_przeznaczenia`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );

        // Sort the data alphabetically by name using localeCompare
        const sortedData = response.data.sort((a, b) => {
          return a.name.localeCompare(b.name, "pl", { sensitivity: "base" });
        });

        setUrzadPrzeznaczeniaList(sortedData); // Set the filtered list
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }, 100);
  };

  const handleLokalizacjaChange = async () => {
    setTimeout(async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/list/lokalizacjaTransportow`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );

        // Zakładamy, że dane to tablica obiektów i sortujemy według klucza 'nazwa'
        const sortedData = response.data.sort((a, b) =>
          a.name.localeCompare(b.name),
        );

        setLokalizacjaList(sortedData);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }, 100);
  };

  const handleUrzadZgloszeniaChange = async () => {
    setTimeout(async () => {
      try {
        const response = await axios.get(`${BASE_URL}/list/urzadZgloszenia`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        const sortedData = response.data.sort((a, b) =>
          a.name.localeCompare(b.name, "pl", { sensitivity: "base" }),
        );

        setUrzadZgloszeniaList(sortedData);
      } catch (error) {
        console.error("Error fetching urzad zgloszenia list:", error);
      }
    }, 100);
  };

  const handleImporterListChange = async () => {
    setTimeout(async () => {
      try {
        const response = await axios.get(`${BASE_URL}/list/importerImport`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        const sortedImporters = response.data
          .map((item) => item.name)
          .sort((a, b) => {
            const prefix = "OS. F";
            const aStartsWithPrefix = a.startsWith(prefix);
            const bStartsWithPrefix = b.startsWith(prefix);

            if (aStartsWithPrefix && !bStartsWithPrefix) {
              return 1;
            }

            if (!aStartsWithPrefix && bStartsWithPrefix) {
              return -1;
            }

            return a.localeCompare(b, "pl", { sensitivity: "base" });
          });

        setImporterList(sortedImporters);
      } catch (error) {
        console.error("Error fetching importers:", error);
      }
    }, 100);
  };

  const handleEksporterListChange = async () => {
    setTimeout(async () => {
      try {
        const response = await axios.get(`${BASE_URL}/list/eksporterEksport`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        const sortedEksporters = response.data
          .map((item) => item.name)
          .sort((a, b) => a.localeCompare(b, "pl", { sensitivity: "base" }));

        setEksporterList(sortedEksporters);
      } catch (error) {
        console.error("Error fetching eksporters:", error);
      }
    }, 100);
  };

  // Slownik firm "Magazyn Warszawa" - to samo zrodlo co w formularzu tworzenia
  // (pole Nazwa firmy w sekcji Przyjęcie uzywa komponentu CompanyCell).
  const fetchMwCompanies = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/list/listMagazynWarszawa`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      const list = (response.data || [])
        .map((item) => item.name)
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b, "pl", { sensitivity: "base" }));
      setMwCompaniesList(list);
    } catch (error) {
      console.error("Błąd przy pobieraniu listy firm Magazyn Warszawa:", error);
    }
  };

  const handleAddMwCompany = async (rawName) => {
    const name = (rawName || "").trim();
    if (!name) throw new Error("Pusta nazwa firmy");
    const canonical = name.toUpperCase();

    await axios.post(
      `${BASE_URL}/add-record/listMagazynWarszawa`,
      { name },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      },
    );

    setMwCompaniesList((prev) =>
      prev.some((c) => c.toUpperCase() === canonical)
        ? prev
        : [...prev, canonical].sort((a, b) =>
            a.localeCompare(b, "pl", { sensitivity: "base" }),
          ),
    );
    toast.success(`Dodano firmę do bazy: ${canonical}`, { autoClose: 2500 });
    return canonical;
  };

  // Slownik adresatow powiadomien "problem z przesylka" - zachowuje pisownie
  // wpisana przez uzytkownika (e-mail / imie i nazwisko), nie podnosi do wielkich liter.
  const fetchAdresaci = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/list/adresaciProblemPrzesylki`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );
      const list = (response.data || [])
        .map((item) => item.name)
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b, "pl", { sensitivity: "base" }));
      setAdresaciList(list);
    } catch (error) {
      console.error("Błąd przy pobieraniu listy adresatów:", error);
    }
  };

  const handleAddAdresat = async (rawName) => {
    const name = (rawName || "").trim();
    if (!name) throw new Error("Pusty adresat");

    await axios.post(
      `${BASE_URL}/add-record/adresaciProblemPrzesylki`,
      { name },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      },
    );

    setAdresaciList((prev) =>
      prev.some((a) => a.toLowerCase() === name.toLowerCase())
        ? prev
        : [...prev, name].sort((a, b) =>
            a.localeCompare(b, "pl", { sensitivity: "base" }),
          ),
    );
    toast.success(`Dodano adresata: ${name}`, { autoClose: 2500 });
    return name;
  };

  const updateRodzajTransport = (rowData) => {
    return new Promise(async (resolve, reject) => {
      try {
        // Najpierw sprawdzamy czy to Magazyn Warszawa - jeśli tak, w ogóle nie wykonujemy aktualizacji
        if (
          rowData.rodzajTransportu === "Magazyn Warszawa" ||
          rowData.rodzajTransportu === "Magazyn Warszawa Zwroty i Błędy" ||
          rowData.rodzajTransportu === "Magazyn Warszawa Handling" ||
          rowData.rodzajTransportu === "Magazyn Warszawa Nowy Handling"
        ) {
          resolve("Skip update for Magazyn Warszawa");
          return;
        }

        // Sprawdzamy pozostałe warunki tylko jeśli to NIE jest Magazyn Warszawa
        if (
          rowData.statusRealizacji === "Zrealizowane" ||
          rowData.statusRealizacji === "Unieważnione przez OC" ||
          rowData.statusRealizacji === "Anulowane" ||
          rowData.statusRealizacji === "Tranzyt zakończony"
        ) {
          const token = localStorage.getItem("token");
          const decoded = jwtDecode(token);
          const username = decoded.username;

          const formattedDate = moment
            .tz("Europe/Warsaw")
            .format("YYYY-MM-DDTHH:mm:ss");

          const updateData = {
            id: rowData.id,
            rodzajTransportu: "Zakończono",
          };

          const updateData1 = {
            id: rowData.id,
            endDate: formattedDate,
          };

          await axios.put(`${BASE_URL}/update/${updateData.id}`, updateData, {
            headers: {
              username: username,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          });

          await axios.put(`${BASE_URL}/update/${updateData1.id}`, updateData1, {
            headers: {
              username: username,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          });

          toast.success("Poprawnie zaktualizowany status zgłoszenia!");
          toast.success("Poprawnie zaktualizowany date zakończenia!");
          resolve("Data updated successfully");
        } else {
          resolve("No update needed");
        }
      } catch (error) {
        reject(error);
      }
    });
  };

  const loadRowData = async () => {
    setLoadError(null);
    try {
      await fetchRowData();
    } catch (error) {
      const status = error?.response?.status;
      setLoadError(
        status === 401 || status === 403
          ? "Sesja wygasła lub brak uprawnień. Zaloguj się ponownie."
          : "Nie udało się wczytać danych zgłoszenia.",
      );
    }
  };

  useEffect(() => {
    if (id) {
      loadRowData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (rowData) {
      const fields = Object.keys(rowData);
      setAvailableFields(fields);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData]);

  useEffect(() => {
    fetchComments();
    handleLokalizacjaChange();
    handleUrzadZgloszeniaChange();
    handleUsersChange();
    handleUrzadTranzytowyChange();
    handleUrzadPrzeznaczeniaChange();
    handleImporterListChange();
    handleEksporterListChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (rowData?.rodzajTransportu === "Magazyn Warszawa Nowy Handling") {
      fetchMwCompanies();
      fetchAdresaci();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData?.rodzajTransportu]);

  const handleFieldSelect = (field) => {
    setEditField(field);
    setIsEditing(true);
    if (field === "importer") {
      setImporterSearchTerm("");
    }
    if (field === "eksporter") {
      setEksporterSearchTerm("");
    }
    setEditedData((prevEditedData) => ({
      ...prevEditedData,
      [field]: rowData[field] || "",
    }));
  };
  const handleInputChange = (event) => {
    let { name, value } = event.target;

    if (name === "kwota_gwarancji") {
      value = value.replace(",", ".");
      value = value.replace(/[^0-9.]/g, "");
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join(""); // Usuwa nadmiar kropek
      }
      if (parts[1]?.length > 6) {
        value = parts[0] + "." + parts[1].slice(0, 6);
      }
    }

    // Sprawdzenie, czy wartość faktycznie się zmienia
    if (name !== "data" || (name === "data" && value !== rowData.data)) {
      setEditedData((prevEditedData) => ({
        ...prevEditedData,
        [name]: value,
      }));
    }
  };

  const notify1 = () => {
    toast.success("Poprawnie zedytowano dane!", {
      autoClose: 1000, // Set autoClose to the number of milliseconds you want the notification to be visible, in this case, 1 second
    });
  };

  // "Nowy Handling", scenariusz "auto przyjechalo przed cleniem": w statusie
  // "Oclono" (odprawa celna zamknieta) z wpisanym "Podjazd auta" nie ma juz pola
  // do uzupelnienia, ktore ruszyloby status dalej - robi to ten przycisk.
  const handleNhReleaseGoods = async () => {
    if (!rowData || !canReleaseNhGoods(rowData) || isReleasingNhGoods) return;
    setIsReleasingNhGoods(true);
    try {
      const token = localStorage.getItem("token");
      const username = jwtDecode(token).username;
      await axios.put(
        `${BASE_URL}/update/${id}`,
        { statusRealizacji: "Towar do wydania" },
        {
          headers: {
            username: username,
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      setRowData((prev) => ({
        ...prev,
        statusRealizacji: "Towar do wydania",
      }));
      toast.info("Status zmieniony na „Towar do wydania”.", {
        autoClose: 2500,
      });
    } catch (error) {
      console.error("Nie udało się przekazać towaru do wydania:", error);
      toast.error("Nie udało się zmienić statusu na „Towar do wydania”.");
    } finally {
      setIsReleasingNhGoods(false);
    }
  };

  async function fetchData(id, rodzaj) {
    let verificationResponse, przygotowaneResponse;

    switch (rodzaj) {
      case "Import":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-przywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-przywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;

      case "Eksport":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;

      case "Wyprowadzenie ze składu":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;

      case "Wprowadzenie na skład":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-przywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-przywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;

      case "Uszlachetnianie czynne":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-przywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-przywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;

      case "Uszlachetnianie bierne":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;

      case "Powrotny przywóz":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-przywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-przywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;

      case "Odprawa czasowa import":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-przywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-przywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;

      case "Powrotny wywóz":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;

      case "Odprawa czasowa eksport":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;

      case "Eksport - wpis do rejestru":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;

      case "Import - wpis do rejestru":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-przywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-przywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;

      case "Eksport PL i import inny kraj":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-wywoz/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;
      case "Tranzyt":
        verificationResponse = await axios.get(
          `${BASE_URL}/get-verification-status-tranzyt/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        przygotowaneResponse = await axios.get(
          `${BASE_URL}/get-przygotowane-status-tranzyt/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        break;
      default:
        throw new Error("Unsupported rodzaj value");
    }

    return {
      verificationData: verificationResponse.data,
      przygotowaneData: przygotowaneResponse.data,
    };
  }

  const updateGwarantStatusIfNeeded = async (rowData, id, username) => {
    if (
      rowData.rodzaj === "Tranzyt" &&
      rowData.statusRealizacji === "Wysłane" &&
      rowData.nr_ref_gwaranta &&
      !rowData.gwarantUpdated // zakładam, że masz flagę w bazie, jeśli nie, usuń ten warunek
    ) {
      try {
        await axios.put(
          `${BASE_URL}/update/${id}`,
          { statusRealizacji: "Przyjęte przez Gwaranta", gwarantUpdated: true },
          {
            headers: {
              username,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );
        toast.success("Status zmieniony na 'Przyjęte przez Gwaranta'");
      } catch (error) {
        console.error("Błąd aktualizacji statusu gwaranta:", error);
        toast.error("Błąd aktualizacji statusu gwaranta.");
      }
    }
  };

  const updateWyslanoDoUrzeduStatusIfNeeded = async (rowData, id, username) => {
    if (
      rowData.rodzaj === "Tranzyt" &&
      rowData.statusRealizacji === "Przyjęte przez Gwaranta" &&
      rowData.nr_LRN &&
      !rowData.LRNUpdate // zakładam, że masz flagę w bazie, jeśli nie, usuń ten warunek
    ) {
      try {
        await axios.put(
          `${BASE_URL}/update/${id}`,
          { statusRealizacji: "Wysłano do urzędu", LRNUpdate: true },
          {
            headers: {
              username,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );
        toast.success("Status zmieniony na 'Wysłano do urzędu'");
      } catch (error) {
        console.error("Błąd aktualizacji statusu Wysłano do urzędu:", error);
        toast.error("Błąd aktualizacji statusu Wysłano do urzędu.");
      }
    }
  };

  const updateZwolnionoDoTranzytuStatusIfNeeded = async (
    rowData,
    id,
    username,
  ) => {
    if (
      rowData.rodzaj === "Tranzyt" &&
      rowData.statusRealizacji === "Wysłano do urzędu" &&
      rowData.MRN &&
      !rowData.MRNUpdate // zakładam, że masz flagę w bazie, jeśli nie, usuń ten warunek
    ) {
      try {
        await axios.put(
          `${BASE_URL}/update/${id}`,
          { statusRealizacji: "Zwolniono do tranzytu", MRNUpdate: true },
          {
            headers: {
              username,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );
        toast.success("Status zmieniony na 'Zwolniono do tranzytu'");
      } catch (error) {
        console.error(
          "Błąd aktualizacji statusu Zwolniono do tranzytu:",
          error,
        );
        toast.error("Błąd aktualizacji statusu Zwolniono do tranzytu.");
      }
    }
  };

  const updateTranzytZakończonyStatusIfNeeded = async (
    rowData,
    id,
    username,
  ) => {
    if (
      rowData.rodzaj === "Tranzyt" &&
      rowData.statusRealizacji === "Zwolniono do tranzytu" &&
      rowData.data_ie &&
      !rowData.dataIeUpdated // zakładam, że masz flagę w bazie, jeśli nie, usuń ten warunek
    ) {
      try {
        await axios.put(
          `${BASE_URL}/update/${id}`,
          { statusRealizacji: "Tranzyt zakończony", dataIeUpdated: true },
          {
            headers: {
              username,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );
        toast.success("Status zmieniony na 'Tranzyt zakończony'");
      } catch (error) {
        console.error("Błąd aktualizacji statusu Tranzyt zakończony:", error);
        toast.error("Błąd aktualizacji statusu Tranzyt zakończony.");
      }
    }
  };

  const handleUpdateClick = async (id) => {
    try {
      await axios.put(
        `${BASE_URL}/update/${id}`,
        {
          statusRealizacji: "Do przygotowania",
          rodzajTransportu: "W drodze",
          endDate: null,
        },
        {
          headers: {
            username,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );
      toast.success("Poprawnie przywrócono zgłoszenie");
      // tutaj ewentualnie dodaj jakąś informację zwrotną (np. snackbar)
    } catch (error) {
      console.error("Błąd przy aktualizacji:", error);
    }
  };

  const handleEditSave = async (event, skipUrzadZgloszeniaDialog = false) => {
    if (event) {
      event.preventDefault();
    }
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const username = decoded.username;
    const role = decoded.role;
    try {
      if (rowData.rodzajTransportu === "Magazyn Warszawa") {
        // Blokada zmiany statusu na Zrealizowane jeśli wymagane pola są puste
        // Używamy połączonych danych z rowData i editedData
        const currentData = { ...rowData, ...editedData };

        if (
          editedData.statusRealizacji === "Zrealizowane" &&
          (!currentData.MRN ||
            !currentData.iloscPozycjiSAD ||
            !currentData.rewizja ||
            !currentData.serwisLotniczy ||
            // tylko jeśli serwisLotniczy NIE jest "Tak", sprawdzaj też kierunek
            (currentData.serwisLotniczy !== "Tak" && !currentData.kierunek))
        ) {
          toast.error(
            "Aby zmienić status na Zrealizowane, pola MRN, Ilość pozycji SAD, Rewizja oraz Serwis lotniczy muszą być wypełnione. Dodatkowo pole Kierunek jest wymagane, jeśli Serwis lotniczy nie ma wartości 'Tak'.",
          );
          return;
        }

        // Walidacja formatu MRN
        const mrnRegex = /^(2[5-9]|[3-9][0-9])PL[A-Z0-9]{14,16}$/;
        if (editedData.MRN && !mrnRegex.test(editedData.MRN)) {
          toast.error(
            "Pole MRN musi zaczynać się od '25PL', zawierać od 18 do 20 znaków alfanumerycznych (bez spacji i znaków specjalnych).",
          );
          return;
        }

        // Walidacja długości numeru listu
        if (editedData.numerListu && editedData.numerListu.length !== 14) {
          toast.error("Numer listu przewozowego musi mieć dokładnie 14 znaków");
          return;
        }

        // Sprawdzenie czy numer listu już istnieje w bazie (tylko jeśli został zmieniony)
        if (
          editedData.numerListu &&
          editedData.numerListu !== rowData.numerListu
        ) {
          try {
            const checkResponse = await axios.get(
              `${BASE_URL}/check-numer-listu-magazyn-warszawa`,
              {
                params: {
                  numerListu: editedData.numerListu,
                  rodzajTransportu: rowData.rodzajTransportu,
                },
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "application/json",
                },
              },
            );

            if (checkResponse.data.exists) {
              toast.error(checkResponse.data.message, {
                autoClose: 3000,
              });
              return;
            }
          } catch (err) {
            console.error(
              "Błąd podczas sprawdzania numeru listu przewozowego:",
              err,
            );
            toast.error(
              "Wystąpił błąd podczas sprawdzania numeru listu przewozowego",
            );
            return;
          }
        }

        // Sprawdzenie czy MRN już istnieje w bazie
        if (editedData.MRN) {
          try {
            const checkResponse = await axios.get(`${BASE_URL}/check-mrn`, {
              params: { MRN: editedData.MRN },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
              },
            });

            if (checkResponse.data.exists) {
              toast.error("Numer MRN już istnieje w bazie danych.");
              return;
            }
          } catch (err) {
            console.error("Błąd podczas sprawdzania numeru MRN:", err);
            toast.error("Wystąpił błąd podczas sprawdzania numeru MRN");
            return;
          }
        }

        // Funkcja sprawdzająca czy wszystkie wymagane pola są wypełnione
        const checkRequiredFields = () => {
          const updatedData = {
            ...rowData,
            ...editedData,
          };
          return (
            updatedData.MRN &&
            updatedData.iloscPozycjiSAD &&
            updatedData.Rewizja &&
            updatedData.statusRealizacji === "Do przygotowania" &&
            updatedData.serwisLotniczy &&
            // tylko jeśli serwisLotniczy NIE jest "Tak", sprawdzaj też kierunek
            (updatedData.serwisLotniczy === "Tak" || updatedData.kierunek)
          );
        };

        // Automatyczna zmiana statusu jeśli wszystkie pola są wypełnione
        const shouldAutoUpdateStatus = checkRequiredFields();

        const formattedDate = moment
          .tz("Europe/Warsaw")
          .format("YYYY-MM-DDTHH:mm:ss");
        const currentDate = moment
          .tz("Europe/Warsaw")
          .format("YYYY-MM-DDTHH:mm:ss");

        const updateData = {
          ...editedData,
          ...(shouldAutoUpdateStatus && {
            statusRealizacji: "Zrealizowane",
            endDate: formattedDate,
          }),
          // Dodaj utworzono tylko jeśli MRN jest edytowane
          ...(editedData.MRN && editedData.MRN !== rowData.MRN
            ? { utworzono: currentDate }
            : {}),
        };

        await axios.put(`${BASE_URL}/update/${id}`, updateData, {
          headers: {
            username: username,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        if (shouldAutoUpdateStatus) {
          toast.success("Status automatycznie zmieniony na Zrealizowane");
        }

        notify1();
        setEditField(null);
        setIsEditing(false);
        setEditedData({});
        setRowData((prev) => ({
          ...prev,
          ...updateData,
        }));

        return;
      } else if (
        rowData.rodzajTransportu === "Magazyn Warszawa Zwroty i Błędy"
      ) {
        // Walidacja długości numeru listu przewozowego
        if (editedData.numerListu && editedData.numerListu.length !== 14) {
          toast.error("Numer listu przewozowego musi mieć dokładnie 14 znaków");
          return;
        }

        // Sprawdzenie czy numer listu przewozowego już istnieje (tylko jeśli został zmieniony)
        if (
          editedData.numerListu &&
          editedData.numerListu !== rowData.numerListu
        ) {
          try {
            const checkResponse = await axios.get(
              `${BASE_URL}/check-numer-listu-magazyn-warszawa-zwroty-i-bledy`,
              {
                params: {
                  numerListu: editedData.numerListu,
                  rodzajTransportu: rowData.rodzajTransportu,
                },
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "application/json",
                },
              },
            );

            if (checkResponse.data.exists) {
              toast.error(checkResponse.data.message, {
                autoClose: 3000,
              });
              return;
            }
          } catch (err) {
            console.error(
              "Błąd podczas sprawdzania numeru listu przewozowego:",
              err,
            );
            toast.error(
              "Wystąpił błąd podczas sprawdzania numeru listu przewozowego",
            );
            return;
          }
        }

        // Jeśli walidacja przeszła pomyślnie, wykonaj aktualizację
        await axios.put(
          `${BASE_URL}/update/${id}`,
          {
            ...editedData,
          },
          {
            headers: {
              username: username,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );

        notify1();
        setEditField(null);
        setIsEditing(false);
        setEditedData({});
        setRowData((prev) => ({
          ...prev,
          ...editedData,
        }));
        return;
      } else if (rowData.rodzajTransportu === "Magazyn Warszawa Handling") {
        // Walidacja długości numeru listu
        if (editedData.numerListu && editedData.numerListu.length !== 14) {
          toast.error("Numer listu przewozowego musi mieć dokładnie 14 znaków");
          return;
        }

        // Sprawdzenie czy numer listu już istnieje w bazie (tylko jeśli został zmieniony)
        if (
          editedData.numerListu &&
          editedData.numerListu !== rowData.numerListu
        ) {
          try {
            const checkResponse = await axios.get(
              `${BASE_URL}/check-numer-listu-magazyn-warszawa-handling`,
              {
                params: {
                  numerListu: editedData.numerListu,
                  rodzajTransportu: rowData.rodzajTransportu,
                },
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "application/json",
                },
              },
            );

            if (checkResponse.data.exists) {
              toast.error(checkResponse.data.message, {
                autoClose: 3000,
              });
              return;
            }
          } catch (err) {
            console.error(
              "Błąd podczas sprawdzania numeru listu przewozowego:",
              err,
            );
            toast.error(
              "Wystąpił błąd podczas sprawdzania numeru listu przewozowego",
            );
            return;
          }
        }

        // Jeśli walidacja przeszła pomyślnie, wykonaj aktualizację
        await axios.put(
          `${BASE_URL}/update/${id}`,
          {
            ...editedData,
          },
          {
            headers: {
              username: username,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );

        notify1();
        setEditField(null);
        setIsEditing(false);
        setEditedData({});
        setRowData((prev) => ({
          ...prev,
          ...editedData,
        }));
        return;
      } else if (
        rowData.rodzajTransportu === "Magazyn Warszawa Nowy Handling"
      ) {
        // Walidacja długości numeru listu
        if (editedData.numerListu && editedData.numerListu.length !== 14) {
          toast.error("Numer listu przewozowego musi mieć dokładnie 14 znaków");
          return;
        }

        // Duplikat numeru listu - globalnie w dane (tylko gdy numer został zmieniony).
        if (
          editedData.numerListu &&
          editedData.numerListu !== rowData.numerListu
        ) {
          try {
            const checkResponse = await axios.get(
              `${BASE_URL}/check-numer-listu-mw-nowy-handling`,
              {
                params: { numerListu: editedData.numerListu, excludeId: id },
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "application/json",
                },
              },
            );

            if (checkResponse.data.exists) {
              toast.error(checkResponse.data.message, { autoClose: 3000 });
              return;
            }
          } catch (err) {
            console.error(
              "Błąd podczas sprawdzania numeru listu przewozowego:",
              err,
            );
            toast.error(
              "Wystąpił błąd podczas sprawdzania numeru listu przewozowego",
            );
            return;
          }
        }

        // Walidacja formatu MRN (minimum 25PL, maksimum 99PL, 18-20 znaków, tylko cyfry i litery).
        const mrnRegex = /^(2[5-9]|[3-9][0-9])PL[A-Z0-9]{14,16}$/;
        if (editedData.MRN && !mrnRegex.test(editedData.MRN)) {
          toast.error(
            "Pole MRN musi zaczynać się od '25PL', zawierać od 18 do 20 znaków alfanumerycznych (bez spacji i znaków specjalnych).",
          );
          return;
        }

        // MRN musi być unikalny w tabeli dane (sprawdzamy tylko gdy został zmieniony).
        if (editedData.MRN && editedData.MRN !== rowData.MRN) {
          try {
            const checkResponse = await axios.get(`${BASE_URL}/check-mrn`, {
              params: { MRN: editedData.MRN, excludeId: id },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
              },
            });

            if (checkResponse.data.exists) {
              toast.error("Numer MRN już istnieje w bazie danych.", {
                autoClose: 3000,
              });
              return;
            }
          } catch (err) {
            console.error("Błąd podczas sprawdzania numeru MRN:", err);
            toast.error("Wystąpił błąd podczas sprawdzania numeru MRN");
            return;
          }
        }

        // Kolejność godzin: przyjazd auta <= start skanowania <= zakończenie skanowania.
        const mergedNH = { ...rowData, ...editedData };
        if (!timeGte(mergedNH.startSkanowania, mergedNH.przyjazdAuta)) {
          toast.error(
            "Start skanowania nie może być wcześniejszy niż przyjazd auta.",
          );
          return;
        }
        if (
          !timeGte(mergedNH.zakonczenieSkanowania, mergedNH.startSkanowania)
        ) {
          toast.error(
            "Zakończenie skanowania nie może być wcześniejsze niż start skanowania.",
          );
          return;
        }

        // Gdy ustawiamy "Problem z przesyłką" = Tak, wymagany jest min. 1 adresat.
        const adresatProblemu = String(
          editedData.adresatProblemu ?? rowData.adresatProblemu ?? "",
        ).trim();
        const adresaciProblemu = parseRecipients(adresatProblemu);
        if (
          editedData.problemZPrzesylka === "Tak" &&
          adresaciProblemu.length === 0
        ) {
          toast.error(
            "Podaj co najmniej jednego adresata powiadomienia mailowego o problemie z przesyłką.",
          );
          return;
        }

        const nhUpdatePayload = { ...editedData };

        // "Czy przenieść do Zwroty i Błędy?" - pole pomocnicze (nie kolumna w bazie).
        // Tak => zmieniamy rodzajTransportu; klucz pomocniczy usuwamy z payloadu.
        const przeniesDoZwrotow = editedData.przeniesDoZwrotow === "Tak";
        delete nhUpdatePayload.przeniesDoZwrotow;
        if (przeniesDoZwrotow) {
          nhUpdatePayload.rodzajTransportu = "Magazyn Warszawa Zwroty i Błędy";
          // "Ilość fakt. paczek" (Nowy Handling) -> "Liczba paczek" (Zwroty i Błędy).
          nhUpdatePayload.liczbaPaczek =
            editedData.iloscFaktPaczek ?? rowData.iloscFaktPaczek;

          // Sprawdzenie duplikatu numeru listu w "Zwroty i Błędy" - tak samo jak
          // przy tworzeniu wpisu w formularzu (endpoint scoped na ten rodzajTransportu).
          const numerListuDoSprawdzenia = String(
            editedData.numerListu ?? rowData.numerListu ?? "",
          ).trim();
          try {
            const dupCheck = await axios.get(
              `${BASE_URL}/check-numer-listu-magazyn-warszawa-zwroty-i-bledy`,
              {
                params: {
                  numerListu: numerListuDoSprawdzenia,
                  rodzajTransportu: "Magazyn Warszawa Zwroty i Błędy",
                },
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "application/json",
                },
              },
            );
            if (dupCheck.data?.isDuplicate) {
              const kontynuuj = window.confirm(
                `UWAGA: ${dupCheck.data.message}\n\nCzy na pewno przenieść do „Zwroty i Błędy" jako duplikat?`,
              );
              if (!kontynuuj) return;
              nhUpdatePayload.duplikat = 1;
            }
          } catch (dupErr) {
            const msg =
              dupErr.response?.data?.message ||
              "Nie udało się sprawdzić duplikatu numeru listu.";
            const kontynuuj = window.confirm(
              `${msg}\n\nKontynuować przeniesienie mimo to?`,
            );
            if (!kontynuuj) return;
          }
        }

        // Paczki vs palety: zapisanie wartosci > 0 w jednej grupie zeruje druga.
        const nhMergedIlosc = { ...rowData, ...editedData };
        const editingPaczki = ILOSC_PACZKI_FIELDS.some(
          (f) => editedData[f] !== undefined,
        );
        const editingPalety = ILOSC_PALETY_FIELDS.some(
          (f) => editedData[f] !== undefined,
        );
        if (
          editingPaczki &&
          iloscGroupActive(ILOSC_PACZKI_FIELDS.map((f) => nhMergedIlosc[f]))
        ) {
          ILOSC_PALETY_FIELDS.forEach((f) => {
            nhUpdatePayload[f] = 0;
          });
        } else if (
          editingPalety &&
          iloscGroupActive(ILOSC_PALETY_FIELDS.map((f) => nhMergedIlosc[f]))
        ) {
          ILOSC_PACZKI_FIELDS.forEach((f) => {
            nhUpdatePayload[f] = 0;
          });
        }

        // "Wydanie towaru": uzytkownik wpisuje sama godzine -> doklejamy dzisiejsza date.
        if (editedData.podjazdAuta !== undefined) {
          nhUpdatePayload.podjazdAuta = nhDateStamp(editedData.podjazdAuta);
        }
        if (editedData.wyjazdAuta !== undefined) {
          nhUpdatePayload.wyjazdAuta = nhDateStamp(editedData.wyjazdAuta);
        }

        // "Godzina wyjazdu auta" nie moze byc wczesniejsza niz "Podjazd auta".
        // Oba pola trzymamy jako "YYYY-MM-DD HH:mm" - porownanie leksykalne = chronologiczne.
        const effPodjazdAuta = String(
          nhUpdatePayload.podjazdAuta ?? rowData.podjazdAuta ?? "",
        ).trim();
        const effWyjazdAuta = String(
          nhUpdatePayload.wyjazdAuta ?? rowData.wyjazdAuta ?? "",
        ).trim();
        if (
          editedData.wyjazdAuta !== undefined &&
          effWyjazdAuta &&
          effPodjazdAuta &&
          effWyjazdAuta < effPodjazdAuta
        ) {
          toast.error(
            "Godzina wyjazdu auta nie może być wcześniejsza niż podjazd auta.",
          );
          return;
        }

        // Automatyczne przejścia statusu dla Nowego Handlingu (kolejność = etapy):
        //  A) "Towar celny" = Tak (w tym zapisie)                   -> "W odprawie celnej"
        //  B) wpisano "Podjazd auta":
        //       Towar celny = Tak i Odprawa celna niekompletna      -> "W oczekiwaniu na clenie"
        //       Towar celny = Tak i status = "Oclono"               -> "Towar do wydania"
        //       Towar celny = Nie                                   -> "Towar do wydania"
        //  C) Odprawa celna staje się kompletna (status "przed cleniem"):
        //       zawsze                                              -> "Oclono"
        //     Wyjście z "Oclono" gdy "Podjazd auta" jest już wpisany
        //     robi przycisk "Przekaż towar do wydania" (patrz handleNhReleaseGoods).
        //  D) wpisano "Godzina wyjazdu auta"                        -> "Zrealizowano"
        // Przy przeniesieniu do "Zwroty i Błędy" pomijamy przejścia statusu NH.
        if (!przeniesDoZwrotow) {
          if (editedData.towarCelny === "Tak") {
            nhUpdatePayload.statusRealizacji = "W odprawie celnej";
          }

          const nhMergedForStatus = { ...rowData, ...nhUpdatePayload };
          const nhOdprawaDone = nhOdprawaCelnaComplete(nhMergedForStatus);
          const nhPodjazdChanged =
            editedData.podjazdAuta !== undefined &&
            nhFilled(nhUpdatePayload, "podjazdAuta") &&
            nhUpdatePayload.podjazdAuta !== rowData.podjazdAuta;
          const nhWyjazdChanged =
            editedData.wyjazdAuta !== undefined &&
            nhFilled(nhUpdatePayload, "wyjazdAuta") &&
            nhUpdatePayload.wyjazdAuta !== rowData.wyjazdAuta;

          if (nhPodjazdChanged) {
            nhUpdatePayload.statusRealizacji =
              nhMergedForStatus.towarCelny === "Tak" && !nhOdprawaDone
                ? "W oczekiwaniu na clenie"
                : "Towar do wydania";
          }

          if (
            nhOdprawaDone &&
            ["W odprawie celnej", "W oczekiwaniu na clenie"].includes(
              nhUpdatePayload.statusRealizacji ?? rowData.statusRealizacji,
            )
          ) {
            nhUpdatePayload.statusRealizacji = "Oclono";
          }

          if (nhWyjazdChanged) {
            nhUpdatePayload.statusRealizacji = "Zrealizowano";
            nhUpdatePayload.endDate = moment
              .tz("Europe/Warsaw")
              .format("YYYY-MM-DDTHH:mm:ss");
          }
        }

        await axios.put(`${BASE_URL}/update/${id}`, nhUpdatePayload, {
          headers: {
            username: username,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        if (
          nhUpdatePayload.statusRealizacji &&
          nhUpdatePayload.statusRealizacji !== rowData.statusRealizacji
        ) {
          toast.info(
            `Status zmieniony na „${nhUpdatePayload.statusRealizacji}”.`,
            { autoClose: 2500 },
          );
        }

        // Zapis się powiódł - wyślij powiadomienie mailowe o problemie z przesyłką.
        if (
          editedData.problemZPrzesylka === "Tak" &&
          adresaciProblemu.length > 0
        ) {
          try {
            await axios.post(
              `${BASE_URL}/send-problem-przesylki-notification`,
              { nrRef: rowData.nrRef, id },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "application/json",
                },
              },
            );
            toast.info(
              `Powiadomienie o problemie z przesyłką wysłane (${adresaciProblemu.length}): ${adresaciProblemu.join(", ")}`,
              { autoClose: 3000 },
            );
            // Odśwież sekcję "Wysłane maile z DutyStation" (jest w CommentSection).
            setEmailRefreshToken((t) => t + 1);
          } catch (mailErr) {
            console.error(
              "Nie udało się wysłać powiadomienia o problemie z przesyłką:",
              mailErr,
            );
            toast.warning(
              "Zapisano, ale nie udało się wysłać powiadomienia mailowego o problemie z przesyłką.",
              { autoClose: 4000 },
            );
          }
        }

        notify1();
        setEditField(null);
        setIsEditing(false);
        setEditedData({});

        if (przeniesDoZwrotow) {
          toast.info(
            "Zgłoszenie przeniesione do „Magazyn Warszawa Zwroty i Błędy”.",
            { autoClose: 2500 },
          );
          navigate("/magazynWarszawaZwrotyIBledy");
          return;
        }

        setRowData((prev) => ({
          ...prev,
          ...nhUpdatePayload,
        }));
        return;
      } else {
        const urzadZgloszeniaValue = (
          skipUrzadZgloszeniaDialog
            ? selectedUrzadZgloszenia
            : editedData.urzadZgloszenia || rowData.urzadZgloszenia || ""
        ).trim();
        const currentLokalizacjaTowaruValue = (
          editedData.lokalizacjaTowaru ||
          rowData.lokalizacjaTowaru ||
          ""
        ).trim();
        const lokalizacjaTowaruValue = (
          skipUrzadZgloszeniaDialog
            ? selectedLokalizacjaTowaruDialog || currentLokalizacjaTowaruValue
            : currentLokalizacjaTowaruValue
        ).trim();

        if (
          editedData.statusRealizacji === "Do wysłania" &&
          (!urzadZgloszeniaValue || !lokalizacjaTowaruValue)
        ) {
          setSelectedUrzadZgloszenia(
            editedData.urzadZgloszenia || rowData.urzadZgloszenia || "",
          );
          setSelectedLokalizacjaTowaruDialog(currentLokalizacjaTowaruValue);
          setOpenUrzadZgloszeniaDialog(true);
          return;
        }

        // Walidacja pola SAD
        const sadRegex = /^\d{1,6}$/;
        if (editedData.SAD && !sadRegex.test(editedData.SAD)) {
          toast.error("Pole SAD może zawierać maksymalnie 6 cyfr bez spacji.");
          return;
        }

        // Sprawdzenie, czy SAD został zmieniony
        if (editedData.SAD && editedData.SAD === rowData.nrRef) {
          toast.error("Numer SAD musi różnić się od nr referencyjnego.");
          return;
        }

        if (editedData.SAD) {
          const result = await checkSadExists(editedData.SAD);
          if (result.exists) {
            toast.error(
              `Taki SAD już istnieje i jest przypisany do nrRef: ${
                result.nrRef || "nieznany"
              }`,
            );
            return;
          }
        }

        // Walidacja pola MRN (minimum 25PL, maksimum 99PL, 18-20 znaków, tylko cyfry i litery)
        const mrnRegex = /^(2[5-9]|[3-9][0-9])PL[A-Z0-9]{14,16}$/;
        if (editedData.MRN && !mrnRegex.test(editedData.MRN)) {
          toast.error(
            "Pole MRN musi zaczynać się od '25PL', zawierać od 18 do 20 znaków alfanumerycznych (bez spacji i znaków specjalnych).",
          );
          return;
        }

        const parseDate = (inputDate) => {
          const parts = inputDate.split("-");
          if (parts.length === 3) {
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
          }
          return inputDate;
        };

        if (editedData.data && editedData.data !== rowData.data) {
          const dateFormatRegex =
            /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;
          if (!editedData.data.match(dateFormatRegex)) {
            toast.error("Zły format danych. Powinien być np. 30-10-2023");
            return;
          }
        }

        if (
          editedData.nrRejestracyjnyPojazdyKurier &&
          editedData.nrRejestracyjnyPojazdyKurier !==
            rowData.nrRejestracyjnyPojazdyKurier
        ) {
          const nr = editedData.nrRejestracyjnyPojazdyKurier.trim();

          if (nr.length < 7 || new Set(nr).size === 1) {
            toast.error(
              "Numer rejestracyjny pojazdu musi zawierać co najmniej 7 różnych znaków.",
            );
            return;
          }
        }

        if (
          editedData.rodzajTransportu === "Na Kołach" &&
          rowData.rodzajTransportu !== "Na Kołach" &&
          Number(rowData.oczekiwanieNaRozladunekLubOdprawaLaczonaBox) === 1
        ) {
          toast.error(
            `Nie można zmienić rodzaju transportu na "Na Kołach", ponieważ zaznaczony jest znacznik "Oczekiwanie na rozładunek i/lub odprawa łączona z innymi agencjami".`,
          );
          return;
        }

        if (role !== "admin") {
          if (
            (editedData.rodzajTransportu === "Na Kołach" &&
              rowData.lokalizacjaTowaru === "W DRODZE") ||
            (editedData.lokalizacjaTowaru === "W DRODZE" &&
              rowData.rodzajTransportu === "Na Kołach")
          ) {
            toast.error(
              `Nie można ustawić rodzaju transportu "Na Kołach, jeśli lokalizacja towaru/urząd celny wyjścia jest "W DRODZE".`,
            );
            return;
          }
          if (
            editedData.statusRealizacji === "Przygotowane" &&
            rowData.SAD === ""
          ) {
            toast.error(
              "Nie można zmienić statusu na Przygotowane, brak wpisanego numeru SAD",
            );
            return;
          }

          if (
            ["Zrealizowane", "Unieważnione przez OC"].includes(
              editedData.statusRealizacji,
            ) &&
            rowData.pliki === ""
          ) {
            toast.error(
              "Nie można zmienić statusu na Zrealizowane lub Unieważnione przez OC, brak wpisanej ścieżki do plików",
            );
            return;
          }

          if (
            ["Zrealizowane", "Unieważnione przez OC"].includes(
              editedData.statusRealizacji,
            ) &&
            rowData.przelew === 1 &&
            (rowData.nota_ksiegowa === null || rowData.nota_ksiegowa === "")
          ) {
            toast.error(
              "Nie można zmienić statusu na Zrealizowane lub Unieważnione przez OC, brak wpisanej noty księgowej - w liście kontrolnej zadeklarowano Przelew",
            );
            return;
          }

          if (
            editedData.statusRealizacji === "Przygotowane" &&
            rowData.plikiBox === 0
          ) {
            toast.error(
              "Nie można zmienić statusu na Przygotowane, brak zaznaczonego znacznika plik do zaczytania",
            );
            return;
          }

          if (
            editedData.statusRealizacji === "Przygotowane" &&
            rowData.plikiBox === 0
          ) {
            toast.error(
              "Nie można zmienić statusu na Przygotowane, brak zaznaczonego znacznika plik do zaczytania",
            );
            return;
          }

          if (
            ["Zrealizowane", "Unieważnione przez OC"].includes(
              editedData.statusRealizacji,
            ) &&
            (rowData.MRN === "" || rowData.MRN === null)
          ) {
            toast.error(
              "Nie można zmienić statusu na Zrealizowane lub Unieważnione przez OC, brak wpisanego numeru MRN",
            );
            return;
          }

          if (
            ["Zrealizowane", "Unieważnione przez OC"].includes(
              editedData.statusRealizacji,
            ) &&
            (rowData.lokalizacjaTowaru === "NIEZNANA" ||
              rowData.lokalizacjaTowaru === "W DRODZE")
          ) {
            toast.error(
              "Nie można zmienić statusu na Zrealizowane lub Unieważnione przez OC, lokalizacja towaru nie może być Nieznana lub W drodze.",
            );
            return;
          }

          if (
            editedData.statusRealizacji === "Wysłane" &&
            (rowData.lokalizacjaTowaru === "NIEZNANA" ||
              rowData.lokalizacjaTowaru === "W DRODZE")
          ) {
            toast.error(
              "Nie można zmienić statusu na Wysłane, lokalizacja towaru nie może być Nieznana lub W drodze.",
            );
            return;
          }

          //TRANZYTY
          if (rowData.rodzaj === "Tranzyt") {
            if (
              editedData.statusRealizacji === "Wysłane" &&
              (rowData.waga_netto === "" || rowData.waga_netto === null)
            ) {
              toast.error(
                "Nie można zmienić statusu na Wysłane, brak wpisanej wagi netto",
              );
              return;
            }

            if (
              editedData.statusRealizacji === "TWysłane" &&
              (rowData.waga_brutto === "" || rowData.waga_brutto === null)
            ) {
              toast.error(
                "Nie można zmienić statusu na Wysłane, brak wpisanej wagi brutto",
              );
              return;
            }

            if (
              editedData.statusRealizacji === "Wysłane" &&
              (rowData.nrRejestracyjnyPojazdyKurier === "" ||
                rowData.nrRejestracyjnyPojazdyKurier === null)
            ) {
              toast.error(
                "Nie można zmienić statusu na Wysłane, brak wpisanego Nr rejestracyjny pojazdu/kuriera",
              );
              return;
            }

            if (
              editedData.statusRealizacji === "Wysłane" &&
              (rowData.kwota_gwarancji === "" ||
                rowData.kwota_gwarancji === null)
            ) {
              toast.error(
                "Nie można zmienić statusu na Wysłane, brak wpisanej kwoty gwarancji w PLN",
              );
              return;
            }

            if (
              editedData.statusRealizacji === "Przyjęte przez Gwaranta" &&
              (rowData.nr_ref_gwaranta === "" ||
                rowData.nr_ref_gwaranta === null)
            ) {
              toast.error(
                "Nie można zmienić statusu na Przyjęte przez Gwaranta, brak wpisanego numeru Ref Gwaranta",
              );
              return;
            }

            if (
              editedData.statusRealizacji === "Wysłano do urzędu" &&
              (rowData.nr_LRN === "" || rowData.nr_LRN === null)
            ) {
              toast.error(
                "Nie można zmienić statusu na Wysłano do urzędu, brak wpisanego numeru LRN",
              );
              return;
            }
            if (
              editedData.statusRealizacji === "Zwolniono do tranzytu" &&
              (rowData.MRN === "" ||
                rowData.MRN === null ||
                rowData.MRN === undefined)
            ) {
              toast.error(
                "Nie można zmienić statusu na Zwolniono do tranzytu, brak wpisanego numeru MRN",
              );
              return;
            }

            if (
              editedData.statusRealizacji === "Tranzyt zakończony" &&
              (rowData.data_ie === "" || rowData.data_ie === null)
            ) {
              toast.error(
                "Nie można zmienić statusu na Tranzyt zakończony, brak wpisanej daty otrzymania komunikatu IE045",
              );
              return;
            }
          }
        }

        if (
          rowData.rodzaj === "Import" ||
          rowData.rodzaj === "Eksport" ||
          rowData.rodzaj === "Eksport - wpis do rejestru" ||
          rowData.rodzaj === "Import - wpis do rejestru" ||
          rowData.rodzaj === "Uszlachetnianie czynne" ||
          rowData.rodzaj === "Uszlachetnianie bierne" ||
          rowData.rodzaj === "Wyprowadzenie ze składu" ||
          rowData.rodzaj === "Wprowadzenie na skład" ||
          rowData.rodzaj === "Eksport PL i import inny kraj" ||
          rowData.rodzaj === "Powrotny przywóz" ||
          rowData.rodzaj === "Powrotny wywóz" ||
          rowData.rodzaj === "Tranzyt" ||
          rowData.rodzaj === "Odprawa czasowa import" ||
          rowData.rodzaj === "Odprawa czasowa eksport"
        ) {
          const { verificationData, przygotowaneData } = await fetchData(
            id,
            rowData.rodzaj,
          );

          //Zmiana statusu na Przygotowane z Do przygotowania
          //Na ten status moze zmienic tylko os. przygotowujaca, os.weryfikujaca lub admin
          //Lista kontrolna dla os. przygotowującej musi byc ukonczona
          //Sprawdzone i działa
          const isPrzygotowaneStatus =
            editedData.statusRealizacji === "Przygotowane";

          if (
            isPrzygotowaneStatus &&
            przygotowaneData.Przygotowane !== 1 &&
            (role !== "admin" ||
              username !== rowData.osobaWeryfikujacaOdprawe ||
              username !== rowData.osobaPrzygotowujacaOdprawe)
          ) {
            toast.error(
              "Nie można zmienić statusu na Przygotowane, ponieważ Lista kontrolna nie została w całości uzupełniona!",
            );
            return; // Nie kontynuuj zapisywania formularza
          }

          //Zmiana statusu na Do poprawy z Do weryfikacji
          //Musi być przeprowadzona weryfikacja w liscie kontrolnej aby moc zmienic ten status na Do poprawy
          if (
            editedData.statusRealizacji === "Do poprawy" &&
            rowData.statusRealizacji === "Do weryfikacji" &&
            (verificationData.Zweryfikowane === undefined ||
              verificationData.Zweryfikowane === null)
          ) {
            toast.error(
              "Nie można zmienić na status do poprawy jeżeli weryfikacja nie została przeprowadzona",
            );
            return;
          }

          if (
            editedData.statusRealizacji === "Do wysłania" &&
            rowData.statusRealizacji === "Do weryfikacji" &&
            (verificationData.Zweryfikowane === undefined ||
              verificationData.Zweryfikowane === null)
          ) {
            toast.error(
              "Nie można zmienić na status do wysłania jeżeli weryfikacja nie została przeprowadzona",
            );
            return;
          }

          //Zmiana statusu na Do wysłania z Do poprawy
          //Moze zmienic tylko os. przygotowujaca, os.weryfikujaca, rola admin
          //Musi zostac wykonana weryfikacja w liscie kontrolnej
          if (
            (verificationData.Zweryfikowane === 0 ||
              verificationData.Zweryfikowane === 1) &&
            editedData.statusRealizacji === "Do wysłania" &&
            rowData.statusRealizacji === "Do poprawy" &&
            username !== rowData.osobaPrzygotowujacaOdprawe &&
            username !== rowData.osobaWeryfikujacaOdprawe &&
            role !== "admin"
          ) {
            toast.error(
              "Nie można zmienić statusu na Do wysłania, ponieważ może zmienić ten status tylko osoba, która przygotowywała odprawę, osoba weryfikująca, administrator lub nie została przeprowadzona weryfikacja.",
            );
            return; // Nie kontynuuj zapisywania formularza
          }
        }

        if (role !== "admin") {
          if (
            editedData.statusRealizacji === "Przygotowane" &&
            rowData.statusRealizacji !== "Do przygotowania" &&
            rowData.statusRealizacji !== "Wstępnie przygotowane"
          ) {
            toast.error(
              "Nie można zmienić statusu na Przygotowane, jeśli poprzedni status jest różny od Do przygotowania lub Wstępnie przygotowane",
            );
            return;
          }

          if (
            editedData.statusRealizacji === "Do weryfikacji" &&
            rowData.statusRealizacji !== "Przygotowane"
          ) {
            toast.error(
              "Nie można zmienić statusu na Do weryfikacji, jeśli poprzedni status jest różny od Przygotowane",
            );
            return;
          }

          if (
            editedData.statusRealizacji === "Do poprawy" &&
            rowData.statusRealizacji !== "Do weryfikacji"
          ) {
            toast.error(
              "Nie można zmienić statusu na Do poprawy, jeśli poprzedni status jest różny od Do weryfikacji",
            );
            return;
          }

          if (
            editedData.statusRealizacji === "Do wysłania" &&
            rowData.statusRealizacji !== "Do weryfikacji" &&
            rowData.statusRealizacji !== "Do poprawy" &&
            rowData.statusRealizacji !== "Przygotowane"
          ) {
            toast.error(
              "Nie można zmienić statusu na Do wysłania, jeśli poprzedni status jest różny od Do weryfikacji lub Do poprawy lub Przygotowane",
            );
            return;
          }

          if (
            editedData.statusRealizacji === "Wysłane" &&
            rowData.statusRealizacji !== "Do wysłania"
          ) {
            toast.error(
              "Nie można zmienić statusu na Wysłane, jeśli poprzedni status jest różny od Do wysłania",
            );
            return;
          }

          if (
            ["Unieważnione przez OC", "Odprawa zakończona"].includes(
              editedData.statusRealizacji,
            ) &&
            rowData.statusRealizacji !== "Wysłane"
          ) {
            toast.error(
              "Nie można zmienić statusu na Unieważnione przez OC lub Odprawa zakończona, jeśli poprzedni status jest różny od Wysłane",
            );
            return;
          }

          if (
            editedData.statusRealizacji === "Zrealizowane" &&
            !["Wysłane", "Odprawa zakończona"].includes(
              rowData.statusRealizacji,
            )
          ) {
            toast.error(
              "Nie można zmienić statusu na Zrealizowane, jeśli poprzedni status jest różny od Wysłane lub Odprawa zakończona",
            );
            return;
          }
        }

        let formattedEditedData = { ...editedData };

        if (editedData.statusRealizacji === "Do wysłania") {
          formattedEditedData = {
            ...formattedEditedData,
            urzadZgloszenia: urzadZgloszeniaValue,
            lokalizacjaTowaru: lokalizacjaTowaruValue || null,
          };
        }
        if (editedData.data && rowData.data) {
          const editedDateFormatted = parseDate(editedData.data);
          const originalDateFormatted = parseDate(rowData.data);

          if (editedDateFormatted !== originalDateFormatted) {
            formattedEditedData = {
              ...formattedEditedData,
              data: editedDateFormatted,
            };
          }
        }

        await axios.put(`${BASE_URL}/update/${id}`, formattedEditedData, {
          headers: {
            username: username,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        notify1();
        setEditField(null);
        setIsEditing(false);
        setEditedData({});
        setSelectedUrzadZgloszenia("");
        setSelectedLokalizacjaTowaruDialog("");

        setRowData((prev) => ({
          ...prev,
          ...formattedEditedData,
        }));

        const statusChanged =
          Object.prototype.hasOwnProperty.call(
            formattedEditedData,
            "statusRealizacji",
          ) &&
          formattedEditedData.statusRealizacji !== rowData.statusRealizacji;

        if (!statusChanged) {
          return;
        }

        if (
          (rowData.statusRealizacji === "Anulowane" &&
            rowData.rodzajTransportu === "Zakończono") ||
          (rowData.statusRealizacji === "Unieważnione przez OC" &&
            rowData.rodzajTransportu === "Zakończono") ||
          (rowData.statusRealizacji === "Zrealizowane" &&
            rowData.rodzajTransportu === "Zakończono") ||
          (rowData.statusRealizacji === "Zrealizowane" &&
            rowData.rodzajTransportu === "Magazyn Warszawa")
        ) {
          return;
        } else {
          fetchRowData()
            .then((newRowData) => {
              return new Promise((resolve) => {
                setTimeout(() => resolve(newRowData), 100);
              });
            })
            .then(async (freshRowData) => {
              // Wykonuj aktualizacje tylko jeśli to NIE jest Magazyn Warszawa
              if (freshRowData.rodzajTransportu !== "Magazyn Warszawa") {
                await updateRodzajTransport(freshRowData);
                await updateGwarantStatusIfNeeded(freshRowData, id, username);
                await updateWyslanoDoUrzeduStatusIfNeeded(
                  freshRowData,
                  id,
                  username,
                );
                await updateZwolnionoDoTranzytuStatusIfNeeded(
                  freshRowData,
                  id,
                  username,
                );
                await updateTranzytZakończonyStatusIfNeeded(
                  freshRowData,
                  id,
                  username,
                );
              }
            })
            .then(() => {
              return new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                }, 100);
              });
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      }
    } catch (error) {
      console.error("Error updating data:", error);
      toast.error(error.response?.data?.error || "Error updating data.");
    }
  };

  const handleEditCancel = () => {
    setEditField(null);
    setIsEditing(false);
    setOpenUrzadZgloszeniaDialog(false);
    setSelectedUrzadZgloszenia("");
    setSelectedLokalizacjaTowaruDialog("");
    setUrzadSearchTerm("");
    setLokalizacjaSearchTerm("");
    setEditedData({});
  };

  if (!rowData || !id) {
    return (
      <div className={classes.loaderContainer}>
        {loadError ? (
          <div style={{ textAlign: "center" }}>
            <Typography variant="h6" gutterBottom>
              {loadError}
            </Typography>
            <Button variant="contained" color="primary" onClick={loadRowData}>
              Spróbuj ponownie
            </Button>
            <Button
              variant="outlined"
              color="primary"
              style={{ marginLeft: 8 }}
              onClick={() => navigate(-1)}
            >
              Wróć
            </Button>
          </div>
        ) : (
          <>
            <CircularProgress color="secondary" />
            <Typography variant="body1">Loading...</Typography>
          </>
        )}
      </div>
    );
  }

  function shouldDisplayField(field, rowData, role) {
    if (!rowData) {
      return false; // Ukryj, dopóki dane się nie załadują
    }

    // Pole "nota_ksiegowa" - wyświetl tylko, gdy przelew jest 1
    if (field === "nota_ksiegowa") {
      return rowData.przelew === 1; // Wyświetl tylko, gdy przelew ma wartość 1
    }

    // Lista pól zawsze ukrytych
    const hiddenFields = [
      "createdBy",
      "utworzono",
      "nrRef",
      "endDate",
      "id",
      "urzadZgloszenia",
    ];

    // Lista pól specyficznych dla rodzaju !== "Tranzyt"
    const nonTransitFields = ["waluta", "wagaNetto", "wagaBrutto", "nrPojazdu"];

    // Logika dla administratora
    if (role === "admin") {
      return (
        !hiddenFields.includes(field) && // Pole nie należy do ukrytych
        !field.endsWith("Box") && // Pole nie kończy się na "Box"
        !(rowData.rodzaj !== "Tranzyt" && nonTransitFields.includes(field)) // Pole specyficzne dla tranzytu
      );
    }

    // Logika dla innych użytkowników
    if (role !== "admin") {
      // Osoba przygotowująca odprawę - ukryj, jeśli status realizacji pasuje
      if (
        field === "osobaPrzygotowujacaOdprawe" &&
        [
          "Przygotowane",
          "Do wysłania",
          "Wysłane",
          "Unieważnione przez OC",
          "Zrealizowane",
          "Anulowane",
        ].includes(rowData.statusRealizacji)
      ) {
        return false;
      }

      // Ukryj pole, jeśli jest w "hiddenFields"
      if (hiddenFields.includes(field)) {
        return false;
      }

      // Ukryj pola specyficzne dla rodzaju !== "Tranzyt"
      if (rowData.rodzaj !== "Tranzyt" && nonTransitFields.includes(field)) {
        return false;
      }

      // Ukryj pola kończące się na "Box"
      if (field.endsWith("Box")) {
        return false;
      }
    }

    // Domyślnie wyświetl pole
    return true;
  }

  const handleEksportUniwersal = (
    nrRef,
    osobaPrzygotowujaca,
    osobaWeryfikujaca,
    osobaWysylajaca,
    status,
    rodzajOdprawy,
  ) => {
    navigate(`/UniwersalListEksport/${rowData.nrRef}/${rowData.id}`, {
      state: {
        nrRef: rowData.nrRef,
        osobaPrzygotowujaca: rowData.osobaPrzygotowujacaOdprawe,
        osobaWeryfikujaca: rowData.osobaWeryfikujacaOdprawe,
        osobaWysylajaca: rowData.osobaWysylajacaOdprawe,
        status: rowData.statusRealizacji,
        rodzajOdprawy: rowData.rodzaj,
        lokalizacjaTowaru: rowData.lokalizacjaTowaru,
      },
    });
  };

  const handleTranzytUniwersal = (
    nrRef,
    osobaPrzygotowujaca,
    osobaWeryfikujaca,
    osobaWysylajaca,
    status,
    rodzajOdprawy,
  ) => {
    navigate(`/UniwersalListTranzyt/${rowData.nrRef}/${rowData.id}`, {
      state: {
        nrRef: rowData.nrRef,
        osobaPrzygotowujaca: rowData.osobaPrzygotowujacaOdprawe,
        osobaWeryfikujaca: rowData.osobaWeryfikujacaOdprawe,
        osobaWysylajaca: rowData.osobaWysylajacaOdprawe,
        status: rowData.statusRealizacji,
        rodzajOdprawy: rowData.rodzaj,
        lokalizacjaTowaru: rowData.lokalizacjaTowaru,
      },
    });
  };

  const handleImportUniwersal = (
    nrRef,
    osobaPrzygotowujaca,
    osobaWeryfikujaca,
    osobaWysylajaca,
    status,
    rodzajOdprawy,
  ) => {
    navigate(`/UniwersalListImport/${rowData.nrRef}/${rowData.id}`, {
      state: {
        nrRef: rowData.nrRef,
        osobaPrzygotowujaca: rowData.osobaPrzygotowujacaOdprawe,
        osobaWeryfikujaca: rowData.osobaWeryfikujacaOdprawe,
        osobaWysylajaca: rowData.osobaWysylajacaOdprawe,
        status: rowData.statusRealizacji,
        rodzajOdprawy: rowData.rodzaj,
        lokalizacjaTowaru: rowData.lokalizacjaTowaru,
      },
    });
  };

  const isMagazynEntry = [
    "Magazyn Warszawa Zwroty i Błędy",
    "Magazyn Warszawa Handling",
    "Magazyn Warszawa Nowy Handling",
  ].includes(rowData.rodzajTransportu);

  return (
    <div className={classes.root}>
      <main className={classes.content}>
        <div className={pageClasses.pageHeader}>
          <div>
            <h1 className={pageClasses.title}>
              {isMagazynEntry ? "Szczegóły wpisu" : "Szczegóły zgłoszenia"}: {rowData.nrRef}
            </h1>
            {rowData.rodzajTransportu && (
              <div className={pageClasses.subtitle}>{rowData.rodzajTransportu}</div>
            )}
          </div>
        </div>
        {editField ? (
          <div className={classes.editForm}>
            {rowData.rodzajTransportu === "Magazyn Warszawa" ? (
              // Pola dla Magazyn Warszawa
              <>
                {editField === "kierunek" && isEditing && (
                  <FormControl
                    variant="outlined"
                    className={classes.inputField}
                  >
                    <InputLabel>Kierunek</InputLabel>
                    <Select
                      label="Kierunek"
                      name="kierunek"
                      value={editedData.kierunek || ""}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="GB">GB</MenuItem>
                      <MenuItem value="CH">CH</MenuItem>
                      <MenuItem value="NO">NO</MenuItem>
                      <MenuItem value="BA">BA</MenuItem>
                      <MenuItem value="RS">RS</MenuItem>
                      <MenuItem value="Lotniczy">Lotniczy</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {editField === "statusRealizacji" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">
                      Status realizacji
                    </InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.statusRealizacji}
                      onChange={handleInputChange}
                      name={editField}
                    >
                      <MenuItem value="Do przygotowania">
                        Do przygotowania
                      </MenuItem>
                      <MenuItem value="Zrealizowane">Zrealizowane</MenuItem>
                      <MenuItem value="Anulowane">Anulowane</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {editField === "serwisLotniczy" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">
                      Serwis lotniczy
                    </InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.serwisLotniczy}
                      onChange={handleInputChange}
                      name={editField}
                    >
                      <MenuItem value="Tak">Tak</MenuItem>
                      <MenuItem value="Nie">Nie</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {editField === "Rewizja" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">Rewizja</InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.rewizja}
                      onChange={handleInputChange}
                      name={editField}
                    >
                      <MenuItem value="Tak">Tak</MenuItem>
                      <MenuItem value="Nie">Nie</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {editField === "numerListu" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Numer listu przewozowego"
                    variant="outlined"
                    name="numerListu"
                    value={editedData.numerListu || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    required
                    inputProps={{
                      maxLength: 14,
                      minLength: 14,
                    }}
                    error={
                      editedData.numerListu &&
                      editedData.numerListu.length !== 14
                    }
                    helperText={
                      editedData.numerListu &&
                      editedData.numerListu.length !== 14
                        ? "Numer listu przewozowego musi mieć dokładnie 14 znaków"
                        : ""
                    }
                  />
                )}
                {editField === "nadawca" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Nazwa firmy"
                    variant="outlined"
                    name="nadawca"
                    value={editedData.nadawca || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                )}
                {editField === "pliki" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Ścieżka do plików"
                    variant="outlined"
                    name="pliki"
                    value={editedData.pliki || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                )}
                {editField === "liczbaPaczek" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Liczba paczek"
                    variant="outlined"
                    type="number"
                    name="liczbaPaczek"
                    value={editedData.liczbaPaczek || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    inputProps={{ min: 0 }}
                  />
                )}
                {editField === "liczbaPalet" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Liczba palet"
                    variant="outlined"
                    type="number"
                    name="liczbaPalet"
                    value={editedData.liczbaPalet || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    inputProps={{ min: 0 }}
                  />
                )}
                {editField === "MRN" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="MRN"
                    variant="outlined"
                    name="MRN"
                    value={editedData.MRN || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                )}
                {editField === "iloscPozycjiSAD" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Ilość pozycji SAD"
                    variant="outlined"
                    type="number"
                    name="iloscPozycjiSAD"
                    value={editedData.iloscPozycjiSAD || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                )}
              </>
            ) : rowData.rodzajTransportu ===
              "Magazyn Warszawa Zwroty i Błędy" ? (
              // Nowe pola dla Magazyn Warszawa Stan Magazynowy
              <>
                {editField === "nadawca" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Nazwa firmy"
                    variant="outlined"
                    name="nadawca"
                    value={editedData.nadawca || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                )}
                {editField === "numerListu" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Numer listu przewozowego"
                    variant="outlined"
                    name="numerListu"
                    value={editedData.numerListu || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    required
                    inputProps={{
                      maxLength: 14,
                      minLength: 14,
                    }}
                    error={
                      editedData.numerListu &&
                      editedData.numerListu.length !== 14
                    }
                    helperText={
                      editedData.numerListu &&
                      editedData.numerListu.length !== 14
                        ? "Numer listu przewozowego musi mieć dokładnie 14 znaków"
                        : ""
                    }
                  />
                )}
                {editField === "liczbaPaczek" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Liczba paczek"
                    variant="outlined"
                    type="number"
                    name="liczbaPaczek"
                    value={editedData.liczbaPaczek || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    inputProps={{ min: 0 }}
                  />
                )}
                {editField === "bladDokumentacji" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">
                      Błąd dokumentacji
                    </InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.bladDokumentacji}
                      onChange={handleInputChange}
                      name={editField}
                    >
                      <MenuItem value="Tak">Tak</MenuItem>
                      <MenuItem value="Nie">Nie</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {editField === "rodzajBledu" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">Rodzaj błędu</InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.rodzajBledu}
                      onChange={handleInputChange}
                      name={editField}
                    >
                      <MenuItem value="Brak dokumentów">
                        Brak dokumentów
                      </MenuItem>
                      <MenuItem value="Upoważnienie">Upoważnienie</MenuItem>
                      <MenuItem value="Faktura">Faktura</MenuItem>
                      <MenuItem value="Inne">Inne</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {editField === "zwrot" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">Zwrot</InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.zwrot}
                      onChange={handleInputChange}
                      name={editField}
                    >
                      <MenuItem value="Tak">Tak</MenuItem>
                      <MenuItem value="Nie">Nie</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {editField === "powod" && isEditing && (
                  <FormControl
                    variant="outlined"
                    className={classes.inputField}
                  >
                    <InputLabel>Powód</InputLabel>
                    <Select
                      label="Powód"
                      name="powod"
                      value={editedData.powod || ""}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="Dyspozycja">Dyspozycja</MenuItem>
                      <MenuItem value="Gabaryt">Gabaryt</MenuItem>
                      <MenuItem value="Inne">Inne</MenuItem>
                      <MenuItem value="Po upływie 10 dni magazynowania">
                        Po upływie 10 dni magazynowania
                      </MenuItem>
                    </Select>
                  </FormControl>
                )}
                {editField === "wniosek" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">Wniosek</InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.wniosek}
                      onChange={handleInputChange}
                      name={editField}
                    >
                      <MenuItem value="Tak">Tak</MenuItem>
                      <MenuItem value="Nie">Nie</MenuItem>
                    </Select>
                  </FormControl>
                )}
              </>
            ) : rowData.rodzajTransportu === "Magazyn Warszawa Handling" ? (
              <>
                {editField === "numerListu" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Numer listu przewozowego"
                    variant="outlined"
                    name="numerListu"
                    value={editedData.numerListu || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    required
                    inputProps={{
                      maxLength: 14,
                      minLength: 14,
                    }}
                    error={
                      editedData.numerListu &&
                      editedData.numerListu.length !== 14
                    }
                    helperText={
                      editedData.numerListu &&
                      editedData.numerListu.length !== 14
                        ? "Numer listu przewozowego musi mieć dokładnie 14 znaków"
                        : ""
                    }
                  />
                )}
                {editField === "nadawca" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Nazwa firmy (nadawca)"
                    variant="outlined"
                    name="nadawca"
                    value={editedData.nadawca || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                )}
                {editField === "liczbaPaczek" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Liczba paczek"
                    variant="outlined"
                    type="number"
                    name="liczbaPaczek"
                    value={editedData.liczbaPaczek || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    inputProps={{ min: 0 }}
                  />
                )}
                {editField === "liczbaPalet" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Liczba palet"
                    variant="outlined"
                    type="number"
                    name="liczbaPalet"
                    value={editedData.liczbaPalet || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    inputProps={{ min: 0 }}
                  />
                )}
                {editField === "kierunek" && isEditing && (
                  <FormControl
                    variant="outlined"
                    className={classes.inputField}
                  >
                    <InputLabel>Kierunek</InputLabel>
                    <Select
                      label="Kierunek"
                      name="kierunek"
                      value={editedData.kierunek || ""}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="GB">GB</MenuItem>
                      <MenuItem value="CH">CH</MenuItem>
                      <MenuItem value="NO">NO</MenuItem>
                      <MenuItem value="BA">BA</MenuItem>
                      <MenuItem value="RS">RS</MenuItem>
                      <MenuItem value="Lotniczy">Lotniczy</MenuItem>
                    </Select>
                  </FormControl>
                )}
              </>
            ) : rowData.rodzajTransportu ===
              "Magazyn Warszawa Nowy Handling" ? (
              <>
                {/* Przyjęcie */}
                {editField === "przyjazdAuta" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Przyjazd auta"
                    variant="outlined"
                    type="time"
                    name="przyjazdAuta"
                    value={editedData.przyjazdAuta || ""}
                    onChange={handleInputChange}
                    InputLabelProps={{ shrink: true }}
                    autoComplete="off"
                    error={
                      !!editedData.przyjazdAuta &&
                      !timeGte(
                        editedData.startSkanowania ?? rowData.startSkanowania,
                        editedData.przyjazdAuta,
                      )
                    }
                    helperText={
                      !!editedData.przyjazdAuta &&
                      !timeGte(
                        editedData.startSkanowania ?? rowData.startSkanowania,
                        editedData.przyjazdAuta,
                      )
                        ? "Przyjazd auta nie może być późniejszy niż start skanowania"
                        : ""
                    }
                  />
                )}
                {editField === "startSkanowania" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Start skanowania"
                    variant="outlined"
                    type="time"
                    name="startSkanowania"
                    value={editedData.startSkanowania || ""}
                    onChange={handleInputChange}
                    InputLabelProps={{ shrink: true }}
                    autoComplete="off"
                    error={
                      !!editedData.startSkanowania &&
                      !timeGte(
                        editedData.startSkanowania,
                        editedData.przyjazdAuta ?? rowData.przyjazdAuta,
                      )
                    }
                    helperText={
                      !!editedData.startSkanowania &&
                      !timeGte(
                        editedData.startSkanowania,
                        editedData.przyjazdAuta ?? rowData.przyjazdAuta,
                      )
                        ? "Start skanowania nie może być wcześniejszy niż przyjazd auta"
                        : ""
                    }
                  />
                )}
                {editField === "numerListu" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Numer listu przewozowego"
                    variant="outlined"
                    name="numerListu"
                    value={editedData.numerListu || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    required
                    inputProps={{
                      maxLength: 14,
                      minLength: 14,
                    }}
                    error={
                      editedData.numerListu &&
                      editedData.numerListu.length !== 14
                    }
                    helperText={
                      editedData.numerListu &&
                      editedData.numerListu.length !== 14
                        ? "Numer listu przewozowego musi mieć dokładnie 14 znaków"
                        : ""
                    }
                  />
                )}
                {editField === "nadawca" && isEditing && (
                  <div className={classes.inputField}>
                    <CompanyCell
                      value={editedData.nadawca ?? ""}
                      companies={mwCompaniesList}
                      dict={mwCompanyDict}
                      onChange={(v) =>
                        setEditedData((prev) => ({ ...prev, nadawca: v }))
                      }
                      onCommit={(v) =>
                        setEditedData((prev) => ({ ...prev, nadawca: v }))
                      }
                      onBlurCommit={() => {
                        const key = normalizeCompany(editedData.nadawca);
                        if (mwCompanyDict.has(key)) {
                          setEditedData((prev) => ({
                            ...prev,
                            nadawca: mwCompanyDict.get(key),
                          }));
                        }
                      }}
                      onAddCompany={handleAddMwCompany}
                    />
                  </div>
                )}
                {/* Obsługa */}
                {editField === "kierunek" && isEditing && (
                  <FormControl
                    variant="outlined"
                    className={classes.inputField}
                  >
                    <InputLabel>Kierunek</InputLabel>
                    <Select
                      label="Kierunek"
                      name="kierunek"
                      value={editedData.kierunek || ""}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="GB">GB</MenuItem>
                      <MenuItem value="CH">CH</MenuItem>
                      <MenuItem value="NO">NO</MenuItem>
                      <MenuItem value="BA">BA</MenuItem>
                      <MenuItem value="RS">RS</MenuItem>
                      <MenuItem value="Lotniczy">Lotniczy</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {editField === "iloscDeklPaczek" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Ilość dekl. paczek"
                    variant="outlined"
                    type="number"
                    name="iloscDeklPaczek"
                    value={editedData.iloscDeklPaczek || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    inputProps={{ min: 0 }}
                  />
                )}
                {editField === "iloscDeklPalet" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Ilość dekl. palet"
                    variant="outlined"
                    type="number"
                    name="iloscDeklPalet"
                    value={editedData.iloscDeklPalet || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    inputProps={{ min: 0 }}
                  />
                )}
                {editField === "iloscFaktPaczek" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Ilość fakt. paczek"
                    variant="outlined"
                    type="number"
                    name="iloscFaktPaczek"
                    value={editedData.iloscFaktPaczek || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    inputProps={{ min: 0 }}
                  />
                )}
                {editField === "iloscFaktPalet" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Ilość fakt. palet"
                    variant="outlined"
                    type="number"
                    name="iloscFaktPalet"
                    value={editedData.iloscFaktPalet || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    inputProps={{ min: 0 }}
                  />
                )}
                {editField === "problemZPrzesylka" && isEditing && (
                  <>
                    <FormControl className={classes.formControlWidth}>
                      <InputLabel id="select-problem-label">
                        Problem z przesyłką
                      </InputLabel>
                      <Select
                        labelId="select-problem-label"
                        value={editedData.problemZPrzesylka || ""}
                        onChange={handleInputChange}
                        name={editField}
                      >
                        <MenuItem value="Tak">Tak</MenuItem>
                        <MenuItem value="Nie">Nie</MenuItem>
                      </Select>
                    </FormControl>

                    {editedData.problemZPrzesylka === "Tak" && (
                      <div
                        className={classes.inputField}
                        style={{ marginTop: 8 }}
                      >
                        <Typography
                          variant="body2"
                          style={{ marginBottom: 6, color: "#555" }}
                        >
                          Wpisz adresata (lub kilku) wiadomości. Powiadomienie
                          mailowe o problemie z przesyłką zostanie przesłane do
                          wszystkich wskazanych adresatów.
                        </Typography>
                        <RecipientsCell
                          value={
                            editedData.adresatProblemu ??
                            rowData.adresatProblemu ??
                            ""
                          }
                          options={adresaciList}
                          dict={adresaciDict}
                          onChange={(v) =>
                            setEditedData((prev) => ({
                              ...prev,
                              adresatProblemu: v,
                            }))
                          }
                          onAddOption={handleAddAdresat}
                        />

                        <TextField
                          style={{ marginTop: 14 }}
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={12}
                          variant="outlined"
                          label="Opis problemu (treść zostanie przesłana w wiadomości email)"
                          name="opisProblemu"
                          value={
                            editedData.opisProblemu ??
                            rowData.opisProblemu ??
                            ""
                          }
                          onChange={(e) =>
                            setEditedData((prev) => ({
                              ...prev,
                              opisProblemu: e.target.value,
                            }))
                          }
                        />

                        <FormControl
                          className={classes.formControlWidth}
                          style={{ marginTop: 14 }}
                        >
                          <InputLabel id="select-przenies-zwroty-label">
                            Czy przenieść do Zwroty i Błędy?
                          </InputLabel>
                          <Select
                            labelId="select-przenies-zwroty-label"
                            value={editedData.przeniesDoZwrotow || "Nie"}
                            onChange={(e) =>
                              setEditedData((prev) => ({
                                ...prev,
                                przeniesDoZwrotow: e.target.value,
                              }))
                            }
                          >
                            <MenuItem value="Nie">Nie</MenuItem>
                            <MenuItem value="Tak">Tak</MenuItem>
                          </Select>
                          {editedData.przeniesDoZwrotow === "Tak" && (
                            <Typography
                              variant="caption"
                              style={{ marginTop: 4, color: "#b26a00" }}
                            >
                              Po zapisie zgłoszenie zostanie przeniesione do
                              „Magazyn Warszawa Zwroty i Błędy".
                            </Typography>
                          )}
                        </FormControl>
                      </div>
                    )}
                  </>
                )}
                {editField === "zakonczenieSkanowania" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Zakończenie skanowania"
                    variant="outlined"
                    type="time"
                    name="zakonczenieSkanowania"
                    value={editedData.zakonczenieSkanowania || ""}
                    onChange={handleInputChange}
                    InputLabelProps={{ shrink: true }}
                    autoComplete="off"
                    error={
                      !!editedData.zakonczenieSkanowania &&
                      !timeGte(
                        editedData.zakonczenieSkanowania,
                        editedData.startSkanowania ?? rowData.startSkanowania,
                      )
                    }
                    helperText={
                      !!editedData.zakonczenieSkanowania &&
                      !timeGte(
                        editedData.zakonczenieSkanowania,
                        editedData.startSkanowania ?? rowData.startSkanowania,
                      )
                        ? "Zakończenie skanowania nie może być wcześniejsze niż start skanowania"
                        : ""
                    }
                  />
                )}
                {editField === "towarCelny" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-towar-celny-label">
                      Towar celny
                    </InputLabel>
                    <Select
                      labelId="select-towar-celny-label"
                      value={editedData.towarCelny || ""}
                      onChange={handleInputChange}
                      name={editField}
                    >
                      <MenuItem value="Tak">Tak</MenuItem>
                      <MenuItem value="Nie">Nie</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {/* Odprawa celna (widoczna gdy Towar celny = Tak) */}
                {editField === "osobaPrzygotowujacaOdprawe" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-osoba-nh-label">
                      Osoba przygotowująca odprawę
                    </InputLabel>
                    <Select
                      labelId="select-osoba-nh-label"
                      value={editedData.osobaPrzygotowujacaOdprawe || ""}
                      onChange={handleInputChange}
                      name={editField}
                    >
                      <MenuItem value="">Brak przypisania osoby</MenuItem>
                      {uzytkownicyList.map((item) => (
                        <MenuItem key={item.id} value={item.name}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                {editField === "MRN" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="MRN"
                    variant="outlined"
                    name="MRN"
                    value={editedData.MRN || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    error={
                      !!editedData.MRN &&
                      !/^(2[5-9]|[3-9][0-9])PL[A-Z0-9]{14,16}$/.test(
                        editedData.MRN,
                      )
                    }
                    helperText={
                      !!editedData.MRN &&
                      !/^(2[5-9]|[3-9][0-9])PL[A-Z0-9]{14,16}$/.test(
                        editedData.MRN,
                      )
                        ? "MRN musi zaczynać się od '25PL' i zawierać 18-20 znaków alfanumerycznych"
                        : ""
                    }
                  />
                )}
                {editField === "iloscPozycjiSAD" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Ilość pozycji SAD"
                    variant="outlined"
                    type="number"
                    name="iloscPozycjiSAD"
                    value={editedData.iloscPozycjiSAD || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                    inputProps={{ min: 0 }}
                  />
                )}
                {editField === "Rewizja" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-rewizja-nh-label">
                      Rewizja
                    </InputLabel>
                    <Select
                      labelId="select-rewizja-nh-label"
                      value={editedData.Rewizja || ""}
                      onChange={handleInputChange}
                      name={editField}
                    >
                      <MenuItem value="Tak">Tak</MenuItem>
                      <MenuItem value="Nie">Nie</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {editField === "serwisLotniczy" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-serwis-nh-label">
                      Serwis lotniczy
                    </InputLabel>
                    <Select
                      labelId="select-serwis-nh-label"
                      value={editedData.serwisLotniczy || ""}
                      onChange={handleInputChange}
                      name={editField}
                    >
                      <MenuItem value="Tak">Tak</MenuItem>
                      <MenuItem value="Nie">Nie</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {/* Wydanie towaru */}
                {editField === "podjazdAuta" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Podjazd auta (godzina)"
                    variant="outlined"
                    type="time"
                    name="podjazdAuta"
                    value={nhTimePart(
                      editedData.podjazdAuta ?? rowData.podjazdAuta ?? "",
                    )}
                    onChange={(e) =>
                      setEditedData((prev) => ({
                        ...prev,
                        podjazdAuta: e.target.value,
                      }))
                    }
                    InputLabelProps={{ shrink: true }}
                    autoComplete="off"
                    helperText="Data zostanie uzupełniona automatycznie (dzisiejsza)"
                  />
                )}
                {editField === "wyjazdAuta" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Godzina wyjazdu auta"
                    variant="outlined"
                    type="time"
                    name="wyjazdAuta"
                    value={nhTimePart(
                      editedData.wyjazdAuta ?? rowData.wyjazdAuta ?? "",
                    )}
                    onChange={(e) =>
                      setEditedData((prev) => ({
                        ...prev,
                        wyjazdAuta: e.target.value,
                      }))
                    }
                    InputLabelProps={{ shrink: true }}
                    autoComplete="off"
                    error={wyjazdBeforePodjazd(editedData, rowData)}
                    helperText={
                      wyjazdBeforePodjazd(editedData, rowData)
                        ? "Nie może być wcześniejsza niż podjazd auta"
                        : "Data zostanie uzupełniona automatycznie (dzisiejsza)"
                    }
                  />
                )}
              </>
            ) : (
              <>
                {editField === "lokalizacjaTowaru" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">
                      {rowData.rodzaj === "Tranzyt"
                        ? "Urząd celny wyjścia"
                        : "Lokalizacja towaru"}
                    </InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.lokalizacjaTowaru}
                      onChange={handleInputChange}
                      name={editField}
                      className={classes.marginBottom} // Apply marginBottom style to the TextField
                    >
                      {lokalizacjaList.map((item) => (
                        <MenuItem key={item.id} value={item.name}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {editField === "nota_ksiegowa" &&
                  isEditing &&
                  rowData.przelew && (
                    <TextField
                      className={classes.inputField}
                      label="Nota Księgowa"
                      variant="outlined"
                      name="nota_ksiegowa"
                      value={editedData.nota_ksiegowa || ""}
                      onChange={handleInputChange}
                      autoComplete="off"
                    />
                  )}
                {editField === "nrFaktury" && isEditing && (
                  <>
                    <Button
                      variant="outlined"
                      onClick={handleOpenInvoiceDialog}
                      className={classes.inputField}
                    >
                      {editedData.nrFaktury?.trim()
                        ? editedData.nrFaktury
                        : "Dodaj numery faktur"}
                    </Button>

                    <InvoiceEditorDialog
                      open={openInvoiceDialog}
                      initialValue={editedData.nrFaktury || ""}
                      onSave={handleSaveInvoices}
                      onClose={handleCloseInvoiceDialog}
                    />
                  </>
                )}
                {editField === "osobaWysylajacaOdprawe" && isEditing && (
                  <div>
                    <FormControl className={classes.formControlWidth}>
                      <InputLabel id="select-list-label">
                        Osoba wysyłająca odprawę
                      </InputLabel>
                      <Select
                        labelId="select-list-label"
                        id="select-list"
                        value={editedData.osobaWysylajacaOdprawe}
                        onChange={handleInputChange}
                        name={editField}
                        className={classes.marginBottom}
                      >
                        <MenuItem value="" style={{ fontWeight: "bold" }}>
                          Brak przypisania osoby
                        </MenuItem>
                        {uzytkownicyList.map((item) => (
                          <MenuItem key={item.id} value={item.name}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Typography
                      variant="caption"
                      style={{
                        display: "block",
                        marginTop: "8px",
                        color: "#1976d2",
                        fontStyle: "italic",
                        fontSize: "14px",
                      }}
                    >
                      ℹ️ Po zapisaniu zmiany, przypisana osoba zostanie
                      automatycznie powiadomiona emailem o nowej odprawie do
                      wysłania
                    </Typography>
                  </div>
                )}
                {editField === "osobaPrzygotowujacaOdprawe" && isEditing && (
                  <div>
                    <FormControl className={classes.formControlWidth}>
                      <InputLabel id="select-list-label">
                        Osoba realizująca odprawę
                      </InputLabel>
                      <Select
                        labelId="select-list-label"
                        id="select-list"
                        value={editedData.osobaPrzygotowujacaOdprawe}
                        onChange={handleInputChange}
                        name={editField}
                        className={classes.marginBottom}
                      >
                        <MenuItem value="" style={{ fontWeight: "bold" }}>
                          Brak przypisania osoby
                        </MenuItem>
                        {uzytkownicyList.map((item) => (
                          <MenuItem key={item.id} value={item.name}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Typography
                      variant="caption"
                      style={{
                        display: "block",
                        marginTop: "8px",
                        color: "#1976d2",
                        fontStyle: "italic",
                        fontSize: "14px",
                      }}
                    >
                      ℹ️ Po zapisaniu zmiany, przypisana osoba zostanie
                      automatycznie powiadomiona emailem o nowej odprawie
                    </Typography>
                  </div>
                )}
                {editField === "osobaMonitorujacaOdprawe" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">
                      Osoba wysyłająca odprawę
                    </InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.osobaMonitorujacaOdprawe}
                      onChange={handleInputChange}
                      name={editField}
                      className={classes.marginBottom}
                    >
                      <MenuItem value="" style={{ fontWeight: "bold" }}>
                        Brak przypisania osoby
                      </MenuItem>
                      {uzytkownicyList.map((item) => (
                        <MenuItem key={item.id} value={item.name}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                {editField === "osobaWeryfikujacaOdprawe" && isEditing && (
                  // (rowData.rodzaj === "Eksport" ||
                  //   rowData.rodzaj === "Eksport - wpis do rejestru") &&
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">
                      Osoba weryfikująca odprawę
                    </InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.osobaWeryfikujacaOdprawe}
                      onChange={handleInputChange}
                      name={editField}
                      className={classes.marginBottom}
                    >
                      <MenuItem value="" style={{ fontWeight: "bold" }}>
                        Brak przypisania osoby
                      </MenuItem>
                      {osobyWeryfikujaceEksporty.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                {editField === "statusRealizacji" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">
                      Status realizacji
                    </InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.statusRealizacji}
                      onChange={handleInputChange}
                      name={editField}
                      className={classes.marginBottom}
                    >
                      {(() => {
                        // Opcje statusów dla Tranzytu
                        const statusyTranzyt = [
                          "Do przygotowania",
                          "Wstępnie przygotowane",
                          "Przygotowane",
                          "Do weryfikacji",
                          "Do poprawy",
                          "Do wysłania",
                          "Wysłane",
                          "Przyjęte przez Gwaranta",
                          "Wysłano do urzędu",
                          "Zwolniono do tranzytu",
                          "Tranzyt zakończony",
                          "Anulowane",
                        ];

                        // Opcje statusów dla innych rodzajów
                        const statusyStandardowe = [
                          "Do przygotowania",
                          "Wstępnie przygotowane",
                          "Przygotowane",
                          "Do weryfikacji",
                          "Do poprawy",
                          "Do wysłania",
                          "Wysłane",
                          "Unieważnione przez OC",
                          "Odprawa zakończona",
                          "Zrealizowane",
                          "Anulowane",
                        ];

                        // Wybieramy odpowiednie opcje w zależności od rodzaju
                        const dostepneStatusy =
                          rowData.rodzaj === "Tranzyt"
                            ? statusyTranzyt
                            : statusyStandardowe;

                        // Admin widzi wszystkie opcje dla danego rodzaju, bez ograniczeń
                        if (role === "admin") {
                          return dostepneStatusy.map((status) => (
                            <MenuItem key={status} value={status}>
                              {status}
                            </MenuItem>
                          ));
                        }

                        // Normalni użytkownicy - filtrowanie statusów
                        return dostepneStatusy
                          .filter((status) =>
                            rowData.rodzaj === "Tranzyt"
                              ? rowData.statusRealizacji === "Do przygotowania"
                                ? [
                                    "Wstępnie przygotowane",
                                    "Przygotowane",
                                    "Anulowane",
                                  ].includes(status)
                                : rowData.statusRealizacji ===
                                    "Wstępnie przygotowane"
                                  ? [
                                      "Przygotowane",
                                      "Do weryfikacji",
                                      "Anulowane",
                                    ].includes(status)
                                  : rowData.statusRealizacji === "Przygotowane"
                                    ? [
                                        "Do weryfikacji",
                                        "Do poprawy",
                                        "Do wysłania",
                                        "Anulowane",
                                      ].includes(status)
                                    : rowData.statusRealizacji ===
                                        "Do weryfikacji"
                                      ? [
                                          "Do poprawy",
                                          "Do wysłania",
                                          "Wysłane",
                                          "Anulowane",
                                        ].includes(status)
                                      : rowData.statusRealizacji ===
                                          "Do poprawy"
                                        ? [
                                            "Do wysłania",
                                            "Wysłane",
                                            "Anulowane",
                                          ].includes(status)
                                        : rowData.statusRealizacji ===
                                            "Do wysłania"
                                          ? ["Wysłane", "Anulowane"].includes(
                                              status,
                                            )
                                          : rowData.statusRealizacji ===
                                              "Wysłane"
                                            ? [
                                                "Przyjęte przez Gwaranta",
                                                "Anulowane",
                                              ].includes(status)
                                            : rowData.statusRealizacji ===
                                                "Przyjęte przez Gwaranta"
                                              ? [
                                                  "Wysłano do urzędu",
                                                  "Anulowane",
                                                ].includes(status)
                                              : rowData.statusRealizacji ===
                                                  "Wysłano do urzędu"
                                                ? [
                                                    "Zwolniono do tranzytu",
                                                    "Anulowane",
                                                  ].includes(status)
                                                : rowData.statusRealizacji ===
                                                    "Zwolniono do tranzytu"
                                                  ? [
                                                      "Tranzyt zakończony",
                                                      "Anulowane",
                                                    ].includes(status)
                                                  : rowData.statusRealizacji ===
                                                      "Tranzyt zakończony"
                                                    ? [
                                                        "Tranzyt zakończony",
                                                      ].includes(status)
                                                    : rowData.statusRealizacji ===
                                                        "Anulowane"
                                                      ? ["Anulowane"].includes(
                                                          status,
                                                        )
                                                      : true
                              : // Filtrowanie dla standardowych statusów
                                rowData.statusRealizacji === "Do przygotowania"
                                ? true
                                : rowData.statusRealizacji ===
                                    "Wstępnie przygotowane"
                                  ? [
                                      "Przygotowane",
                                      "Do weryfikacji",
                                      "Do poprawy",
                                      "Do wysłania",
                                      "Wysłane",
                                      "Unieważnione przez OC",
                                      "Zrealizowane",
                                    ].includes(status)
                                  : rowData.statusRealizacji === "Przygotowane"
                                    ? [
                                        "Do weryfikacji",
                                        "Do poprawy",
                                        "Do wysłania",
                                        "Wysłane",
                                        "Unieważnione przez OC",
                                        "Zrealizowane",
                                      ].includes(status)
                                    : rowData.statusRealizacji ===
                                        "Do weryfikacji"
                                      ? [
                                          "Do poprawy",
                                          "Do wysłania",
                                          "Wysłane",
                                          "Unieważnione przez OC",
                                          "Zrealizowane",
                                        ].includes(status)
                                      : rowData.statusRealizacji ===
                                          "Do poprawy"
                                        ? [
                                            "Do wysłania",
                                            "Wysłane",
                                            "Unieważnione przez OC",
                                            "Zrealizowane",
                                          ].includes(status)
                                        : rowData.statusRealizacji ===
                                            "Do wysłania"
                                          ? [
                                              "Wysłane",
                                              "Unieważnione przez OC",
                                              "Zrealizowane",
                                            ].includes(status)
                                          : rowData.statusRealizacji ===
                                              "Wysłane"
                                            ? [
                                                "Unieważnione przez OC",
                                                "Odprawa zakończona",
                                                "Zrealizowane",
                                                "Anulowane",
                                              ].includes(status)
                                            : rowData.statusRealizacji ===
                                                "Odprawa zakończona"
                                              ? ["Zrealizowane"].includes(
                                                  status,
                                                )
                                              : rowData.statusRealizacji ===
                                                  "Anulowane"
                                                ? ["Anulowane"].includes(status)
                                                : true,
                          )
                          .map((status) => (
                            <MenuItem key={status} value={status}>
                              {status}
                            </MenuItem>
                          ));
                      })()}
                    </Select>
                  </FormControl>
                )}
                {editField === "rodzaj" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">Rodzaj</InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.rodzaj}
                      onChange={handleInputChange}
                      name={editField}
                      className={classes.marginBottom} // Apply marginBottom style to the TextField
                    >
                      <MenuItem value="Import">Import</MenuItem>
                      <MenuItem value="Eksport">Eksport</MenuItem>
                      <MenuItem value="Tranzyt">Tranzyt</MenuItem>
                      <MenuItem value="Wyprowadzenie ze składu">
                        Wyprowadzenie ze składu
                      </MenuItem>
                      <MenuItem value="Wprowadzenie na skład">
                        Wprowadzenie na skład
                      </MenuItem>
                      <MenuItem value="Uszlachetnianie czynne">
                        Uszlachetnianie czynne
                      </MenuItem>
                      <MenuItem value="Uszlachetnianie bierne">
                        Uszlachetnianie bierne
                      </MenuItem>
                      <MenuItem value="Powrotny przywóz">
                        Powrotny przywóz
                      </MenuItem>
                      <MenuItem value="Powrotny wywóz">Powrotny wywóz</MenuItem>
                      <MenuItem value="Eksport - wpis do rejestru">
                        Eksport - wpis do rejestru
                      </MenuItem>
                      <MenuItem value="Import - wpis do rejestru">
                        Import - wpis do rejestru
                      </MenuItem>
                      <MenuItem value="Symulacja sad">Symulacja sad</MenuItem>
                      <MenuItem value="Eksport PL i import inny kraj">
                        Eksport PL i import inny kraj
                      </MenuItem>
                      <MenuItem value="Odprawa czasowa import">
                        Odprawa czasowa import
                      </MenuItem>
                      <MenuItem value="Odprawa czasowa eksport">
                        Odprawa czasowa eksport
                      </MenuItem>
                    </Select>
                  </FormControl>
                )}
                {editField === "Rewizja" && isEditing && (
                  <FormControl
                    component="fieldset"
                    className={classes.formControlWidth}
                  >
                    <FormLabel component="legend">
                      Czy została przeprowadzona rewizja?
                    </FormLabel>
                    <RadioGroup
                      aria-label=" Czy została przeprowadzona rewizja?"
                      name="Rewizja"
                      value={editedData.Rewizja}
                      onChange={handleInputChange}
                    >
                      <FormControlLabel
                        value="Tak"
                        control={<Radio color="primary" />}
                        label="Tak"
                      />
                      <FormControlLabel
                        value="Nie"
                        control={<Radio color="primary" />}
                        label="Nie"
                        className={classes.marginBottom} // Apply marginBottom style to the TextField
                      />
                    </RadioGroup>
                  </FormControl>
                )}
                {editField === "dokPrzedPrzybyciem" && isEditing && (
                  <FormControl
                    component="fieldset"
                    className={classes.formControlWidth}
                  >
                    <FormLabel component="legend">
                      Czy zostały dostarczone dokumenty przed przybyciem?
                    </FormLabel>
                    <RadioGroup
                      name="dokPrzedPrzybyciem"
                      value={editedData.dokPrzedPrzybyciem}
                      onChange={handleInputChange}
                    >
                      <FormControlLabel
                        value="Tak"
                        control={<Radio color="primary" />}
                        label="Tak"
                      />
                      <FormControlLabel
                        value="Nie"
                        control={<Radio color="primary" />}
                        label="Nie"
                        className={classes.marginBottom} // Apply marginBottom style to the TextField
                      />
                    </RadioGroup>
                  </FormControl>
                )}
                {editField === "data" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Data T1 Format DD-MM-YYYY"
                    variant="outlined"
                    name="data"
                    value={editedData.data}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                )}
                {editField === "data_ie" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Data IE045 Format YYYY-MM-DD"
                    variant="outlined"
                    name="data_ie"
                    value={editedData.data_ie}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                )}
                {editField === "rodzajTransportu" && isEditing && (
                  <FormControl
                    component="fieldset"
                    className={classes.formControlWidth}
                  >
                    <FormLabel component="legend">Rodzaj transportu?</FormLabel>
                    <RadioGroup
                      name="rodzajTransportu"
                      value={editedData.rodzajTransportu}
                      onChange={handleInputChange}
                    >
                      <FormControlLabel
                        value="Kurier"
                        control={<Radio color="primary" />}
                        label="Kurier"
                      />
                      <FormControlLabel
                        value="Na Kołach"
                        control={<Radio color="primary" />}
                        label="Na Kołach"
                      />
                      <FormControlLabel
                        value="W drodze"
                        control={<Radio color="primary" />}
                        label="W drodze"
                      />
                    </RadioGroup>
                  </FormControl>
                )}
                {editField === "gwarant" && isEditing && (
                  <FormControl
                    component="fieldset"
                    className={classes.formControlWidth}
                  >
                    <FormLabel component="legend">Gwarant</FormLabel>
                    <RadioGroup
                      name="gwarant"
                      value={editedData.gwarant}
                      onChange={handleInputChange}
                    >
                      <FormControlLabel
                        value="SGS"
                        control={<Radio color="primary" />}
                        label="SGS"
                      />
                      <FormControlLabel
                        value="OREGON"
                        control={<Radio color="primary" />}
                        label="OREGON"
                      />
                    </RadioGroup>
                  </FormControl>
                )}
                {editField === "kwota_gwarancji" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Kwota gwarancji w PLN"
                    variant="outlined"
                    name="kwota_gwarancji"
                    value={editedData.kwota_gwarancji || ""}
                    onChange={handleInputChange}
                    inputProps={{
                      inputMode: "decimal",
                      pattern: "[0-9]*[.,]?[0-9]*",
                      min: 0,
                    }}
                    autoComplete="off"
                  />
                )}
                {editField === "waluta" && isEditing && (
                  <FormControl
                    component="fieldset"
                    className={classes.formControlWidth}
                  >
                    <FormLabel component="legend">Waluta</FormLabel>
                    <RadioGroup
                      aria-label="Waluta"
                      name="waluta"
                      value={editedData.waluta}
                      onChange={handleInputChange}
                    >
                      <FormControlLabel
                        value="EUR"
                        control={<Radio color="primary" />}
                        label="Euro"
                      />
                      <FormControlLabel
                        value="USD"
                        control={<Radio color="primary" />}
                        label="USD"
                      />
                      <FormControlLabel
                        value="Zł"
                        control={<Radio color="primary" />}
                        label="ZŁ"
                      />
                      <FormControlLabel
                        value="GBP"
                        control={<Radio color="primary" />}
                        label="GBP"
                      />
                      <FormControlLabel
                        value="WIELE"
                        control={<Radio color="primary" />}
                        label="WIELE"
                      />
                    </RadioGroup>
                  </FormControl>
                )}
                {editField === "urzad_tranzytowy" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">
                      Przewidywany urząd tranzytowy
                    </InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.urzad_tranzytowy}
                      onChange={handleInputChange}
                      name={editField}
                      className={classes.marginBottom}
                    >
                      <MenuItem value="" style={{ fontWeight: "bold" }}>
                        Brak przewidywanego urzędu tranzytowego
                      </MenuItem>
                      {urzadTranzytowyList.map((item) => (
                        <MenuItem key={item.id} value={item.name}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                {editField === "urzad_przeznaczenia" && isEditing && (
                  <FormControl className={classes.formControlWidth}>
                    <InputLabel id="select-list-label">
                      Urząd celny przeznaczenia
                    </InputLabel>
                    <Select
                      labelId="select-list-label"
                      id="select-list"
                      value={editedData.urzad_przeznaczenia}
                      onChange={handleInputChange}
                      name={editField}
                      className={classes.marginBottom}
                    >
                      <MenuItem value="" style={{ fontWeight: "bold" }}>
                        Brak urzędu celnego przeznaczenia
                      </MenuItem>
                      {urzadPrzeznaczeniaList.map((item) => (
                        <MenuItem key={item.id} value={item.name}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                {editField === "pliki" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="Ścieżka do plików"
                    variant="outlined"
                    name="pliki"
                    value={editedData.pliki || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                )}
                {editField === "MRN" && isEditing && (
                  <TextField
                    className={classes.inputField}
                    label="MRN"
                    variant="outlined"
                    name="MRN"
                    value={editedData.MRN || ""}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                )}
                {editField === "importer" && isEditing && (
                  <>
                    {isImporterListMode ? (
                      <FormControl className={classes.formControlWidth}>
                        <InputLabel id="importer-select-label">
                          Importer
                        </InputLabel>
                        <Select
                          labelId="importer-select-label"
                          value={editedData.importer || ""}
                          onChange={handleInputChange}
                          name="importer"
                          className={classes.marginBottom}
                          label="Importer"
                          MenuProps={{
                            getContentAnchorEl: null,
                          }}
                        >
                          <ListSubheader>
                            <TextField
                              size="small"
                              autoFocus
                              placeholder="Szukaj importera..."
                              fullWidth
                              value={importerSearchTerm}
                              onChange={(event) =>
                                setImporterSearchTerm(event.target.value)
                              }
                              onClick={(event) => event.stopPropagation()}
                              onKeyDown={(event) => event.stopPropagation()}
                            />
                          </ListSubheader>
                          {filteredImporterOptions.map((item) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                          {filteredImporterOptions.length === 0 && (
                            <MenuItem disabled>Brak wyników</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    ) : (
                      <TextField
                        className={classes.inputField}
                        label="Importer"
                        variant="outlined"
                        name="importer"
                        autoComplete="off"
                        value={editedData.importer || ""}
                        onChange={handleInputChange}
                      />
                    )}
                  </>
                )}
                {editField === "eksporter" && isEditing && (
                  <>
                    {isEksporterListMode ? (
                      <FormControl className={classes.formControlWidth}>
                        <InputLabel id="eksporter-select-label">
                          Eksporter
                        </InputLabel>
                        <Select
                          labelId="eksporter-select-label"
                          value={editedData.eksporter || ""}
                          onChange={handleInputChange}
                          name="eksporter"
                          className={classes.marginBottom}
                          label="Eksporter"
                          MenuProps={{
                            getContentAnchorEl: null,
                          }}
                        >
                          <ListSubheader>
                            <TextField
                              size="small"
                              autoFocus
                              placeholder="Szukaj eksportera..."
                              fullWidth
                              value={eksporterSearchTerm}
                              onChange={(event) =>
                                setEksporterSearchTerm(event.target.value)
                              }
                              onClick={(event) => event.stopPropagation()}
                              onKeyDown={(event) => event.stopPropagation()}
                            />
                          </ListSubheader>
                          {filteredEksporterOptions.map((item) => (
                            <MenuItem key={item} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                          {filteredEksporterOptions.length === 0 && (
                            <MenuItem disabled>Brak wyników</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    ) : (
                      <TextField
                        className={classes.inputField}
                        label="Eksporter"
                        variant="outlined"
                        name="eksporter"
                        autoComplete="off"
                        value={editedData.eksporter || ""}
                        onChange={handleInputChange}
                      />
                    )}
                  </>
                )}

                {isEditing &&
                  ![
                    "importer",
                    "eksporter",
                    "statusRealizacji",
                    "Rewizja",
                    "numerListu",
                    "nadawca",
                    "pliki",
                    "liczbaPaczek",
                    "liczbaPalet",
                    "MRN",
                    "iloscPozycjiSAD",
                    "bladDokumentacji",
                    "rodzajBledu",
                    "zwrot",
                    "powod",
                    "wniosek",
                    "kierunek",
                    "lokalizacjaTowaru",
                    "nota_ksiegowa",
                    "nrFaktury",
                    "osobaWysylajacaOdprawe",
                    "osobaPrzygotowujacaOdprawe",
                    "osobaMonitorujacaOdprawe",
                    "osobaWeryfikujacaOdprawe",
                    "statusRealizacji",
                    "rodzaj",
                    "dokPrzedPrzybyciem",
                    "data",
                    "data_ie",
                    "rodzajTransportu",
                    "gwarant",
                    "kwota_gwarancji",
                    "waluta",
                    "urzad_tranzytowy",
                    "urzad_przeznaczenia",
                    "urzadZgloszenia",
                    "serwisLotniczy",
                    // ...dodaj tu wszystkie pola specjalne...
                  ].includes(editField) && (
                    <TextField
                      className={classes.inputField}
                      label={editField}
                      variant="outlined"
                      name={editField}
                      autoComplete="off"
                      value={editedData[editField] || ""}
                      onChange={handleInputChange}
                    />
                  )}
              </>
            )}
            <Button
              variant="contained"
              color="primary"
              onClick={handleEditSave}
            >
              Save
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleEditCancel}
            >
              Cancel
            </Button>
          </div>
        ) : (
          <>
            <div className={classes.fieldList}>
              <Typography variant="h6" className={classes.categoryHeading}>
                Wybierz pole do edycji:
              </Typography>
              {Object.entries(categories).map(
                ([categoryName, fieldsInCategory]) => {
                  // Pokazuj tylko odpowiednią kategorię w zależności od rodzaju transportu
                  const isNowyHandling =
                    rowData.rodzajTransportu ===
                    "Magazyn Warszawa Nowy Handling";
                  const nowyHandlingCategories = [
                    "Przyjęcie",
                    "Obsługa",
                    "Odprawa celna",
                    "Wydanie towaru",
                  ];
                  const isNowyHandlingCategory =
                    nowyHandlingCategories.includes(categoryName);
                  // Sekcje Nowego Handlingu widoczne tylko dla tego typu.
                  if (isNowyHandling && !isNowyHandlingCategory) {
                    return null;
                  }
                  if (!isNowyHandling && isNowyHandlingCategory) {
                    return null;
                  }
                  // "Odprawa celna" tylko gdy Towar celny = Tak.
                  if (
                    isNowyHandling &&
                    categoryName === "Odprawa celna" &&
                    rowData.towarCelny !== "Tak"
                  ) {
                    return null;
                  }
                  if (
                    rowData.rodzajTransportu === "Magazyn Warszawa" &&
                    categoryName !== "Magazyn Warszawa"
                  ) {
                    return null;
                  }
                  if (
                    rowData.rodzajTransportu !== "Magazyn Warszawa" &&
                    categoryName === "Magazyn Warszawa"
                  ) {
                    return null;
                  }

                  if (
                    rowData.rodzajTransportu ===
                      "Magazyn Warszawa Zwroty i Błędy" &&
                    categoryName !== "Magazyn Warszawa Zwroty i Błędy"
                  ) {
                    return null;
                  }
                  if (
                    rowData.rodzajTransportu !==
                      "Magazyn Warszawa Zwroty i Błędy" &&
                    categoryName === "Magazyn Warszawa Zwroty i Błędy"
                  ) {
                    return null;
                  }

                  if (
                    rowData.rodzajTransportu === "Magazyn Warszawa Handling" &&
                    categoryName !== "Magazyn Warszawa Handling"
                  ) {
                    return null;
                  }
                  if (
                    rowData.rodzajTransportu !== "Magazyn Warszawa Handling" &&
                    categoryName === "Magazyn Warszawa Handling"
                  ) {
                    return null;
                  }
                  // Warunek nie renderowania kategorii "Szczegóły Finansowe i Tranzytu"
                  if (
                    categoryName === "Szczegóły Finansowe i Tranzytu" &&
                    rowData.rodzaj !== "Tranzyt"
                  ) {
                    return null;
                  }

                  return (
                    <div key={categoryName} className={classes.categoryRow}>
                      <Typography
                        variant="h6"
                        className={classes.categoryHeading}
                      >
                        {categoryName}
                      </Typography>
                      <div className={classes.fieldBlocksRow}>
                        {fieldsInCategory.map((field) => {
                          if (
                            rowData &&
                            shouldDisplayField(field, rowData, role) &&
                            !(
                              field === "nrTranzytu" &&
                              rowData.rodzaj === "Tranzyt"
                            )
                          ) {
                            const customLabel = fieldLabels[field] || field;
                            const label =
                              field === "lokalizacjaTowaru" &&
                              rowData.rodzaj === "Tranzyt"
                                ? "Urząd celny wyjścia"
                                : customLabel;
                            const isNowyHandling =
                              rowData.rodzajTransportu ===
                              "Magazyn Warszawa Nowy Handling";
                            const isValidChip = isNowyHandling
                              ? isNowyHandlingFieldValid(
                                  field,
                                  rowData,
                                  mwCompanyDict,
                                )
                              : isZwrotyIBledyFieldValid(field, rowData); // pozostałe rodzaje: niepuste = zielony
                            // Blokady sekcji (Nowy Handling):
                            //  - "Obsługa" (poza "Towar celny"): dopoki "Towar celny" pusty
                            //  - "Podjazd auta": dopoki cala "Obsługa" niekompletna
                            //  - "Godzina wyjazdu auta": dopiero w statusie "Towar do wydania"
                            let lockHint = "";
                            if (isNowyHandling) {
                              if (
                                categoryName === "Obsługa" &&
                                field !== "towarCelny" &&
                                !String(rowData.towarCelny ?? "").trim()
                              ) {
                                lockHint = TOWAR_CELNY_LOCK_HINT;
                              } else if (
                                field === "kierunek" &&
                                String(rowData.serwisLotniczy ?? "").trim() ===
                                  "Tak"
                              ) {
                                lockHint = KIERUNEK_SERWIS_LOTNICZY_LOCK_HINT;
                              } else if (
                                field === "podjazdAuta" &&
                                !isPodjazdAutaUnlocked(rowData)
                              ) {
                                lockHint = PODJAZD_AUTA_LOCK_HINT;
                              } else if (
                                field === "wyjazdAuta" &&
                                !isWyjazdAutaUnlocked(rowData)
                              ) {
                                if (canReleaseNhGoods(rowData)) {
                                  lockHint = WYJAZD_AUTA_RELEASE_HINT;
                                } else if (
                                  !nhObslugaComplete(rowData) ||
                                  (rowData.towarCelny === "Tak" &&
                                    !nhOdprawaCelnaComplete(rowData))
                                ) {
                                  lockHint = WYDANIE_TOWARU_LOCK_HINT;
                                } else {
                                  lockHint = WYJAZD_AUTA_LOCK_HINT;
                                }
                              } else if (
                                ILOSC_PALETY_FIELDS.includes(field) &&
                                iloscPaczkiActive(rowData) &&
                                !iloscPaletyActive(rowData)
                              ) {
                                lockHint = ILOSC_PACZKI_LOCK_HINT;
                              } else if (
                                ILOSC_PACZKI_FIELDS.includes(field) &&
                                iloscPaletyActive(rowData) &&
                                !iloscPaczkiActive(rowData)
                              ) {
                                lockHint = ILOSC_PALETY_LOCK_HINT;
                              }
                            }
                            const locked = Boolean(lockHint);

                            const chip = (
                              <div
                                key={field}
                                className={
                                  locked
                                    ? `${classes.fieldBlock} ${classes.fieldBlockLocked}`
                                    : isValidChip
                                      ? `${classes.fieldBlock} ${classes.fieldBlockValid}`
                                      : classes.fieldBlock
                                }
                                onClick={
                                  locked
                                    ? undefined
                                    : () => handleFieldSelect(field)
                                }
                              >
                                <Typography className={classes.fieldLabel}>
                                  {label}
                                </Typography>
                              </div>
                            );

                            return locked ? (
                              <Tooltip key={field} arrow title={lockHint}>
                                {chip}
                              </Tooltip>
                            ) : (
                              chip
                            );
                          }
                          return null;
                        })}
                      </div>
                    </div>
                  );
                },
              )}
            </div>
          </>
        )}
        <hr className={classes.wider} />
        {rowData.rodzajTransportu === "Magazyn Warszawa" ? (
          // Pola dla Magazyn Warszawa
          <>
            <div className={classes.nhStatusBar}>
              <span className={classes.nhStatusLabel}>Status realizacji</span>
              <span className={classes.nhStatusValue}>
                {rowData.statusRealizacji || "—"}
              </span>
            </div>

            <div className={classes.nhSummaryWrap}>
              <div className={classes.nhSummaryCol}>
                <div className={classes.nhCard}>
                  <div className={classes.nhCardTitle}>Dane przesyłki</div>
                  {[
                    [
                      "Utworzono dnia",
                      rowData.utworzono
                        ? moment(rowData.utworzono)
                            .tz("Europe/Warsaw")
                            .format("DD-MM-YYYY")
                        : "",
                    ],
                    ["Numer listu przewozowego", rowData.numerListu],
                    ["Nazwa firmy (nadawca)", rowData.nadawca],
                    ["Liczba paczek", rowData.liczbaPaczek],
                    ["Liczba palet", rowData.liczbaPalet],
                    ["Kierunek", rowData.kierunek],
                  ].map(([label, value]) => renderNhRow(classes, label, value))}
                </div>
              </div>

              <div className={classes.nhSummaryCol}>
                <div className={classes.nhCard}>
                  <div className={classes.nhCardTitle}>Odprawa celna</div>
                  {[
                    ["MRN", rowData.MRN],
                    ["Ilość pozycji SAD", rowData.iloscPozycjiSAD],
                    ["Rewizja", rowData.Rewizja],
                    ["Serwis lotniczy", rowData.serwisLotniczy],
                    [
                      "Zgłoszenie zakończono dnia",
                      rowData.endDate
                        ? moment(rowData.endDate)
                            .tz("Europe/Warsaw")
                            .format("HH:mm, DD-MM-YYYY")
                        : "",
                    ],
                    [
                      "Ścieżka do plików",
                      rowData.pliki ? (
                        <FolderPathAction
                          nrRef={rowData.nrRef}
                          path={rowData.pliki}
                        />
                      ) : (
                        ""
                      ),
                    ],
                  ].map(([label, value]) => renderNhRow(classes, label, value))}
                </div>
              </div>
            </div>

            <div className={classes.nhMeta}>
              Utworzone przez: <strong>{rowData.createdBy || "—"}</strong>
            </div>

            <hr className={classes.wider} />
            {id && rowData && (
              <CommentSection
                id={id}
                rowData={rowData}
                onDataRefresh={handleCommentSectionDataRefresh}
                emailRefreshToken={emailRefreshToken}
              />
            )}
            <hr className={classes.wider} />
            <div>
              <Typography variant="h6" className={classes.komentarzeHeading}>
                Komentarze:
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                className={classes.mailNotificationButton}
                onClick={handleRecordMailNotification}
              >
                Odnotuj powiadomienie mailowe
              </Button>
              {comments.map(renderCommentItem)}
            </div>
          </>
        ) : rowData.rodzajTransportu === "Magazyn Warszawa Zwroty i Błędy" ? (
          // Pola dla Magazyn Warszawa Zwroty i Błędy
          <>
            <div className={classes.nhStatusBar}>
              <span className={classes.nhStatusLabel}>Status realizacji</span>
              <span className={classes.nhStatusValue}>
                {rowData.statusRealizacji || "—"}
              </span>
            </div>

            <div className={classes.nhSummaryWrap}>
              <div className={classes.nhSummaryCol}>
                <div className={classes.nhCard}>
                  <div className={classes.nhCardTitle}>Dane przesyłki</div>
                  {[
                    [
                      "Data utworzenia",
                      rowData.utworzono
                        ? moment(rowData.utworzono)
                            .tz("Europe/Warsaw")
                            .format("HH:mm, DD-MM-YYYY")
                        : "",
                    ],
                    ["Nazwa firmy (nadawca)", rowData.nadawca],
                    ["Numer listu przewozowego", rowData.numerListu],
                    ["Liczba paczek", rowData.liczbaPaczek],
                  ].map(([label, value]) => renderNhRow(classes, label, value))}
                </div>
              </div>

              <div className={classes.nhSummaryCol}>
                <div className={classes.nhCard}>
                  <div className={classes.nhCardTitle}>Błąd i zwrot</div>
                  {[
                    ["Błąd dokumentacji", rowData.bladDokumentacji],
                    ["Rodzaj błędu", rowData.rodzajBledu],
                    ["Zwrot", rowData.zwrot],
                    ["Powód zwrotu", rowData.powod],
                    ["Wniosek", rowData.wniosek],
                  ].map(([label, value]) => renderNhRow(classes, label, value))}
                </div>
              </div>
            </div>

            <div className={classes.nhMeta}>
              Utworzone przez: <strong>{rowData.createdBy || "—"}</strong>
            </div>

            <hr className={classes.wider} />
            {id && rowData && (
              <CommentSection
                id={id}
                rowData={rowData}
                onDataRefresh={handleCommentSectionDataRefresh}
                emailRefreshToken={emailRefreshToken}
              />
            )}
            <hr className={classes.wider} />
            <div>
              <Typography variant="h6" className={classes.komentarzeHeading}>
                Komentarze:
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                className={classes.mailNotificationButton}
                onClick={handleRecordMailNotification}
              >
                Odnotuj powiadomienie mailowe
              </Button>
              {comments.map(renderCommentItem)}
            </div>
          </>
        ) : rowData.rodzajTransportu === "Magazyn Warszawa Handling" ? (
          // Pola dla Magazyn Warszawa
          <>
            <div className={classes.nhStatusBar}>
              <span className={classes.nhStatusLabel}>Rodzaj transportu</span>
              <span className={classes.nhStatusValue}>
                {rowData.rodzajTransportu}
              </span>
            </div>

            <div className={classes.nhSummaryWrap}>
              <div className={classes.nhSummaryCol}>
                <div className={classes.nhCard}>
                  <div className={classes.nhCardTitle}>Dane przesyłki</div>
                  {[
                    [
                      "Utworzono dnia",
                      rowData.utworzono
                        ? moment(rowData.utworzono)
                            .tz("Europe/Warsaw")
                            .format("DD-MM-YYYY")
                        : "",
                    ],
                    ["Numer listu przewozowego", rowData.numerListu],
                    ["Nazwa firmy (nadawca)", rowData.nadawca],
                    ["Liczba paczek", rowData.liczbaPaczek],
                    ["Liczba palet", rowData.liczbaPalet],
                    ["Kierunek", rowData.kierunek],
                  ].map(([label, value]) => renderNhRow(classes, label, value))}
                </div>
              </div>
            </div>

            <div className={classes.nhMeta}>
              Utworzone przez: <strong>{rowData.createdBy || "—"}</strong>
            </div>

            <hr className={classes.wider} />
            {id && rowData && (
              <CommentSection
                id={id}
                rowData={rowData}
                onDataRefresh={handleCommentSectionDataRefresh}
                emailRefreshToken={emailRefreshToken}
              />
            )}
            <hr className={classes.wider} />
            <div>
              <Typography variant="h6" className={classes.komentarzeHeading}>
                Komentarze:
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                className={classes.mailNotificationButton}
                onClick={handleRecordMailNotification}
              >
                Odnotuj powiadomienie mailowe
              </Button>
              {comments.map(renderCommentItem)}
            </div>
          </>
        ) : rowData.rodzajTransportu === "Magazyn Warszawa Nowy Handling" ? (
          // Pola dla Magazyn Warszawa - Nowy Handling
          <>
            <div className={classes.nhStatusBar}>
              <span className={classes.nhStatusLabel}>Status realizacji</span>
              <span className={classes.nhStatusValue}>
                {rowData.statusRealizacji || "—"}
              </span>
            </div>

            <div className={classes.nhSummaryWrap}>
              <div className={classes.nhSummaryCol}>
                <div className={classes.nhCard}>
                  <div className={classes.nhCardTitle}>Przyjęcie</div>
                  {[
                    [
                      "Data utworzenia",
                      rowData.utworzono
                        ? moment(rowData.utworzono)
                            .tz("Europe/Warsaw")
                            .format("HH:mm, DD-MM-YYYY")
                        : "",
                    ],
                    [
                      "Przyjazd auta",
                      nhDateTime(rowData.utworzono, rowData.przyjazdAuta),
                    ],
                    ["Numer listu przewozowego", rowData.numerListu],
                    ["Nazwa firmy (nadawca)", rowData.nadawca],
                    [
                      "Start skanowania",
                      nhDateTime(rowData.utworzono, rowData.startSkanowania),
                    ],
                  ].map(([label, value]) => renderNhRow(classes, label, value))}
                </div>

                <div className={classes.nhCard}>
                  <div className={classes.nhCardTitle}>Obsługa</div>
                  {[
                    ["Kierunek", rowData.kierunek],
                    ["Ilość dekl. paczek", rowData.iloscDeklPaczek],
                    ["Ilość dekl. palet", rowData.iloscDeklPalet],
                    ["Ilość fakt. paczek", rowData.iloscFaktPaczek],
                    ["Ilość fakt. palet", rowData.iloscFaktPalet],
                    [
                      "Zakończenie skanowania",
                      formatHHmm(rowData.zakonczenieSkanowania),
                    ],
                    ["Problem z przesyłką", rowData.problemZPrzesylka],
                    ...(rowData.problemZPrzesylka === "Tak" ||
                    rowData.adresatProblemu
                      ? [["Adresat powiadomienia", rowData.adresatProblemu]]
                      : []),
                    ...(rowData.problemZPrzesylka === "Tak" ||
                    rowData.opisProblemu
                      ? [["Opis problemu", rowData.opisProblemu]]
                      : []),
                    ["Towar celny", rowData.towarCelny],
                  ].map(([label, value]) => renderNhRow(classes, label, value))}
                </div>
              </div>

              <div className={classes.nhSummaryCol}>
                {rowData.towarCelny === "Tak" && (
                  <div className={classes.nhCard}>
                    <div className={classes.nhCardTitle}>Odprawa celna</div>
                    {[
                      [
                        "Osoba przygotowująca odprawę",
                        rowData.osobaPrzygotowujacaOdprawe,
                      ],
                      ["MRN", rowData.MRN],
                      ["Ilość pozycji SAD", rowData.iloscPozycjiSAD],
                      ["Rewizja", rowData.Rewizja],
                      ["Serwis lotniczy", rowData.serwisLotniczy],
                    ].map(([label, value]) =>
                      renderNhRow(classes, label, value),
                    )}
                  </div>
                )}

                <div className={classes.nhCard}>
                  <div className={classes.nhCardTitle}>Wydanie towaru</div>
                  {[
                    ["Podjazd auta", rowData.podjazdAuta],
                    ["Godzina wyjazdu auta", rowData.wyjazdAuta],
                  ].map(([label, value]) => renderNhRow(classes, label, value))}
                  {canReleaseNhGoods(rowData) && (
                    <div className={classes.nhReleaseWrap}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={isReleasingNhGoods}
                        onClick={handleNhReleaseGoods}
                      >
                        Przekaż towar do wydania
                      </Button>
                      <div className={classes.nhReleaseHint}>
                        Odprawa celna zamknięta, auto czeka pod magazynem.
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className={classes.nhMeta}>
              Utworzone przez: <strong>{rowData.createdBy || "—"}</strong>
            </div>

            <hr className={classes.wider} />
            {id && rowData && (
              <CommentSection
                id={id}
                rowData={rowData}
                onDataRefresh={handleCommentSectionDataRefresh}
                emailRefreshToken={emailRefreshToken}
              />
            )}
            <hr className={classes.wider} />
            <div>
              <Typography variant="h6" className={classes.komentarzeHeading}>
                Komentarze:
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                className={classes.mailNotificationButton}
                onClick={handleRecordMailNotification}
              >
                Odnotuj powiadomienie mailowe
              </Button>
              {comments.map(renderCommentItem)}
            </div>
          </>
        ) : (
          // Pola dla innych rodzajów transportu
          <>
            <div className={classes.nhStatusBar}>
              <span className={classes.nhStatusLabel}>Status realizacji</span>
              <span className={classes.nhStatusValue}>
                {rowData.statusRealizacji || "—"}
              </span>
            </div>

            <div className={classes.nhSummaryWrap}>
              <div className={classes.nhSummaryCol}>
                <div className={classes.nhCard}>
                  <div className={classes.nhCardTitle}>Zgłoszenie</div>
                  {[
                    ["Rodzaj zgłoszenia", rowData.rodzaj],
                    [
                      "Lista kontrolna",
                      (() => {
                        const listaHandler = importTypes.includes(
                          rowData.rodzaj,
                        )
                          ? handleImportUniwersal
                          : exportTypes.includes(rowData.rodzaj)
                            ? handleEksportUniwersal
                            : rowData.rodzaj === "Tranzyt"
                              ? handleTranzytUniwersal
                              : null;
                        if (!listaHandler) return "";
                        return (
                          <Tooltip
                            title={
                              !rowData.SAD || rowData.plikiBox !== 1 ? (
                                <Typography sx={{ fontSize: "1rem" }}>
                                  Aby aktywować przycisk, upewnij się, że pole
                                  SAD nie jest puste oraz zaznaczony jest
                                  znacznik Pliki do zaczytania.
                                </Typography>
                              ) : (
                                ""
                              )
                            }
                          >
                            <span>
                              <Button
                                onClick={listaHandler}
                                variant="contained"
                                color="primary"
                                size="small"
                                disabled={
                                  !rowData.SAD || rowData.plikiBox !== 1
                                }
                              >
                                Lista
                              </Button>
                            </span>
                          </Tooltip>
                        );
                      })(),
                    ],
                    ["Importer", rowData.importer],
                    ["Eksporter", rowData.eksporter],
                    ["Nr faktury", rowData.nrFaktury],
                    ["Nr tranzytu", rowData.nrTranzytu],
                    [
                      "Data wygaśnięcia T1",
                      rowData.data
                        ? moment(rowData.data)
                            .tz("Europe/Warsaw")
                            .format("DD-MM-YYYY")
                        : "",
                    ],
                    ...(rowData.przelew === 1 && rowData.nota_ksiegowa
                      ? [["Nota księgowa", rowData.nota_ksiegowa]]
                      : []),
                    ...(rowData.dataMailOBrakiBox !== null &&
                    rowData.dataMailOBrakiBox !== undefined
                      ? [
                          [
                            "Data wysłania ponownego maila o braki",
                            moment(rowData.dataMailOBrakiBox)
                              .tz("Europe/Warsaw")
                              .format("DD-MM-YYYY, HH:mm"),
                          ],
                        ]
                      : []),
                  ].map(([label, value]) => renderNhRow(classes, label, value))}
                  {role === "admin" &&
                    rowData.statusRealizacji === "Anulowane" && (
                      <div className={classes.nhReleaseWrap}>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() => handleUpdateClick(id)}
                        >
                          Przywróć odprawę
                        </Button>
                      </div>
                    )}
                  {rowData.statusRealizacji === "Do przygotowania" && (
                    <div className={classes.nhReleaseWrap}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        size="small"
                        onClick={() => setIsSplitModalOpen(true)}
                      >
                        Podziel ticket
                      </Button>
                    </div>
                  )}
                  {isSplitModalOpen && (
                    <SplitTicketModal
                      open={isSplitModalOpen}
                      onClose={() => setIsSplitModalOpen(false)}
                      ticketData={rowData}
                    />
                  )}
                </div>

                <div className={classes.nhCard}>
                  <div className={classes.nhCardTitle}>Osoby</div>
                  {[
                    [
                      "Osoba przygotowująca odprawę",
                      rowData.osobaPrzygotowujacaOdprawe,
                    ],
                    [
                      "Osoba weryfikująca odprawę",
                      rowData.osobaWeryfikujacaOdprawe,
                    ],
                    [
                      "Osoba wysyłająca odprawę",
                      rowData.osobaWysylajacaOdprawe,
                    ],
                    [
                      "Osoba monitorująca odprawę",
                      rowData.osobaMonitorujacaOdprawe,
                    ],
                    ["Osoba, która utworzyła odprawę", rowData.createdBy],
                  ].map(([label, value]) => renderNhRow(classes, label, value))}
                </div>
              </div>

              <div className={classes.nhSummaryCol}>
                <div className={classes.nhCard}>
                  <div className={classes.nhCardTitle}>
                    Transport i lokalizacja
                  </div>
                  {[
                    [
                      "Nr rejestracyjny pojazdu/kuriera",
                      rowData.nrRejestracyjnyPojazdyKurier,
                    ],
                    [
                      rowData.rodzaj === "Tranzyt"
                        ? "Urząd celny wyjścia"
                        : "Lokalizacja towaru",
                      rowData.lokalizacjaTowaru,
                    ],
                    ["Urząd zgłoszenia", rowData.urzadZgloszenia],
                    ["Adresat dokumentów", rowData.adresatDokumentow],
                    ["Email korespondencyjny", rowData.emailKorespondencyjny],
                  ].map(([label, value]) => renderNhRow(classes, label, value))}
                </div>

                <div className={classes.nhCard}>
                  <div className={classes.nhCardTitle}>Dokumentacja</div>
                  {[
                    ["Dokumenty przed przybyciem", rowData.dokPrzedPrzybyciem],
                    ["Nr SAD", rowData.SAD],
                    ["Nr MRN", rowData.MRN],
                    ["Rewizja", rowData.Rewizja],
                    [
                      "Zgłoszenie utworzono dnia",
                      rowData.utworzono
                        ? moment
                            .utc(rowData.utworzono)
                            .format("HH:mm, DD-MM-YYYY")
                        : "",
                    ],
                    [
                      "Zgłoszenie zakończono dnia",
                      rowData.endDate
                        ? moment
                            .utc(rowData.endDate)
                            .format("HH:mm, DD-MM-YYYY")
                        : "",
                    ],
                    [
                      "Ścieżka do plików",
                      rowData.pliki ? (
                        <FolderPathAction
                          nrRef={rowData.nrRef}
                          path={rowData.pliki}
                        />
                      ) : (
                        ""
                      ),
                    ],
                  ].map(([label, value]) => renderNhRow(classes, label, value))}
                  {/* Link do folderu na dysku Sharepoint - ukryty, zostawiony na później.
                  <div className={classes.nhReleaseWrap}>
                    <a
                      className={classes.link}
                      href={
                        rowData.rodzaj === "Import"
                          ? importRodzajURL
                          : eksportRodzajURL
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Otwórz folder na dysku Sharepoint
                    </a>
                  </div>
                  */}
                </div>

                {rowData.rodzaj === "Tranzyt" && (
                  <div className={classes.nhCard}>
                    <div className={classes.nhCardTitle}>
                      Szczegóły finansowe i tranzytu
                    </div>
                    {[
                      ["Nr ref gwaranta", rowData.nr_ref_gwaranta],
                      ["Waluta", rowData.waluta],
                      ["Waga netto", rowData.waga_netto],
                      ["Waga brutto", rowData.waga_brutto],
                      ["Gwarant", rowData.gwarant],
                      [
                        "Przewidywany urząd tranzytowy",
                        rowData.urzad_tranzytowy,
                      ],
                      [
                        "Urząd celny przeznaczenia",
                        rowData.urzad_przeznaczenia,
                      ],
                      ["Nr LRN", rowData.nr_LRN],
                      ["Kwota gwarancji w PLN", rowData.kwota_gwarancji],
                      [
                        "Data zakończenia tranzytu",
                        rowData.data_ie
                          ? moment(rowData.data_ie).format("DD-MM-YYYY")
                          : "",
                      ],
                    ].map(([label, value]) =>
                      renderNhRow(classes, label, value),
                    )}
                  </div>
                )}
              </div>
            </div>

            <hr className={classes.wider} />
            {/* Add other details as needed */}
            {/* Add the CommentSection component to render the comment section */}
            {id && rowData && (
              <CommentSection
                id={id}
                rowData={rowData}
                onDataRefresh={handleCommentSectionDataRefresh}
                emailRefreshToken={emailRefreshToken}
              />
            )}

            <div>
              <EmailSender
                nrRef={nrRef}
                odbiorca={rowData.emailKorespondencyjny}
                rodzaj={rowData.rodzaj}
                importer={rowData.importer}
                eksporter={rowData.eksporter}
                lokalizacjaTowaru={rowData.lokalizacjaTowaru}
              />
            </div>
            <div>
              <Typography variant="h6" className={classes.komentarzeHeading}>
                Komentarze:
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                className={classes.mailNotificationButton}
                onClick={handleRecordMailNotification}
              >
                Odnotuj powiadomienie mailowe
              </Button>
              {comments.map(renderCommentItem)}
            </div>
            {/* <div>
          <Typography variant="h6" className={classeRs.komentarzeHeading}>f
            Konwersja Plików:
          </Typography>
          <FileUpload />
          <AgregateData />
        </div> */}
          </>
        )}
      </main>
      <Dialog
        open={openUrzadZgloszeniaDialog}
        onClose={handleCloseUrzadZgloszeniaDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Uzupełnij wymagane pole</DialogTitle>
        <DialogContent>
          {isUrzadZgloszeniaMissing && (
            <FormControl fullWidth variant="outlined" margin="normal">
              <InputLabel id="urzad-zgloszenia-select-label">
                Urząd zgłoszenia
              </InputLabel>
              <Select
                labelId="urzad-zgloszenia-select-label"
                value={selectedUrzadZgloszenia}
                onChange={(event) =>
                  setSelectedUrzadZgloszenia(event.target.value)
                }
                label="Urząd zgłoszenia"
                MenuProps={{
                  getContentAnchorEl: null,
                }}
              >
                <ListSubheader>
                  <TextField
                    size="small"
                    autoFocus
                    placeholder="Szukaj urzędu..."
                    fullWidth
                    value={urzadSearchTerm}
                    onChange={(event) => setUrzadSearchTerm(event.target.value)}
                    onClick={(event) => event.stopPropagation()}
                    onKeyDown={(event) => event.stopPropagation()}
                  />
                </ListSubheader>
                {filteredUrzadZgloszeniaOptions.map((item) => (
                  <MenuItem key={item.id} value={item.name}>
                    {item.name}
                  </MenuItem>
                ))}
                {filteredUrzadZgloszeniaOptions.length === 0 && (
                  <MenuItem disabled>Brak wyników</MenuItem>
                )}
              </Select>
            </FormControl>
          )}

          {isLokalizacjaTowaruMissing && (
            <FormControl fullWidth variant="outlined" margin="normal">
              <InputLabel id="lokalizacja-towaru-select-label">
                Lokalizacja towaru
              </InputLabel>
              <Select
                labelId="lokalizacja-towaru-select-label"
                value={selectedLokalizacjaTowaruDialog}
                onChange={(event) =>
                  setSelectedLokalizacjaTowaruDialog(event.target.value)
                }
                label="Lokalizacja towaru"
                MenuProps={{
                  getContentAnchorEl: null,
                }}
              >
                <ListSubheader>
                  <TextField
                    size="small"
                    autoFocus={!isUrzadZgloszeniaMissing}
                    placeholder="Szukaj lokalizacji..."
                    fullWidth
                    value={lokalizacjaSearchTerm}
                    onChange={(event) =>
                      setLokalizacjaSearchTerm(event.target.value)
                    }
                    onClick={(event) => event.stopPropagation()}
                    onKeyDown={(event) => event.stopPropagation()}
                  />
                </ListSubheader>
                {filteredLokalizacjaOptions.map((item) => (
                  <MenuItem key={item.id} value={item.name}>
                    {item.name}
                  </MenuItem>
                ))}
                {filteredLokalizacjaOptions.length === 0 && (
                  <MenuItem disabled>Brak wyników</MenuItem>
                )}
              </Select>
            </FormControl>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseUrzadZgloszeniaDialog} color="primary">
            Anuluj
          </Button>
          <Button
            onClick={handleConfirmUrzadZgloszeniaDialog}
            color="primary"
            variant="contained"
            disabled={
              (isUrzadZgloszeniaMissing && !selectedUrzadZgloszenia.trim()) ||
              (isLokalizacjaTowaruMissing &&
                !selectedLokalizacjaTowaruDialog.trim())
            }
          >
            Zatwierdź i zapisz
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isMailNotificationDialogOpen}
        onClose={handleCloseMailNotificationDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Odnotuj powiadomienie mailowe</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            label="Treść maila"
            required
            fullWidth
            multiline
            minRows={5}
            margin="normal"
            variant="outlined"
            value={mailNotificationText}
            onChange={(event) => setMailNotificationText(event.target.value)}
          />
          <FormControl component="fieldset" margin="normal">
            <FormLabel component="legend">Kierunek maila</FormLabel>
            <RadioGroup
              row
              value={mailNotificationDirection}
              onChange={(event) =>
                setMailNotificationDirection(event.target.value)
              }
            >
              <FormControlLabel
                value="przychodzacy"
                control={<Radio />}
                label="Mail przychodzący"
              />
              <FormControlLabel
                value="wychodzacy"
                control={<Radio />}
                label="Mail wychodzący"
              />
            </RadioGroup>
          </FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={mailNotificationArchiveConfirmed}
                onChange={(event) =>
                  setMailNotificationArchiveConfirmed(event.target.checked)
                }
              />
            }
            label="Pamiętaj o archiwizacji maila w katalogu do plików"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMailNotificationDialog} color="primary">
            Anuluj
          </Button>
          <Button
            onClick={handleSaveMailNotification}
            color="primary"
            variant="contained"
            disabled={
              !mailNotificationText.trim() ||
              (mailNotificationDirection === "przychodzacy" &&
                !mailNotificationArchiveConfirmed)
            }
          >
            Zapisz
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DetailPage;
